import React, { useEffect, useRef, useState } from "react";
import DeviceContext from "../../Services/identifyDevice";
import "../../UI/DocumentBrowse/DocumentBrowse.scss";

import Button, {
  SubmitButton,
  TransparentButton,
} from "../../UI/Button/Button";
import "./DocVerificationForm.scss";
import watsAppIcon from "../../../assets/icons/watsapp.png";
import watsIcon from "../../../assets/icons/Whatsapp_blue.png";
import uploadIcon from "../../../assets/icons/Upload _Blue.png";

import {
  containerUrl,
  photographCategoryId,
  signatureCategoryId,
  statusUrl,
} from "../../utils/constants";
import {
  AGetDocumentList,
  AGetPendingDocument,
  AGetUploadedDocument,
  AGetDocStatus,
  ADownloadDocument,
  ASaveDocumentDetails,
  AextractPan,
  AextractCheque,
  AextractAadhaar,
  AextractPassport,
  AextractVoterid,
  AextractDl,
  Afacecompare,
  AgetPdf,
  AcreateApplicationTicket,
  AmaskAadhaar,
  AgetDocumentAutoQcDetails,
  AextractBankStatement,
  ACheckLocation,
  ACheckPhotoLiveness,
  QCServiceTaskCreation,
} from "../../Services/dashboard/docVerificationAPIServices";
import DocumentBrowse, {
  DocDetailFormat,
} from "../../UI/DocumentBrowse/DocumentBrowse";
import Toggle from "../../UI/Toggle/Toggle";
import DropdownSearch from "../../UI/DropdownSearch/DropdownSearch";
import GlobalStore from "../../store/globalStore";
import { AUploadDocument } from "../../Services/dashboard/brokerageServices";
import ErrMsg from "../../UI/ErrMsg/ErrMsg";
import {
  aadhaarDocumnetId,
  firstChequeDocumnetId,
  secondChequeDocumnetId,
  thirdChequeDocumnetId,
  fourthChequeDocumnetId,
  fifthChequeDocumnetId,
  firstBankStatementDocumnetId,
  secondBankStatementDocumnetId,
  thirdBankStatementDocumnetId,
  fourthBankStatementDocumnetId,
  fifthBankStatementDocumnetId,
  DIY,
  dlDocumentId,
  panDocumentId,
  passportDocumnetId,
  voterIdDocumentId,
  dashboardUrl,
  corrAadhaarDocumnetId,
  corrPassportDocumnetId,
  corrVoterIdDocumentId,
  corrDlDocumentId,
  watsappNo,
  geoLocationConfig,
  photographId,
  DocumentCategoryIdForphotographId,
  signatureDocumentId,
  ipvNavBarObj,
} from "../../utils/constants";
import {
  completeModuleStatus,
  utmDurationInfoObj,
  incompleteStageNavigation,
} from "../../Services/globalService";
import { AGetStageCompletionStatus } from "../../Services/registration/continueApiService";
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import gtmService from "../../Services/gtmService";
import mixpanelService from "../../Services/mixpanelService";
import mixpanelEvents, { getScreenName } from "../../../config/mixpanelEvents";
import cleverTapEvents from "../../../config/cleverTapEvents";
import { ClevertapService } from "../../Services/clevertapService";
import Backdrop from "../../UI/Backdrop/Backdrop";
import isSeeding from "../../../assets/icons/seeding.png";
import { AgetBeneficiaryName } from "../../Services/dashboard/bankApiServices";
import EdelLogoCenter from "../../UI/EdelLogoCenter/EdelLogoCenter";
import {
  AGetPanUtiData,
  APanLinkedWithAadhar,
} from "../../Services/registration/panDobApiService";
import { AppsFlyerService } from "../../Services/appsFlyerService";
import appsFlyerEvents from "../../../config/appsFlyerEvents";
import { error } from "console";
import { ASaveIPVerificationDetails, ASendSmsV2 } from "../../Services/dashboard/ipvApiServices";
import useGeoLocation from "../../../customHooks/useGeoLocation";
import { errorMessage } from "../../utils/errorMessage";
import InfoModal from "../../UI/InfoModal/InfoModal";
import moment from "moment";
import nomineeDocsIds from "../../../config/nomineeDocsId";

//import SignatureCanvas from "react-signature-canvas";
import prevIcon from "../../../assets/icons/eye.png";
import cropIcon from "../../../assets/icons/crop.png";
import NewSelfie from "../../Selfie/NewSelfie";
import {
  checkESignSubmitted,
  disabledUploadForEsign,
} from "../../utils/eSignSubmitHandler";
import { decryptJwtToken } from "../../Services/dashboard/encryptionNew";
import { ITokenObj } from "../../types/genericTypes";
import { errorCode } from "../../../ErrorCode/ErrorCode";
import ViewSignatureSamplePopup from "./ViewSignatureSamplePopup";
import ViewSignatureSamplePopupMobileView from "./ViewSignatureSamplePopupMobileView";
import ViewPhotoSamplePopup from "./ViewPhotoSamplePopup";
import ViewPhotoSampleMobileViewProps from "./ViewPhotoSampleMobileView";
import SampleAadharPopup from "../../Registration/SampleFolderPopups/SampleAadharPopup";
import SampleDrivingLicensePopup from "../../Registration/SampleFolderPopups/SampleDrivingLicense";
import SampleVoterIDPopup from "../../Registration/SampleFolderPopups/SampleVoterIdPopup";
import SamplePassportPopup from "../../Registration/SampleFolderPopups/SamplePassportPopup";
import SampleAadharMobileViewProps from "../../Registration/SampleFolderPopups/SampleAadharPopupMobileView";
import SampleSDLMobileViewProps from "../../Registration/SampleFolderPopups/SampleDLMobile";
import SampleVoterIDMobileViewProps from "../../Registration/SampleFolderPopups/SampleVoterIDMobile";
import SamplePassportMobileViewProps from "../../Registration/SampleFolderPopups/SamplePassportMobile";
import config from "../../../config/domain";
import SignCheck from "../../Selfie/Signature/SignCheck";
export interface DocVerifcationFormProps {
  UTM_SOURCE: string;
  UTM_MEDIUM?: string;
  UTM_CAMPAIGN?: string;
}

export interface iGeoLocation {
  loaded: boolean;
  coordinates: { lat: string; lng: string };
  error: boolean;
}

export interface uploadDocObj {
  applicationid: string;
  base64document: string;
  filename: string;
  panNo: string;
  ModifiedBy?: string | number
}

export const initialDocObj: DocDetailFormat = {
  id: "",
  disable: true,
  uploadPer: 0,
  hideProgress: false,
  fileName: "",
  showFile: true,
  imgUrl: "",
  documentcategory: "",
  documentCategoryId: "",
  documentId: 0,
  mimeType: "",
  base64: "",
  isWatsappFlag: false,
};
export const initialPhotoDocObj: DocDetailFormat = {
  id: "",
  disable: false,
  uploadPer: 0,
  hideProgress: false,
  fileName: "",
  showFile: true,
  imgUrl: "",
  documentcategory: "",
  documentCategoryId: "",
  documentId: 0,
  mimeType: "",
  base64: "",
  isWatsappFlag: false,
};
export const initialPanDocObj: DocDetailFormat = {
  id: "",
  disable: false,
  uploadPer: 0,
  hideProgress: true,
  fileName: "",
  showFile: true,
  imgUrl: "",
  documentcategory: "",
  documentCategoryId: "",
  documentId: 0,
  mimeType: "",
  base64: "",
  iscropped: false,
  isWatsappFlag: false,
};

const DocVerifcationFormJoint: React.FC<DocVerifcationFormProps> = (props) => {
  // const history = useHistory();
  const navigate = useNavigate()
  let userId = "0";
  const tokenObj: string = decryptJwtToken(GlobalStore?.token);
  if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
    let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
    userId = tokenMainObj?.UserId?.toString();
  }
  const showPhotographBrowseOption = () => {
    if (
      userId !== "0" &&
      (GlobalStore?.isNormalClient ||
        (GlobalStore?.isDigiLocker == false && GlobalStore?.isKRA == false)) &&
      GlobalStore?.stageStatus?.accountcategory == 2
    ) {
      return true;
    }
    return false;
  };
  const [captureSigPad, setCaptureSigPad] = React.useState<boolean>(false);
  let sigPad: any = {};
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [startTime, setStartTime] = React.useState<Date>(new Date());
  const [renderSamplePopups, setRenderSamplePopup] =
    React.useState<boolean>(false);
  const [renderCorrSamplePopups, setRenderCorrSamplePopup] =
    React.useState<boolean>(false);
  const [uploadDocFlag, setUploadDocFlag] = useState<boolean>(false);
  const [uploadVaiWatsAppFlag, setUploadViaWatsAppFlag] =
    useState<boolean>(false);
  const [togPAN, setTogPAN] = useState<boolean>(false);
  const [togFirstBank, setTogFirstBank] = useState<boolean>(false);
  const [togSecondBank, setTogSecondBank] = useState<boolean>(false);
  const [togThirdBank, setTogThirdBank] = useState<boolean>(false);
  const [togFourthBank, setTogFourthBank] = useState<boolean>(false);
  const [togFifthBank, setTogFifthBank] = useState<boolean>(false);

  const [togPermAdd, setTogPermAdd] = useState<boolean>(false);
  const [togCorrAdd, setTogCorrAdd] = useState<boolean>(false);
  const [togSig, setTogSig] = useState<boolean>(false);
  const [togIncome, setTogIncome] = useState<boolean>(false);
  const [firstBankList, setFirstBankList] = useState<any>([]);
  const [secondBankList, setSecondBankList] = useState<any>([]);
  const [thirdBankList, setThirdBankList] = useState<any>([]);
  const [fourthBankList, setFourthBankList] = useState<any>([]);
  const [fifthBankList, setFifthBankList] = useState<any>([]);
  const [permAddList, setPermAddList] = useState<any>([]);
  const [corrAddList, setCorrAddList] = useState<any>([]);
  const [incomeList, setIncomeList] = useState<any>([]);
  const [secondDoc, setSecondDoc] = useState<boolean>(false);
  const [corrSecondDoc, setCorrSecondDoc] = useState<boolean>(false);
  const [pendingDocObj, setPendingDocObj] = useState<any>();
  const [photoObj, setPhotoObj] = useState<DocDetailFormat>(
    showPhotographBrowseOption()
      ? { ...initialPhotoDocObj }
      : {
        ...initialDocObj,
      }
  );
  const [panObj, setPanObj] = useState<DocDetailFormat>({
    ...JSON.parse(JSON.stringify(initialPanDocObj)),
  });
  const [firstBankObj, setFirstBankObj] = useState<DocDetailFormat>({
    ...initialDocObj,
  });
  const [secondBankObj, setSecondBankObj] = useState<DocDetailFormat>({
    ...initialDocObj,
  });
  const [thirdBankObj, setThirdBankObj] = useState<DocDetailFormat>({
    ...initialDocObj,
  });
  const [fourthBankObj, setFourthBankObj] = useState<DocDetailFormat>({
    ...initialDocObj,
  });
  const [fifthBankObj, setFifthBankObj] = useState<DocDetailFormat>({
    ...initialDocObj,
  });

  const [permSecondAddressObj, setPermSecondAddressObj] =
    useState<DocDetailFormat>({ ...initialPanDocObj });
  const [corrSecondAddressObj, setCorrSecondAddressObj] =
    useState<DocDetailFormat>({ ...initialPanDocObj });
  const [permAddressObj, setPermAddressObj] = useState<DocDetailFormat>({
    ...initialDocObj,
  });
  const [corrAddressObj, setCorrAddressObj] = useState<DocDetailFormat>({
    ...initialDocObj,
  });
  const [signatureObj, setSignatureObj] = useState<DocDetailFormat>({
    ...initialPanDocObj,
  });
  const [signaturesArr, setSignaturesArr] = useState<Array<DocDetailFormat>>([]);
  const [signatureObjSecond, setSignatureObjSecond] = useState<DocDetailFormat>({
    ...initialPanDocObj,
  });
  const [incomeObj, setIncomeObj] = useState<DocDetailFormat>({
    ...initialDocObj,
  });
  const [defaultAddress, setDefaultAddress] = useState<string>("");
  const [defaultCorrAddress, setDefaultCorrAddress] = useState<string>("");
  const [defaultFirstBankDoc, setDefaultFirstBankDoc] = useState<string>("");
  const [defaultSecondBankDoc, setDefaultSecondBankDoc] = useState<string>("");
  const [defaultThirdBankDoc, setDefaultThirdBankDoc] = useState<string>("");
  const [defaultFourthBankDoc, setDefaultFourthBankDoc] = useState<string>("");
  const [defaultFifthBankDoc, setDefaultFifthBankDoc] = useState<string>("");
  const [defaultIncomeDoc, setDefaultIncomeDoc] = useState<string>("");
  const [errCode, setErrCode] = React.useState<number | string>("");
  const [showRetake, setShowRetake] = useState<boolean>(false);
  const videoRefElement = React.useRef<HTMLVideoElement>(null);
  const canvasRefElement = React.useRef<HTMLCanvasElement>(null);
  const uploadedPhotoRefElement = React.useRef<HTMLTableSectionElement>(null);
  const [mediaRecorder, setMediaRecorder] = React.useState<MediaRecorder>();
  const [turnOfCamera, setTurnOfCamera] = React.useState<MediaStream>();
  const [showVidPerm, setShowVidPerm] = React.useState<boolean>(false);
  const [showSignaturePopup, setShowSignaturePopup] =
    React.useState<boolean>(false);
  const [showPhotoPopup, setShowPhotoPopup] = React.useState<boolean>(false);
  const [showSignatureMobilePopup, setShowSignatureMobilePopup] =
    React.useState<boolean>(false);
  const [showPhotoMobilePopup, setShowPhotoMobilePopup] =
    React.useState<boolean>(false);
  const [autoQc, setAutoQc] = React.useState<boolean>(false);
  const [photoBase64, setPhotoBase64] = React.useState<string>("");
  const [panBase64, setPanBase64] = React.useState<string>("");
  const [bankStage, setBankStage] = React.useState<boolean>(false);
  const [anotherFile, setAnotherFile] = React.useState<boolean>(false);
  const [corrAnotherFile, setCorrAnotherFile] = React.useState<boolean>(false);
  const [panName, setPanName] = React.useState<string>("");
  const [firstBankName, setFirstBankName] = React.useState<string>("");
  const [secondBankName, setSecondBankName] = React.useState<string>("");
  const [thirdBankName, setThirdBankName] = React.useState<string>("");
  const [fourthBankName, setFourthBankName] = React.useState<string>("");
  const [fifthBankName, setFifthBankName] = React.useState<string>("");

  const [firstBankDetails, setFirstBankDetails] = React.useState<any>("");
  const [secondBankDetails, setSecondBankDetails] = React.useState<any>("");
  const [thirdBankDetails, setThirdBankDetails] = React.useState<any>("");
  const [fourthBankDetails, setFourthBankDetails] = React.useState<any>("");
  const [fifthBankDetails, setFifthBankDetails] = React.useState<any>("");

  const [addressName, setAddressName] = React.useState<string>("");
  const [corrAddressName, setCorrAddressName] = React.useState<string>("");
  const [signatureName, setSignatureName] = React.useState<string>("");
  const [incomeName, setIncomeName] = React.useState<string>("");
  const [isPhotoPendingFlag, setIsPhotoPendingFlag] =
    React.useState<boolean>(false);

  const [isNewPhoto, setIsNewPhoto] = useState<boolean>(false);
  const [isNewPan, setIsNewPan] = useState<boolean>(false);
  const [isNewFirstBank, setIsNewFirstBank] = useState<boolean>(false);
  const [isNewSecondBank, setIsNewSecondBank] = useState<boolean>(false);
  const [isNewThirdBank, setIsNewThirdBank] = useState<boolean>(false);
  const [isNewFourthBank, setIsNewFourthBank] = useState<boolean>(false);
  const [isNewFifthBank, setIsNewFifthBank] = useState<boolean>(false);

  const [isNewPermAddress, setIsNewPermAddress] = useState<boolean>(false);
  const [isNewCorrAddress, setIsNewCorrAddress] = useState<boolean>(false);
  const [isNewSignature, setIsNewSignature] = useState<boolean>(false);
  const [isNewIncome, setIsNewIncome] = useState<boolean>(false);
  const [loaderSign, setLoaderSign] = React.useState<boolean>(false);
  const [showCorr, setShowCorr] = React.useState<boolean>(false);
  const [isPanAndDobMatch, setIsPanAndDobMatch] = useState<boolean>(true);
  const [seedingPopup, setSeedingPopup] = React.useState<boolean>(
    !GlobalStore.isSeeding
  );
  const [regectedDocStatus, setRegectedDocStatus] = React.useState<
    Array<object>
  >([{}]);
  const [aadharAddress, setAadharAddress] = React.useState<boolean>(true);
  const [corrAadharAddress, setCorrAadharAddress] =
    React.useState<boolean>(true);
  const [location, setLocation] = useState<any>("");
  const geoLoc: iGeoLocation = useGeoLocation();
  const [isGeoError, setIsGeoError] = React.useState<boolean>(false);
  const [isGeoErrorTimeFlag, setIsGeoErrorTimeFlag] =
    React.useState<boolean>(false);

  const [removePanImg, setRemovePanImg] = React.useState<boolean>(false);
  const [isManual, setIsManual] = React.useState<boolean>(false);

  let watchPositionId: number;

  //File specific error msg state

  const [panCardError, setPanCardError] = useState<any>("");
  const [firstBankListError, setFirstBankListError] = useState<any>("");
  const [secondBankListError, setSecondBankListError] = useState<any>("");
  const [thirdBankListError, setThirdBankListError] = useState<any>("");
  const [fourthBankListError, setFourthBankListError] = useState<any>("");
  const [fifthBankListError, setFifthBankListError] = useState<any>("");
  const [permAddListError, setPermAddListError] = useState<any>("");
  const [corrAddListError, setCorrAddListError] = useState<any>("");
  const [incomeListError, setIncomeListError] = useState<any>("");
  const [secondDocError, setSecondDocError] = useState<any>("");
  const [corrSecondDocError, setCorrSecondDocError] = useState<any>("");
  const [signatureListError, setSignatureListError] = useState<any>("");
  const [signatureArrError, setSignatureArrError] = useState<any>([]);
  const [showBrowserPermissionModal, setsShowBrowserPermissionModal] =
    useState<boolean>(false);
  const [isSdkSelfie, setIsSdkSelfie] = useState<boolean>(true);
  const [browserPermission, setBrowserPermission] = useState<boolean>(true);
  const [locationPermission, setLocationPermission] = useState<boolean>(true);
  const [cameraPermission, setCameraPermission] = useState<boolean>(true);
  // To check if a default permanent address is available for the application
  const [defaultPermAddressProof, setDefaultPermAddressProof] = useState(false);
  //permAddButDisable
  const [showSignatureTwoPopup, setShowSignatureTwoPopup] =
    React.useState<boolean>(false);
  const [nomineeFirstObj, setNomineeFirstObj] = useState<DocDetailFormat[]>([
    {
      ...initialDocObj,
      disable: false,
    },
    { ...initialDocObj, disable: false },
  ]);
  const [nomineeSecondObj, setNomineeSecondObj] = useState<DocDetailFormat[]>([
    {
      ...initialDocObj,
      disable: false,
    },
    { ...initialDocObj, disable: false },
  ]);
  const [nomineeThirdObj, setNomineeThirdObj] = useState<DocDetailFormat[]>([
    {
      ...initialDocObj,
      disable: false,
    },
    { ...initialDocObj, disable: false },
  ]);
  const [guardianFirstObj, setGuardianFirstObj] = useState<DocDetailFormat[]>([
    {
      ...initialDocObj,
      disable: false,
    },
    { ...initialDocObj, disable: false },
  ]);
  const [guardianSecondObj, setGuardianSecondObj] = useState<DocDetailFormat[]>(
    [
      {
        ...initialDocObj,
        disable: false,
      },
      { ...initialDocObj, disable: false },
    ]
  );
  const [guardianThirdObj, setGuardianThirdObj] = useState<DocDetailFormat[]>([
    {
      ...initialDocObj,
      disable: false,
    },
    { ...initialDocObj, disable: false },
  ]);
  const [nomineeFirstList, setNomineeFirstList] = useState([]);
  const [nomineeSecondList, setNomineeSecondList] = useState([]);
  const [nomineeThirdList, setNomineeThirdList] = useState([]);
  const [guardianFirstList, setGuardianFirstList] = useState([]);
  const [guardianSecondList, setGuardianSecondList] = useState([]);
  const [guardianThirdList, setGuardianThirdList] = useState([]);
  const [nomineeGuardianTog, setNomineeGuardianTog] = useState({
    nomineeFirst: false,
    nomineeSecond: false,
    nomineeThree: false,
    guardianFirst: false,
    guardianSecond: false,
    guardianThird: false,
  });
  const [nomineeGuardianError, setNomineeGuardianError] = useState({
    nomFirstPhotoId: "",
    nomFirstSignature: "",
    nomSecondPhotoId: "",
    nomSecondSignature: "",
    nomThirdPhotoId: "",
    nomThirdSignature: "",
    guardianFirstPhotoId: "",
    guardianFirstSignature: "",
    guardianSecondPhotoId: "",
    guardianSecondSignature: "",
    guardianThirdPhotoId: "",
    guardianThirdSignature: "",
  });

  const [isNomineeGuardian, setIsNomineeGuardian] = useState({
    isNomFirstPhoto: false,
    isNomFirstSignature: false,
    isNomSecondPhoto: false,
    isNomSecondSignature: false,
    isNomThirdPhoto: false,
    isNomThirdSignature: false,
    isGuardianFirstPhoto: false,
    isGuardianFirstSignature: false,
    isGuardianSecondPhoto: false,
    isGuardianSecondSignature: false,
    isGuardianThirdPhoto: false,
    isGuardianThirdSignature: false,
  });

  const [nomineeDisable, setNomineeDisable] = useState(false);
  const [guardianDisable, setGuardianDisable] = useState(false);

  //permAddButDisable
  const [panCardImageFound, setPanCardImageFound] = useState(true);
  const [permAddButDisable, setPermAddButDisable] = useState(false);
  const [panButDisable, setPanButDisable] = useState(false);
  const [liveLocationCheck, setLiveLocationCheck] = useState<any>({
    checkPhotoLiveness: false,
    checkLocation: false,
  });
  const [photoErrorMsg, setPhotoErrorMsg] = React.useState("");
  const [clientStageDetails, setClientStageDetails] = React.useState<any>();

  const [blockAadhar, setBlockAadhar] = React.useState(false);
  const [checkLocationCalled, setCheckLocationCalled] = React.useState<boolean>(false);
  const [sendSmsLinkModal, setSendSmsLinkModal] = React.useState<boolean>(false);
  const [showRemovePopup, setShowRemovePopup] = React.useState<boolean>(false);
  const [sendSmsLinkError, setSendSmsLinkError] = React.useState<string>("");
  const [timer, setTimer] = useState(0);
  const [status, setStatus] = useState("send");
  const [signatureOption, setSignatureOption] = useState("upload");
  const [showSignCheck, setShowSignCheck] = useState(false);
  const [sdkResult, setSdkResult] = useState<any>(null);
  const [sdkError, setSdkError] = useState<any>(null);

  const handleCaptureSignature = () => {
    setShowSignCheck(true);
  };

  const intervalRef = useRef<any>(null);

  const [ShowCanvas, setShowCanvas] = useState(true);
  const shouldDisable = () => {
    let disabled: boolean = false;
    if (
      GlobalStore?.stageStatus?.first_esign_initiated !== null &&
      GlobalStore?.stageStatus?.first_esign_initiated !== undefined &&
      GlobalStore?.stageStatus?.first_esign_initiated
    ) {
      disabled = true;
    }
    return disabled;
  };
  let isPanLinkedToAadhar: boolean;

  React.useEffect(() => {
    // window.scrollTo(0, 0);
    // if (GlobalStore?.isKRA && GlobalStore?.stageStatus?.accountcategory == 2) {
    //   setCameraPermission(false);
    // }
    // if (GlobalStore.location) {
    //   setLocation(GlobalStore.location);
    // } else if (GlobalStore?.stageStatus?.accountcategory !== 2) {
    //   setTimeout(() => {
    //     navigator.geolocation.getCurrentPosition(saveLocation, errorLocation, {
    //       enableHighAccuracy: geoLocationConfig.enableHighAccuracy,
    //       maximumAge: geoLocationConfig.maximumAge,
    //       timeout: geoLocationConfig.timeout,
    //     });
    //     setIsGeoErrorTimeFlag(true);
    //   }, geoLocationConfig.errorTimer);
    // }

    // setIsLoading(true);
    AGetStageCompletionStatus(getClientStageDetails, GlobalStore.applicationID);
    // if kra Client to hide address logic
    const clientPartialDetails_ao = JSON.parse(
      window.localStorage.getItem("clientPartialDetails_ao") || "{}"
    );
    GlobalStore.isKRA || clientPartialDetails_ao.isKRA
      ? setBlockAadhar(true)
      : setBlockAadhar(false);

    // turnOnCamera();
    // showPhotoPreview(false);
    if (
      GlobalStore?.isKRA &&
      GlobalStore?.stageStatus?.accountcategory == 2 &&
      uploadedPhotoRefElement !== null &&
      uploadedPhotoRefElement.current !== null
    )
      uploadedPhotoRefElement.current!.hidden = true;
  }, []);
  React.useEffect(() => {
    if (
      panBase64 !== null &&
      panBase64 !== undefined &&
      panBase64 !== "" &&
      (panObj?.imgUrl == "" ||
        panObj?.imgUrl == undefined ||
        panObj?.imgUrl == null)
    ) {
      setPanObj((panObj) => {
        panObj.imgUrl = getbase64(panBase64, panObj);
        return panObj;
      });
    }
  }, [panBase64]);
  React.useEffect(() => {
    if (location && !checkLocationCalled && !isSdkSelfie) {
      GlobalStore.location = location;
      setIsGeoError(false);
      setIsGeoErrorTimeFlag(false);
      // const locationString;
      const locationObj = {
        lat: location.lat,
        lng: location.long,
      };
      ACheckLocation((res: any) => checkLocationRes(res), locationObj);
    }
  }, [location]);

  React.useEffect(() => {
    if (nomineeFirstList.length > 0) {
      let nomineeOne = [...nomineeFirstObj];
      for (let i = 0; i < nomineeOne.length; i++) {
        if (nomineeOne[i].imgUrl === "" || nomineeOne[i].fileName === "") {
          setNomineeDisable(true);
          break;
        } else {
          setNomineeDisable(false);
        }
      }
    }

    if (nomineeSecondList.length > 0) {
      let nomineeTwo = [...nomineeSecondObj];
      for (let i = 0; i < nomineeTwo.length; i++) {
        if (nomineeTwo[i].imgUrl === "" || nomineeTwo[i].fileName === "") {
          setNomineeDisable(true);
          break;
        } else {
          setNomineeDisable(false);
        }
      }
    }
    if (nomineeThirdList.length > 0) {
      let nomineeThree = [...nomineeThirdObj];
      for (let i = 0; i < nomineeThree.length; i++) {
        if (nomineeThree[i].imgUrl === "" || nomineeThree[i].fileName === "") {
          setNomineeDisable(true);
          break;
        } else {
          setNomineeDisable(false);
        }
      }
    }

    if (guardianFirstList.length > 0) {
      let guardianOne = [...guardianFirstObj];
      for (let i = 0; i < guardianOne.length; i++) {
        if (guardianOne[i].imgUrl === "" || guardianOne[i].fileName === "") {
          setGuardianDisable(true);
          break;
        } else {
          setGuardianDisable(false);
        }
      }
    }
    if (guardianSecondList.length > 0) {
      let guardianTwo = [...guardianSecondObj];
      for (let i = 0; i < guardianTwo.length; i++) {
        if (guardianTwo[i].imgUrl === "" || guardianTwo[i].fileName === "") {
          setGuardianDisable(true);
          break;
        } else {
          setGuardianDisable(false);
        }
      }
    }
    if (guardianThirdList.length > 0) {
      let guardianThree = [...guardianThirdObj];
      for (let i = 0; i < guardianThree.length; i++) {
        if (
          guardianThree[i].imgUrl === "" ||
          guardianThree[i].fileName === ""
        ) {
          setGuardianDisable(true);
          break;
        } else {
          setGuardianDisable(false);
        }
      }
    }
  }, [
    nomineeFirstList,
    nomineeSecondList,
    nomineeThirdList,
    guardianFirstList,
    guardianSecondList,
    guardianThirdList,
    nomineeFirstObj,
    nomineeSecondObj,
    nomineeThirdObj,
    guardianFirstObj,
    guardianSecondObj,
    guardianThirdObj,
  ]);

  // React.useEffect(() => {
  //   if (!isSdkSelfie) {
  //     watchPositionId = navigator.geolocation.watchPosition(
  //       successPosition,
  //       errorPosition
  //     );
  //     if (locationPermission === true && cameraPermission === true) {
  //       setBrowserPermission(true);
  //       setsShowBrowserPermissionModal(false);
  //       setIsGeoError(false);
  //     } else {
  //       setBrowserPermission(false);
  //       setsShowBrowserPermissionModal(true);
  //       setIsGeoError(true);
  //     }
  //   }
  //   getLocation();
  // }, [geoLoc, locationPermission, cameraPermission, isSdkSelfie]);

  React.useEffect(() => {
    if (photoObj.imgUrl && !isSdkSelfie) {
      ACheckPhotoLiveness(
        (res: any) => getExtractPhotoLiveness(res),
        photoObj.imgUrl.split(",")[1],
        GlobalStore.leadId
      );
    }
  }, [photoObj, isSdkSelfie]);

  React.useEffect(() => {
    return () => {
      turnOfCamera && turnOfCamera.getVideoTracks()[0].stop();
    };
  }, [turnOfCamera]);

  // const getLocation = () => {
  //   if (geoLoc.loaded && geoLoc.error == false) {
  //     setLocation({
  //       lat: geoLoc.coordinates.lat,
  //       long: geoLoc.coordinates.lng,
  //     });
  //   } else if (GlobalStore?.stageStatus?.accountcategory !== 2) {
  //     if (navigator && navigator.geolocation) {
  //       navigator.geolocation.getCurrentPosition(saveLocation, errorLocation, {
  //         enableHighAccuracy: geoLocationConfig.enableHighAccuracy,
  //         maximumAge: geoLocationConfig.maximumAge,
  //         timeout: geoLocationConfig.timeout,
  //       });
  //       navigator.geolocation.getCurrentPosition(saveLocation);
  //       watchPositionId = navigator.geolocation.watchPosition(
  //         successPosition,
  //         errorPosition
  //       );
  //     } else {
  //       alert("Geo location is not supported by this browser");
  //     }
  //   }
  // };

  const errorLocation = (err: any) => {
    if (!location && !GlobalStore.location) {
      geoLoc.error = true;
      // setIsLoading(true);
      // setIsGeoError(true);
      // getLocation()
    }
  };

  // const saveLocation = (position: { coords: any }) => {
  //   watchPositionId = navigator.geolocation.watchPosition(
  //     successPosition,
  //     errorPosition
  //   );
  //   // setLocation(`${position.coords.latitude}, ${position.coords.longitude}`);
  //   setLocation({
  //     lat: position.coords.latitude,
  //     long: position.coords.longitude,
  //   });
  //   GlobalStore.location = {
  //     lat: position.coords.latitude,
  //     long: position.coords.longitude,
  //   };
  //   geoLoc.coordinates.lat = position.coords.latitude;
  //   geoLoc.coordinates.lng = position.coords.longitude;
  //   geoLoc.error = false;
  //   setIsGeoError(false);
  //   setIsGeoErrorTimeFlag(false);
  //   setIsLoading(false);
  //   // GlobalStore.location = location;
  // };

  // function successPosition(data: any) {
  //   setIsLoading(false);
  //   setLocationPermission(true);
  //   // setBrowserPermission(true);
  //   // setsShowBrowserPermissionModal(false);
  //   // setLocation(`${data.coords.latitude}, ${data.coords.longitude}`);
  //   setLocation({
  //     lat: data.coords.latitude,
  //     long: data.coords.longitude,
  //   });
  //   navigator.geolocation.clearWatch(watchPositionId);
  //   // GlobalStore.location = location;
  // }

  function errorPosition(data: any) {
    setIsLoading(true);
    setLocationPermission(false);
  }
  const checkLocationRes = (res: any) => {
    if (!res || res.error) {
      if (errCode !== res.error) setErrCode(errCode ? errCode : "" + res.error);
      setIsLoading(false);
      setLiveLocationCheck({
        ...liveLocationCheck,
        checkLocation: true,
      });
      gtmService({ action: "CheckLocation", label: "ERROR || ERR999" });
    } else {
      setCheckLocationCalled(true);
      if (res.data && res.data.LocationInIndia) {
        setLiveLocationCheck({
          ...liveLocationCheck,
          checkLocation: false,
        });
      } else if (!res.data.LocationInIndia) {
        setLiveLocationCheck({
          ...liveLocationCheck,
          checkLocation: true,
        });
        if (errCode !== res.data.Message)
          setErrCode(errCode ? errCode : "" + res.data.Message);
      }
      setIsLoading(false);
    }
  };
  function getClientStageDetails(res: any) {
    if (!res || res.error) {
      //   setErrCode("106- Failed to fetch stage completion data.");
      setErrCode(errCode + res.error);
      gtmService({
        action: "GetStageCompletionStatus",
        label: "ERROR || ERR141",
      });
    } else {
      if (res.data) {
        const responseObj = JSON.parse(res.data);
        if (responseObj?.elog_opted) {
          setSignatureOption("elog")
          setTimeout(() => {
            let signatureCopy = { ...initialPanDocObj };
            signatureCopy.documentcategory = "Signature";
            signatureCopy.documentCategoryId = "27";
            signatureCopy.documentId = 305;
            signatureCopy.isElogSignOpted = true;
            signatureCopy.imgUrl = "";
            setSignatureObj(signatureCopy);
          }, 1000);
        }
        setClientStageDetails(responseObj)
        if (GlobalStore.isKRA || responseObj.iskra) {
          permAddressObj.disable = true;
          setPermAddressObj(permAddressObj);
          setBlockAadhar(true);
        } else {
          setBlockAadhar(false);
        }
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        clientPartialDetails_ao.isKYC = responseObj.iskyc;
        clientPartialDetails_ao.isKRA = responseObj.iskra;

        setIsManual(clientPartialDetails_ao.isManual);
        clientPartialDetails_ao.isDigiLocker =
          responseObj.isdigilockercompleted;
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        if (responseObj.isbankdetailscompleted) {
          setBankStage(true);
        } else {
          setBankStage(false);
        }

        if (responseObj.ispanlinkedwithaadhar === true) {
          GlobalStore.isSeeding = true;
          setSeedingPopup(false);
        } else if (responseObj.ispanlinkedwithaadhar === false) {
          GlobalStore.isSeeding = false;
          setSeedingPopup(true);
        }
      } else {
        gtmService({
          action: "GetStageCompletionStatus",
          label: "ERROR || ERR141-S",
        });
      }
    }

    AGetDocumentList(getDocList, GlobalStore.applicationID); //2
    AGetPendingDocument(getPendingDoc, GlobalStore.applicationID); //1
    AGetDocStatus(getDocumentStatus, GlobalStore.applicationID); //3
  }

  function showPhotoPreview(showPhotoPreview: boolean) {
    videoRefElement.current!.hidden = showPhotoPreview;
    canvasRefElement.current!.hidden = !showPhotoPreview;
  }
  function sendSmsLink() {
    setSendSmsLinkError("")
    let AccountObj = {
      PanNo: GlobalStore?.personaldetails?.pan,
      AccountCategory: GlobalStore?.accountcategory
        ? GlobalStore?.accountcategory
        : GlobalStore?.stageStatus?.accountcategory,
      userid: userId,
    };
    let accountObjString = JSON.stringify(AccountObj);
    const encodedPan = btoa(accountObjString);
    const stringParams = `ipvLink?id=${encodedPan}`;
    const ipvUrl = `${config.root}${stringParams}`;

    const smsBody = {
      "applicationId": GlobalStore.applicationID,
      "accountCategory": GlobalStore?.accountcategory
      // selfieLinkText: `Give a Smile and complete your IPV process for Online Account Opening, click here ${ipvUrl} to complete the process. Regards, Nuvama`,
    };
    ASendSmsV2((res: any) => {
      if (!res.error) {
        setSendSmsLinkModal(true)
        setTimer(59);
        setStatus("countdown");
      } else {
        setSendSmsLinkError(res.error)
        setStatus("send");
      }
    }, smsBody);
  }

  useEffect(() => {
    if (timer > 0) {
      intervalRef.current = setInterval(() => {
        setTimer(prev => {
          if (prev <= 1) {
            clearInterval(intervalRef.current);
            setStatus("resend");
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(intervalRef.current);
  }, [timer]);

  const formatTime = (seconds: any) => {
    const min = String(Math.floor(seconds / 60)).padStart(2, '0');
    const sec = String(seconds % 60).padStart(2, '0');
    return `${min}:${sec}`;
  };


  async function turnOnCamera() {
    // getLocation();
    const constraints = {
      audio: false,
      video: {
        facingMode: "user",
      },
    };

    function handleSuccess(turnOfCamera: MediaStream) {
      setCameraPermission(true);
      setIsLoading(false);
      videoRefElement.current!.srcObject = turnOfCamera;
      setMediaRecorder(new MediaRecorder(turnOfCamera));
      setTurnOfCamera(turnOfCamera);
      setShowVidPerm(false);
    }

    function handleError(error: any) {
      setIsLoading(true);
      setCameraPermission(false);
      setShowVidPerm(true);
    }

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(handleSuccess)
      .catch(handleError);
  }

  const getDocumentStatus = (res: any) => {
    if (!res || res.error) {
      // setErrCode("164- Failed to get the document status for the application.");
      setErrCode(errCode + res.error);
      gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR125" });
    } else {
      if (res.data) {
        const regectedDoc = JSON.parse(res.data).filter(
          (item: any) => item.Status === "Rejected"
        );
        setRegectedDocStatus(regectedDoc);
      } else {
        gtmService({
          action: "GetDocumentDetails",
          label: "ERROR || ERR125-S",
        });
      }
    }
  };

  const getDocList = (res: any) => {
    if (!res || res.error) {
      setErrCode(errCode + res.error);
      gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR121" });
    } else {
      if (res.data) {
        let listObj = JSON.parse(res.data);
        const photoData = listObj.filter(
          (x: any) => x.DocumentCategory === "Photograph"
        );
        const panData = listObj.filter(
          (x: any) => x.DocumentCategory === "PAN Card"
        );
        const firstBankObjlist = listObj.filter(
          (x: any) => x.DocumentCategoryId === 9
        );
        const SecondBankObjlist = listObj.filter(
          (x: any) => x.DocumentCategoryId === 60
        );
        const thirdBankObjlist = listObj.filter(
          (x: any) => x.DocumentCategoryId === 61
        );
        const fourthBankObjlist = listObj.filter(
          (x: any) => x.DocumentCategoryId === 70
        );
        const fifthBankObjlist = listObj.filter(
          (x: any) => x.DocumentCategoryId === 71
        );
        const corrAddObjlist = listObj.filter(
          (x: any) => x.DocumentCategory === "Address Proof Correspondence"
        );
        const permAddObjlist = listObj.filter(
          (x: any) => x.DocumentCategory === "Address Proof Permanent"
        );
        const incomeObjlist = listObj.filter(
          (x: any) => x.DocumentCategory === "Income Proof"
        );
        const signatureData = listObj.filter(
          (x: any) => x.DocumentCategory === "Signature"
        );
        const nomineeFirstList = listObj.filter(
          (x: any) =>
            x.DocumentCategoryId ===
            nomineeDocsIds.nomineeOne.photo.documentCategoryId ||
            x.DocumentCategoryId ===
            nomineeDocsIds.nomineeOne.signature.documentCategoryId
        );
        const nomineeSecondList = listObj.filter(
          (x: any) =>
            x.DocumentCategoryId ===
            nomineeDocsIds.nomineeTwo.photo.documentCategoryId ||
            x.DocumentCategoryId ===
            nomineeDocsIds.nomineeTwo.signature.documentCategoryId
        );
        const nomineeThirdList = listObj.filter(
          (x: any) =>
            x.DocumentCategoryId ===
            nomineeDocsIds.nomineeThree.photo.documentCategoryId ||
            x.DocumentCategoryId ===
            nomineeDocsIds.nomineeThree.signature.documentCategoryId
        );
        const guardianFirstList = listObj.filter(
          (x: any) =>
            x.DocumentCategoryId ===
            nomineeDocsIds.nomineeOne.guardianDetails.photo
              .documentCategoryId ||
            x.DocumentCategoryId ===
            nomineeDocsIds.nomineeOne.guardianDetails.signature
              .documentCategoryId
        );

        const guardianSecondList = listObj.filter(
          (x: any) =>
            x.DocumentCategoryId ===
            nomineeDocsIds.nomineeTwo.guardianDetails.photo
              .documentCategoryId ||
            x.DocumentCategoryId ===
            nomineeDocsIds.nomineeTwo.guardianDetails.signature
              .documentCategoryId
        );
        const guardianThirdList = listObj.filter(
          (x: any) =>
            x.DocumentCategoryId ===
            nomineeDocsIds.nomineeThree.guardianDetails.photo
              .documentCategoryId ||
            x.DocumentCategoryId ===
            nomineeDocsIds.nomineeThree.guardianDetails.signature
              .documentCategoryId
        );
        if (photoData.length) {
          let photoCopy = { ...photoObj };
          photoCopy.documentCategoryId = photoData[0].DocumentCategoryId;
          photoCopy.documentId = photoData[0].DocumentId;
          photoCopy.documentcategory = photoData[0].DocumentCategory;
          setPhotoObj(photoCopy);
        }

        if (panData.length) {
          setPanObj((panObj) => {
            panObj.documentCategoryId = panData[0].DocumentCategoryId;
            panObj.documentId = panData[0].DocumentId;
            panObj.documentcategory = panData[0].DocumentCategory;
            panObj.fileName = `${GlobalStore.applicationID}_Pan Card`;
            return panObj;
          });
          // let panCopy = { ...panObj };

          // //   panCopy.base64 = panBase64 ? panBase64 : panObj?.base64;
          // setPanObj(panCopy);
        }

        if (firstBankObjlist.length) {
          let firstBankCopy = { ...firstBankObj };
          firstBankCopy.documentCategoryId =
            firstBankObjlist[0].DocumentCategoryId;
          firstBankCopy.documentcategory = firstBankObjlist[0].DocumentCategory;
          setFirstBankObj(firstBankCopy);
        }

        if (SecondBankObjlist.length) {
          let secondBankCopy = { ...secondBankObj };
          secondBankCopy.documentCategoryId =
            SecondBankObjlist[0].DocumentCategoryId;
          secondBankCopy.documentcategory =
            SecondBankObjlist[0].DocumentCategory;
          setSecondBankObj(secondBankCopy);
        }

        if (thirdBankObjlist.length) {
          let thirdBankCopy = { ...thirdBankObj };
          thirdBankCopy.documentCategoryId =
            thirdBankObjlist[0].DocumentCategoryId;
          thirdBankCopy.documentcategory = thirdBankObjlist[0].DocumentCategory;
          setThirdBankObj(thirdBankCopy);
        }

        if (fourthBankObjlist.length) {
          let fourthBankCopy = { ...fourthBankObj };
          fourthBankCopy.documentCategoryId =
            fourthBankObjlist[0].DocumentCategoryId;
          fourthBankCopy.documentcategory =
            fourthBankObjlist[0].DocumentCategory;
          setFourthBankObj(fourthBankCopy);
        }

        if (fifthBankObjlist.length) {
          let fifthBankCopy = { ...fifthBankObj };
          fifthBankCopy.documentCategoryId =
            fifthBankObjlist[0].DocumentCategoryId;
          fifthBankCopy.documentcategory = fifthBankObjlist[0].DocumentCategory;
          setFifthBankObj(fifthBankCopy);
        }

        if (permAddObjlist.length) {
          let permAddressCopy = { ...permAddressObj };
          permAddressCopy.documentcategory = "Address Proof Permanent";
          permAddressCopy.documentCategoryId =
            permAddObjlist[0].DocumentCategoryId;
          setPermAddressObj(permAddressCopy);
        }

        if (corrAddObjlist.length) {
          let corrAddressCopy = { ...corrAddressObj };
          corrAddressCopy.documentcategory = "Address Proof Correspondance";
          corrAddressCopy.documentCategoryId =
            corrAddObjlist[0].DocumentCategoryId;
          setCorrAddressObj(corrAddressCopy);
        }

        let tempArr: any = []
        if (signatureData.length) {
          if (signatureData[0].DocumentCategoryId == 27) {
            let signatureCopy = { ...signatureObj };
            signatureCopy.documentcategory = "Signature";
            signatureCopy.documentCategoryId = signatureData[0].DocumentCategoryId;
            signatureCopy.documentId = signatureData[0].DocumentId;
            setSignatureObj(signatureCopy);
          }
          let signArr = signatureData[0].DocumentCategoryId == 27 ? signatureData.slice(1) : signatureData
          signArr.map((sign: any) => {
            if (!tempArr.find((a: any) => a.documentCategoryId == sign.DocumentCategoryId)) {
              let signatureCopy = { ...signatureObj };
              signatureCopy.documentcategory = "Signature";
              signatureCopy.documentCategoryId = sign.DocumentCategoryId;
              signatureCopy.documentId = sign.DocumentId;
              tempArr.push(signatureCopy)
            }
          })
          setSignaturesArr(tempArr)
        } else {
          let signatureCopy = { ...initialPanDocObj };
          signatureCopy.documentcategory = "Signature";
          signatureCopy.documentCategoryId = "27";
          signatureCopy.documentId = 305;
          signatureCopy.isElogSignOpted = true;
          signatureCopy.imgUrl = "";
          setSignatureObj(signatureCopy);
        }

        if (incomeObjlist.length) {
          let incomeCopy = { ...incomeObj };
          incomeCopy.documentcategory = "Income Proof";
          incomeCopy.documentCategoryId = incomeObjlist[0].DocumentCategoryId;
          incomeCopy.documentId = incomeObjlist[0].DocumentId;
          setIncomeObj(incomeCopy);
        }
        setErrCode(errCode);
        setFirstBankList(firstBankObjlist);
        setSecondBankList(SecondBankObjlist);
        setThirdBankList(thirdBankObjlist);
        setFourthBankList(fourthBankObjlist);
        setFifthBankList(fifthBankObjlist);
        // let permAddObjListNew=permAddObjlist((permAdd:any)=>permAdd?.DocumentId!==125);
        setPermAddList(permAddObjlist);
        setCorrAddList(corrAddObjlist);
        setIncomeList(incomeObjlist);
        setNomineeFirstList(nomineeFirstList);
        setNomineeSecondList(nomineeSecondList);
        setNomineeThirdList(nomineeThirdList);
        setGuardianFirstList(guardianFirstList);
        setGuardianSecondList(guardianSecondList);
        setGuardianThirdList(guardianThirdList);

        AGetUploadedDocument(
          (res: any) => getUploadedDoc(res, tempArr),
          GlobalStore.applicationID)
      } else {
        // setErrCode(164)
        gtmService({
          action: "GetDocumentDetails",
          label: "ERROR || ERR121-S",
        });
      }
    }
  };

  const getUploadedDoc = (res: any, signatureArr: any) => {
    if (!res || res.error) {
      // setErrCode(164)
      setErrCode(errCode + res.error);
      gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR124" });
    } else if (res.data) {
      const uplDoc = JSON.parse(res.data);
      const isPhoto = uplDoc.filter(
        (x: any) =>
          x.DocumentCategory === "Photograph" && x.DocumentId === photographId
      );
      const isPANCard = uplDoc.filter(
        (x: any) => x.DocumentCategory === "PAN Card"
      );
      const isFirstBankDocument = uplDoc.filter(
        (x: any) => x.DocumentCategoryId === 9
      );
      const isSecondBankDocument = uplDoc.filter(
        (x: any) => x.DocumentCategoryId === 60
      );
      const isThirdBankDocument = uplDoc.filter(
        (x: any) => x.DocumentCategoryId === 61
      );
      const isFourthBankDocument = uplDoc.filter(
        (x: any) => x.DocumentCategoryId === 70
      );
      const isFifthBankDocument = uplDoc.filter(
        (x: any) => x.DocumentCategoryId === 71
      );
      const isCorrAddressProof = uplDoc.filter(
        (x: any) => x.DocumentCategory === "Address Proof Correspondence"
      );
      const isPermAddressProof = uplDoc.filter(
        (x: any) => x.DocumentCategory === "Address Proof Permanent"
      );
      const isSignature = uplDoc.filter(
        (x: any) => x.DocumentCategory === "Signature"
      );
      const isIncomeProof = uplDoc.filter(
        (x: any) => x.DocumentCategory === "Income Proof"
      );
      const isNomineeFirstPhoto = uplDoc.filter(
        (x: any) =>
          x.DocumentCategoryId ===
          nomineeDocsIds.nomineeOne.photo.documentCategoryId
      );
      const isNomineeFirstSignature = uplDoc.filter(
        (x: any) =>
          x.DocumentCategoryId ===
          nomineeDocsIds.nomineeOne.signature.documentCategoryId
      );
      const isNomineeSecondPhoto = uplDoc.filter(
        (x: any) =>
          x.DocumentCategoryId ===
          nomineeDocsIds.nomineeTwo.photo.documentCategoryId
      );
      const isNomineeSecondSignature = uplDoc.filter(
        (x: any) =>
          x.DocumentCategoryId ===
          nomineeDocsIds.nomineeTwo.signature.documentCategoryId
      );
      const isNomineeThirdPhoto = uplDoc.filter(
        (x: any) =>
          x.DocumentCategoryId ===
          nomineeDocsIds.nomineeThree.photo.documentCategoryId
      );
      const isNomineeThirdSignature = uplDoc.filter(
        (x: any) =>
          x.DocumentCategoryId ===
          nomineeDocsIds.nomineeThree.signature.documentCategoryId
      );
      const isGuardianFirstPhoto = uplDoc.filter(
        (x: any) =>
          x.DocumentCategoryId ===
          nomineeDocsIds.nomineeOne.guardianDetails.photo.documentCategoryId
      );
      const isGuardianFirstSignature = uplDoc.filter(
        (x: any) =>
          x.DocumentCategoryId ===
          nomineeDocsIds.nomineeOne.guardianDetails.signature.documentCategoryId
      );
      const isGuardianSecondPhoto = uplDoc.filter(
        (x: any) =>
          x.DocumentCategoryId ===
          nomineeDocsIds.nomineeTwo.guardianDetails.photo.documentCategoryId
      );
      const isGuardianSecondSignature = uplDoc.filter(
        (x: any) =>
          x.DocumentCategoryId ===
          nomineeDocsIds.nomineeTwo.guardianDetails.signature.documentCategoryId
      );
      const isGuardianThirdPhoto = uplDoc.filter(
        (x: any) =>
          x.DocumentCategoryId ===
          nomineeDocsIds.nomineeThree.guardianDetails.photo.documentCategoryId
      );

      const isGuardianThirdSignature = uplDoc.filter(
        (x: any) =>
          x.DocumentCategoryId ===
          nomineeDocsIds.nomineeThree.guardianDetails.signature
            .documentCategoryId
      );

      if (isNomineeFirstPhoto.length > 0) {
        setIsLoading(true);
        let nomineeFirstPhoto = [...nomineeFirstObj];
        nomineeFirstPhoto[0].id = "photo";
        nomineeFirstPhoto[0].disable = false;
        nomineeFirstPhoto[0].uploadPer = 100;
        nomineeFirstPhoto[0].fileName = isNomineeFirstPhoto[0].FileName;
        nomineeFirstPhoto[0].showFile = false;
        nomineeFirstPhoto[0].hideProgress = false;
        nomineeFirstPhoto[0].mimeType = isNomineeFirstPhoto[0].MimeType;
        nomineeFirstPhoto[0].documentCategoryId =
          isNomineeFirstPhoto[0].DocumentCategoryId;
        nomineeFirstPhoto[0].documentId = isNomineeFirstPhoto[0].DocumentId;
        nomineeFirstPhoto[0].documentcategory =
          isNomineeFirstPhoto[0].DocumentCategory;
        setNomineeFirstObj(nomineeFirstPhoto);
        ADownloadDocument(
          (res: any) => NomineeFirstImage(res, "photo"),
          isNomineeFirstPhoto[0].FileName,
          isNomineeFirstPhoto[0].UploadedDocPath
        );
      }
      if (isNomineeFirstSignature.length > 0) {
        setIsLoading(true);
        let nomineeFirstSignature = [...nomineeFirstObj];

        nomineeFirstSignature[1].id = "signature";
        nomineeFirstSignature[1].disable = false;
        nomineeFirstSignature[1].uploadPer = 100;
        nomineeFirstSignature[1].fileName = isNomineeFirstSignature[0].FileName;
        nomineeFirstSignature[1].showFile = false;
        nomineeFirstSignature[1].hideProgress = false;
        nomineeFirstSignature[1].mimeType = isNomineeFirstSignature[0].MimeType;
        nomineeFirstSignature[1].documentCategoryId =
          isNomineeFirstSignature[0].DocumentCategoryId;
        nomineeFirstSignature[1].documentId =
          isNomineeFirstSignature[0].DocumentId;
        nomineeFirstSignature[1].documentcategory =
          isNomineeFirstSignature[0].DocumentCategory;
        setNomineeFirstObj(nomineeFirstSignature);
        ADownloadDocument(
          (res: any) => NomineeFirstImage(res, "signature"),
          isNomineeFirstSignature[0].FileName,
          isNomineeFirstSignature[0].UploadedDocPath
        );
      }
      if (isNomineeSecondPhoto.length > 0) {
        setIsLoading(true);
        let nomineeSecondPhoto = [...nomineeSecondObj];

        nomineeSecondPhoto[0].id = "photo";
        nomineeSecondPhoto[0].disable = false;
        nomineeSecondPhoto[0].uploadPer = 100;
        nomineeSecondPhoto[0].fileName = isNomineeSecondPhoto[0].FileName;
        nomineeSecondPhoto[0].showFile = false;
        nomineeSecondPhoto[0].hideProgress = false;
        nomineeSecondPhoto[0].mimeType = isNomineeSecondPhoto[0].MimeType;
        nomineeSecondPhoto[0].documentCategoryId =
          isNomineeSecondPhoto[0].DocumentCategoryId;
        nomineeSecondPhoto[0].documentId = isNomineeSecondPhoto[0].DocumentId;
        nomineeSecondPhoto[0].documentcategory =
          isNomineeSecondPhoto[0].DocumentCategory;
        setNomineeSecondObj(nomineeSecondPhoto);
        ADownloadDocument(
          (res: any) => NomineeSecondImage(res, "photo"),
          isNomineeSecondPhoto[0].FileName,
          isNomineeSecondPhoto[0].UploadedDocPath
        );
      }
      if (isNomineeSecondSignature.length > 0) {
        setIsLoading(true);
        let nomineeSecondSignature = [...nomineeSecondObj];

        nomineeSecondSignature[1].id = "signature";
        nomineeSecondSignature[1].disable = false;
        nomineeSecondSignature[1].uploadPer = 100;
        nomineeSecondSignature[1].fileName =
          isNomineeSecondSignature[0].FileName;
        nomineeSecondSignature[1].showFile = false;
        nomineeSecondSignature[1].hideProgress = false;
        nomineeSecondSignature[1].mimeType =
          isNomineeSecondSignature[0].MimeType;
        nomineeSecondSignature[1].documentCategoryId =
          isNomineeSecondSignature[0].DocumentCategoryId;
        nomineeSecondSignature[1].documentId =
          isNomineeSecondSignature[0].DocumentId;
        nomineeSecondSignature[1].documentcategory =
          isNomineeSecondSignature[0].DocumentCategory;
        setNomineeSecondObj(nomineeSecondSignature);
        ADownloadDocument(
          (res: any) => NomineeSecondImage(res, "signature"),
          isNomineeSecondSignature[0].FileName,
          isNomineeSecondSignature[0].UploadedDocPath
        );
      }
      if (isNomineeThirdPhoto.length > 0) {
        setIsLoading(true);
        let nomineeThirdPhoto = [...nomineeThirdObj];

        nomineeThirdPhoto[0].id = "photo";
        nomineeThirdPhoto[0].disable = false;
        nomineeThirdPhoto[0].uploadPer = 100;
        nomineeThirdPhoto[0].fileName = isNomineeThirdPhoto[0].FileName;
        nomineeThirdPhoto[0].showFile = false;
        nomineeThirdPhoto[0].hideProgress = false;
        nomineeThirdPhoto[0].mimeType = isNomineeThirdPhoto[0].MimeType;
        nomineeThirdPhoto[0].documentCategoryId =
          isNomineeThirdPhoto[0].DocumentCategoryId;
        nomineeThirdPhoto[0].documentId = isNomineeThirdPhoto[0].DocumentId;
        nomineeThirdPhoto[0].documentcategory =
          isNomineeThirdPhoto[0].DocumentCategory;
        setNomineeThirdObj(nomineeThirdPhoto);
        ADownloadDocument(
          (res: any) => NomineeThirdImage(res, "photo"),
          isNomineeThirdPhoto[0].FileName,
          isNomineeThirdPhoto[0].UploadedDocPath
        );
      }
      if (isNomineeThirdSignature.length > 0) {
        setIsLoading(true);
        let nomineeThirdSignature = [...nomineeThirdObj];

        nomineeThirdSignature[1].id = "signature";
        nomineeThirdSignature[1].disable = false;
        nomineeThirdSignature[1].uploadPer = 100;
        nomineeThirdSignature[1].fileName = isNomineeThirdSignature[0].FileName;
        nomineeThirdSignature[1].showFile = false;
        nomineeThirdSignature[1].hideProgress = false;
        nomineeThirdSignature[1].mimeType = isNomineeThirdSignature[0].MimeType;
        nomineeThirdSignature[1].documentCategoryId =
          isNomineeThirdSignature[0].DocumentCategoryId;
        nomineeThirdSignature[1].documentId =
          isNomineeThirdSignature[0].DocumentId;
        nomineeThirdSignature[1].documentcategory =
          isNomineeThirdSignature[0].DocumentCategory;
        setNomineeThirdObj(nomineeThirdSignature);
        ADownloadDocument(
          (res: any) => NomineeThirdImage(res, "signature"),
          isNomineeThirdSignature[0].FileName,
          isNomineeThirdSignature[0].UploadedDocPath
        );
      }

      // guardian start
      if (isGuardianFirstPhoto.length > 0) {
        setIsLoading(true);
        let guardianFirstPhoto = [...guardianFirstObj];

        guardianFirstPhoto[0].id = "photo";
        guardianFirstPhoto[0].disable = false;
        guardianFirstPhoto[0].uploadPer = 100;
        guardianFirstPhoto[0].fileName = isGuardianFirstPhoto[0].FileName;
        guardianFirstPhoto[0].showFile = false;
        guardianFirstPhoto[0].hideProgress = false;
        guardianFirstPhoto[0].mimeType = isGuardianFirstPhoto[0].MimeType;
        guardianFirstPhoto[0].documentCategoryId =
          isGuardianFirstPhoto[0].DocumentCategoryId;
        guardianFirstPhoto[0].documentId = isGuardianFirstPhoto[0].DocumentId;
        guardianFirstPhoto[0].documentcategory =
          isGuardianFirstPhoto[0].DocumentCategory;
        setGuardianFirstObj(guardianFirstPhoto);
        ADownloadDocument(
          (res: any) => GuardianFirstImage(res, "photo"),
          isGuardianFirstPhoto[0].FileName,
          isGuardianFirstPhoto[0].UploadedDocPath
        );
      }

      if (isGuardianFirstSignature.length > 0) {
        setIsLoading(true);
        let guardianFirstSignature = [...guardianFirstObj];

        guardianFirstSignature[1].id = "signature";
        guardianFirstSignature[1].disable = false;
        guardianFirstSignature[1].uploadPer = 100;
        guardianFirstSignature[1].fileName =
          isGuardianFirstSignature[0].FileName;
        guardianFirstSignature[1].showFile = false;
        guardianFirstSignature[1].hideProgress = false;
        guardianFirstSignature[1].mimeType =
          isGuardianFirstSignature[0].MimeType;
        guardianFirstSignature[1].documentCategoryId =
          isGuardianFirstSignature[0].DocumentCategoryId;
        guardianFirstSignature[1].documentId =
          isGuardianFirstSignature[0].DocumentId;
        guardianFirstSignature[1].documentcategory =
          isGuardianFirstSignature[0].DocumentCategory;
        setGuardianFirstObj(guardianFirstSignature);
        ADownloadDocument(
          (res: any) => GuardianFirstImage(res, "signature"),
          isGuardianFirstSignature[0].FileName,
          isGuardianFirstSignature[0].UploadedDocPath
        );
      }

      if (isGuardianSecondPhoto.length > 0) {
        setIsLoading(true);
        let guardianSecondPhoto = [...guardianSecondObj];

        guardianSecondPhoto[0].id = "photo";
        guardianSecondPhoto[0].disable = false;
        guardianSecondPhoto[0].uploadPer = 100;
        guardianSecondPhoto[0].fileName = isGuardianSecondPhoto[0].FileName;
        guardianSecondPhoto[0].showFile = false;
        guardianSecondPhoto[0].hideProgress = false;
        guardianSecondPhoto[0].mimeType = isGuardianSecondPhoto[0].MimeType;
        guardianSecondPhoto[0].documentCategoryId =
          isGuardianSecondPhoto[0].DocumentCategoryId;
        guardianSecondPhoto[0].documentId = isGuardianSecondPhoto[0].DocumentId;
        guardianSecondPhoto[0].documentcategory =
          isGuardianSecondPhoto[0].DocumentCategory;
        setGuardianSecondObj(guardianSecondPhoto);
        ADownloadDocument(
          (res: any) => GuardianSecondImage(res, "photo"),
          isGuardianSecondPhoto[0].FileName,
          isGuardianSecondPhoto[0].UploadedDocPath
        );
      }

      if (isGuardianSecondSignature.length > 0) {
        setIsLoading(true);
        let guardianSecondSignature = [...guardianSecondObj];

        guardianSecondSignature[1].id = "signature";
        guardianSecondSignature[1].disable = false;
        guardianSecondSignature[1].uploadPer = 100;
        guardianSecondSignature[1].fileName =
          isGuardianSecondSignature[0].FileName;
        guardianSecondSignature[1].showFile = false;
        guardianSecondSignature[1].hideProgress = false;
        guardianSecondSignature[1].mimeType =
          isGuardianSecondSignature[0].MimeType;
        guardianSecondSignature[1].documentCategoryId =
          isGuardianSecondSignature[0].DocumentCategoryId;
        guardianSecondSignature[1].documentId =
          isGuardianSecondSignature[0].DocumentId;
        guardianSecondSignature[1].documentcategory =
          isGuardianSecondSignature[0].DocumentCategory;
        setGuardianSecondObj(guardianSecondSignature);
        ADownloadDocument(
          (res: any) => GuardianSecondImage(res, "signature"),
          isGuardianSecondSignature[0].FileName,
          isGuardianSecondSignature[0].UploadedDocPath
        );
      }
      if (isGuardianThirdPhoto.length > 0) {
        setIsLoading(true);
        let guardianThirdPhoto = [...guardianThirdObj];

        guardianThirdPhoto[0].id = "photo";
        guardianThirdPhoto[0].disable = false;
        guardianThirdPhoto[0].uploadPer = 100;
        guardianThirdPhoto[0].fileName = isGuardianThirdPhoto[0].FileName;
        guardianThirdPhoto[0].showFile = false;
        guardianThirdPhoto[0].hideProgress = false;
        guardianThirdPhoto[0].mimeType = isGuardianThirdPhoto[0].MimeType;
        guardianThirdPhoto[0].documentCategoryId =
          isGuardianThirdPhoto[0].DocumentCategoryId;
        guardianThirdPhoto[0].documentId = isGuardianThirdPhoto[0].DocumentId;
        guardianThirdPhoto[0].documentcategory =
          isGuardianThirdPhoto[0].DocumentCategory;
        setGuardianThirdObj(guardianThirdPhoto);
        ADownloadDocument(
          (res: any) => GuardianThirdImage(res, "photo"),
          isGuardianThirdPhoto[0].FileName,
          isGuardianThirdPhoto[0].UploadedDocPath
        );
      }
      if (isGuardianThirdSignature.length > 0) {
        setIsLoading(true);
        let guardianThirdSignature = [...guardianThirdObj];

        guardianThirdSignature[1].id = "signature";
        guardianThirdSignature[1].disable = false;
        guardianThirdSignature[1].uploadPer = 100;
        guardianThirdSignature[1].fileName =
          isGuardianThirdSignature[0].FileName;
        guardianThirdSignature[1].showFile = false;
        guardianThirdSignature[1].hideProgress = false;
        guardianThirdSignature[1].mimeType =
          isGuardianThirdSignature[0].MimeType;
        guardianThirdSignature[1].documentCategoryId =
          isGuardianThirdSignature[0].DocumentCategoryId;
        guardianThirdSignature[1].documentId =
          isGuardianThirdSignature[0].DocumentId;
        guardianThirdSignature[1].documentcategory =
          isGuardianThirdSignature[0].DocumentCategory;
        setGuardianThirdObj(guardianThirdSignature);
        ADownloadDocument(
          (res: any) => GuardianThirdImage(res, "signature"),
          isGuardianThirdSignature[0].FileName,
          isGuardianThirdSignature[0].UploadedDocPath
        );
      }

      // guardian end
      if (isPhoto.length > 0) {
        setIsLoading(true);
        photoObj.id = "photo";
        photoObj.disable = false;
        photoObj.uploadPer = 100;
        photoObj.fileName = isPhoto[0].FileName;
        photoObj.showFile = false;
        photoObj.hideProgress = false;
        photoObj.mimeType = isPhoto[0].MimeType;
        photoObj.documentCategoryId = isPhoto[0].DocumentCategoryId;
        photoObj.documentId = isPhoto[0].DocumentId;
        photoObj.documentcategory = isPhoto[0].DocumentCategory;
        setPhotoObj(photoObj);
        ADownloadDocument(
          getPhotoImage,
          isPhoto[0].FileName,
          isPhoto[0].UploadedDocPath
        );
      }
      if (isPANCard.length > 0) {
        setIsLoading(true);
        setPanObj((panObj) => {
          let panObjNew = { ...panObj };
          panObjNew.id = "panCard";
          panObjNew.disable = false;
          panObjNew.uploadPer = 100;
          panObjNew.fileName = `${GlobalStore.applicationID}_Pan Card`;
          panObjNew.showFile = false;
          panObjNew.hideProgress = false;
          panObjNew.mimeType = isPANCard[0].MimeType;
          panObjNew.documentCategoryId = isPANCard[0].DocumentCategoryId;
          panObjNew.documentId = isPANCard[0].DocumentId;
          panObjNew.documentcategory = isPANCard[0].DocumentCategory;
          ADownloadDocument(
            (res: any) => {
              if (!res || res.error) {
                // setErrCode(164)
                setErrCode(errCode + res.error);
                gtmService({
                  action: "DownloadDocumentFromS3",
                  label: "ERROR || ERR127",
                });
              } else {
                if (res.data) {
                  setIsLoading(false);
                  setPanBase64(res.data.base64document);
                  if (
                    !!res?.data?.base64document &&
                    res?.data?.base64document !== "" &&
                    res?.data?.base64document?.length > 0
                  ) {
                    setPanCardImageFound(true);
                  } else {
                    setPanCardImageFound(false);
                  }
                  setPanButDisable(false);
                  const base64 = getbase64(res.data.base64document, panObj);
                  panObjNew.imgUrl = base64;
                } else {
                  gtmService({
                    action: "DownloadDocumentFromS3",
                    label: "ERROR || ERR127-S",
                  });
                }
              }
            },
            isPANCard[0].FileName,
            isPANCard[0].UploadedDocPath
          );
          return panObjNew;
        });
      }
      if (isPANCard?.length == 0) {
        setPanCardImageFound(false);
      }

      if (isFirstBankDocument.length > 0) {
        setIsLoading(true);
        if (isFirstBankDocument[0].DocumentName === "Cancelled Cheque") {
          setDefaultFirstBankDoc("Cancelled Cheque");
        } else if (
          isFirstBankDocument[0].DocumentName ===
          "Bank Account Statement / Passbook"
        ) {
          setDefaultFirstBankDoc("Bank Account Statement / Passbook");
        }
        firstBankObj.id = "firstBankDoc";
        firstBankObj.disable = false;
        firstBankObj.uploadPer = 100;
        firstBankObj.fileName = `${GlobalStore.applicationID}_First Bank`;
        firstBankObj.showFile = false;
        firstBankObj.hideProgress = false;
        firstBankObj.documentId = isFirstBankDocument[0].DocumentId;
        firstBankObj.mimeType = isFirstBankDocument[0].MimeType;
        firstBankObj.documentcategory = isFirstBankDocument[0].DocumentCategory;
        firstBankObj.documentCategoryId =
          isFirstBankDocument[0].DocumentCategoryId;
        setFirstBankObj(firstBankObj);
        ADownloadDocument(
          getBankImage,
          isFirstBankDocument[0].FileName,
          isFirstBankDocument[0].UploadedDocPath
        );
        let firstBankDetails: any = {};
        firstBankDetails.BankName = isFirstBankDocument[0].BankName;
        firstBankDetails.AccountType = isFirstBankDocument[0].AccountType;
        setFirstBankDetails(firstBankDetails);
      }

      if (isSecondBankDocument.length > 0) {
        setIsLoading(true);
        if (isSecondBankDocument[0].DocumentName === "Cancelled Cheque") {
          setDefaultSecondBankDoc("Cancelled Cheque");
        } else if (
          isSecondBankDocument[0].DocumentName ===
          "Bank Account Statement / Passbook"
        ) {
          setDefaultSecondBankDoc("Bank Account Statement / Passbook");
        }
        secondBankObj.id = "secondBankDoc";
        secondBankObj.disable = false;
        secondBankObj.uploadPer = 100;
        secondBankObj.fileName = `${GlobalStore.applicationID}_Second Bank`;
        secondBankObj.showFile = false;
        secondBankObj.hideProgress = false;
        secondBankObj.documentId = isSecondBankDocument[0].DocumentId;
        secondBankObj.mimeType = isSecondBankDocument[0].MimeType;
        secondBankObj.documentcategory =
          isSecondBankDocument[0].DocumentCategory;
        secondBankObj.documentCategoryId =
          isSecondBankDocument[0].DocumentCategoryId;
        setSecondBankObj(secondBankObj);
        ADownloadDocument(
          getBankImage,
          isSecondBankDocument[0].FileName,
          isSecondBankDocument[0].UploadedDocPath
        );
        let secondBankDetails: any = {};
        secondBankDetails.BankName = isSecondBankDocument[0].BankName;
        secondBankDetails.AccountType = isSecondBankDocument[0].AccountType;
        setSecondBankDetails(secondBankDetails);
      }

      if (isThirdBankDocument.length > 0) {
        setIsLoading(true);
        if (isThirdBankDocument[0].DocumentName === "Cancelled Cheque") {
          setDefaultThirdBankDoc("Cancelled Cheque");
        } else if (
          isThirdBankDocument[0].DocumentName ===
          "Bank Account Statement / Passbook"
        ) {
          setDefaultThirdBankDoc("Bank Account Statement / Passbook");
        }

        thirdBankObj.id = "thirdBankDoc";
        thirdBankObj.disable = false;
        thirdBankObj.uploadPer = 100;
        thirdBankObj.fileName = `${GlobalStore.applicationID}_Third Bank`;
        thirdBankObj.showFile = false;
        thirdBankObj.hideProgress = false;
        thirdBankObj.documentId = isThirdBankDocument[0].DocumentId;
        thirdBankObj.mimeType = isThirdBankDocument[0].MimeType;
        thirdBankObj.documentcategory = isThirdBankDocument[0].DocumentCategory;
        thirdBankObj.documentCategoryId =
          isThirdBankDocument[0].DocumentCategoryId;
        setThirdBankObj(thirdBankObj);
        ADownloadDocument(
          getBankImage,
          isThirdBankDocument[0].FileName,
          isThirdBankDocument[0].UploadedDocPath
        );
        let thirdBankDetails: any = {};
        thirdBankDetails.BankName = isThirdBankDocument[0].BankName;
        thirdBankDetails.AccountType = isThirdBankDocument[0].AccountType;
        setThirdBankDetails(thirdBankDetails);
      }

      if (isFourthBankDocument.length > 0) {
        setIsLoading(true);
        if (isFourthBankDocument[0].DocumentName === "Cancelled Cheque") {
          setDefaultFourthBankDoc("Cancelled Cheque");
        } else if (
          isFourthBankDocument[0].DocumentName ===
          "Bank Account Statement / Passbook"
        ) {
          setDefaultFourthBankDoc("Bank Account Statement / Passbook");
        }

        fourthBankObj.id = "fourthBankDoc";
        fourthBankObj.disable = false;
        fourthBankObj.uploadPer = 100;
        fourthBankObj.fileName = `${GlobalStore.applicationID}_Fourth Bank`;
        fourthBankObj.showFile = false;
        fourthBankObj.hideProgress = false;
        fourthBankObj.documentId = isFourthBankDocument[0].DocumentId;
        fourthBankObj.mimeType = isFourthBankDocument[0].MimeType;
        fourthBankObj.documentcategory =
          isFourthBankDocument[0].DocumentCategory;
        fourthBankObj.documentCategoryId =
          isFourthBankDocument[0].DocumentCategoryId;
        setFourthBankObj(fourthBankObj);
        ADownloadDocument(
          getBankImage,
          isFourthBankDocument[0].FileName,
          isFourthBankDocument[0].UploadedDocPath
        );
        let fourthBankDetails: any = {};
        fourthBankDetails.BankName = isFourthBankDocument[0].BankName;
        fourthBankDetails.AccountType = isFourthBankDocument[0].AccountType;
        setFourthBankDetails(fourthBankDetails);
      }

      if (isFifthBankDocument.length > 0) {
        setIsLoading(true);
        if (isFifthBankDocument[0].DocumentName === "Cancelled Cheque") {
          setDefaultFifthBankDoc("Cancelled Cheque");
        } else if (
          isFifthBankDocument[0].DocumentName ===
          "Bank Account Statement / Passbook"
        ) {
          setDefaultFifthBankDoc("Bank Account Statement / Passbook");
        }

        fifthBankObj.id = "fifthBankDoc";
        fifthBankObj.disable = false;
        fifthBankObj.uploadPer = 100;
        fifthBankObj.fileName = `${GlobalStore.applicationID}_Fifth Bank`;
        fifthBankObj.showFile = false;
        fifthBankObj.hideProgress = false;
        fifthBankObj.documentId = isFifthBankDocument[0].DocumentId;
        fifthBankObj.mimeType = isFifthBankDocument[0].MimeType;
        fifthBankObj.documentcategory = isFifthBankDocument[0].DocumentCategory;
        fifthBankObj.documentCategoryId =
          isFifthBankDocument[0].DocumentCategoryId;
        setFifthBankObj(fifthBankObj);
        ADownloadDocument(
          getBankImage,
          isFifthBankDocument[0].FileName,
          isFifthBankDocument[0].UploadedDocPath
        );
        let fifthBankDetails: any = {};
        fifthBankDetails.BankName = isFifthBankDocument[0].BankName;
        fifthBankDetails.AccountType = isFifthBankDocument[0].AccountType;
        setFifthBankDetails(fifthBankDetails);
      }

      if (isPermAddressProof.length > 0) {
        setIsLoading(true);
        setDefaultPermAddressProof(true);
        if (isPermAddressProof[0].DocumentName === "Aadhaar Card") {
          setDefaultAddress("Aadhaar Card");
        } else if (isPermAddressProof[0].DocumentName === "Passport") {
          setDefaultAddress("Passport");
        } else if (isPermAddressProof[0].DocumentName === "Voter ID") {
          setDefaultAddress("Voter ID");
        } else if (isPermAddressProof[0].DocumentName === "Driving License") {
          setDefaultAddress("Driving License");
        } else if (isPermAddressProof[0].DocumentName === "Nrega Job Card") {
          setDefaultAddress("Nrega Job Card");
        }

        permAddressObj.id = "permAddress";
        permAddressObj.disable = blockAadhar;
        permAddressObj.uploadPer = 100;
        permAddressObj.fileName = `${GlobalStore.applicationID}_Permanent Address`;
        permAddressObj.showFile = false;
        permAddressObj.hideProgress = false;
        permAddressObj.documentCategoryId =
          isPermAddressProof[0].DocumentCategoryId;
        permAddressObj.documentcategory =
          isPermAddressProof[0].DocumentCategory;
        permAddressObj.documentId = isPermAddressProof[0].DocumentId;
        permAddressObj.mimeType = isPermAddressProof[0].MimeType;
        permAddressObj.documentCategoryId =
          isPermAddressProof[0].DocumentCategoryId;
        setPermAddressObj(permAddressObj);
        ADownloadDocument(
          getAddressImage,
          isPermAddressProof[0].FileName,
          isPermAddressProof[0].UploadedDocPath
        );
      }

      if (isCorrAddressProof.length > 0) {
        setIsLoading(true);
        if (isCorrAddressProof[0].DocumentName === "Aadhaar Card") {
          setDefaultCorrAddress("Aadhaar Card");
        } else if (isCorrAddressProof[0].DocumentName === "Passport") {
          setDefaultCorrAddress("Passport");
        } else if (isCorrAddressProof[0].DocumentName === "Voter ID") {
          setDefaultCorrAddress("Voter ID");
        } else if (isCorrAddressProof[0].DocumentName === "Driving License") {
          setDefaultCorrAddress("Driving License");
        } else if (isCorrAddressProof[0].DocumentName === "Nrega Job Card") {
          setDefaultCorrAddress("Nrega Job Card");
        }

        corrAddressObj.id = "corrAddress";
        corrAddressObj.disable = false;
        corrAddressObj.uploadPer = 100;
        corrAddressObj.fileName = `${GlobalStore.applicationID}_Corrospondance Address`;
        corrAddressObj.showFile = false;
        corrAddressObj.hideProgress = false;
        corrAddressObj.documentCategoryId =
          isCorrAddressProof[0].DocumentCategoryId;
        corrAddressObj.documentcategory =
          isCorrAddressProof[0].DocumentCategory;
        corrAddressObj.documentId = isCorrAddressProof[0].DocumentId;
        corrAddressObj.mimeType = isCorrAddressProof[0].MimeType;
        corrAddressObj.documentCategoryId =
          isCorrAddressProof[0].DocumentCategoryId;
        setCorrAddressObj(corrAddressObj);
        ADownloadDocument(
          getCorrAddressImage,
          isCorrAddressProof[0].FileName,
          isCorrAddressProof[0].UploadedDocPath
        );
      }
      if (isSignature.length > 0) {
        setIsLoading(true);
        setShowCanvas(false);
        if (isSignature[0].DocumentCategoryId == 27) {
          signatureObj.id = "signature";
          signatureObj.disable = false;
          signatureObj.uploadPer = 100;
          signatureObj.fileName = `${GlobalStore.applicationID}_Signature`;
          signatureObj.showFile = false;
          signatureObj.hideProgress = false;
          signatureObj.mimeType = isSignature[0].MimeType;
          signatureObj.documentCategoryId = isSignature[0].DocumentCategoryId;
          signatureObj.documentId = isSignature[0].DocumentId;
          setSignatureObj(signatureObj);
          ADownloadDocument(
            getSignatureImage,
            isSignature[0].FileName,
            isSignature[0].UploadedDocPath
          );
        }
        let tempArr: any = [...signatureArr]
        let signArr = isSignature[0].DocumentCategoryId == 27 ? isSignature.slice(1) : isSignature
        signArr.map((sign: any, i: number) => {
          let signatureObj: any = tempArr.find((a: any) => a.documentCategoryId == sign.DocumentCategoryId)
          if (signatureObj) {
            signatureObj.id = "signature_" + sign.DocumentCategoryId;
            signatureObj.disable = false;
            signatureObj.uploadPer = 100;
            signatureObj.fileName = `${sign.DocumentCategoryId}_Signature`;
            signatureObj.showFile = false;
            signatureObj.hideProgress = false;
            signatureObj.mimeType = sign.MimeType;
            signatureObj.documentCategoryId = sign.DocumentCategoryId;
            signatureObj.documentId = sign.DocumentId;
            signatureObj.FileName = sign.FileName;
            signatureObj.UploadedDocPath = sign.UploadedDocPath
            // tempArr.push(signatureObj);
          }
        })
        setSignaturesArr(tempArr)
        getUploadedSignatures(tempArr)
      }

      if (isIncomeProof.length > 0) {
        setIsLoading(true);
        if (isIncomeProof[0].DocumentName === "Form 16") {
          setDefaultIncomeDoc("Form 16");
        } else if (isIncomeProof[0].DocumentName === "Salary Slip") {
          setDefaultIncomeDoc("Salary Slip");
        } else if (isIncomeProof[0].DocumentName === "ITR Acknowledgement") {
          setDefaultIncomeDoc("ITR Acknowledgement");
        } else if (isIncomeProof[0].DocumentName === "Bank Statement") {
          setDefaultIncomeDoc("Bank Statement");
        } else if (
          isIncomeProof[0].DocumentName === "Demat Holding Statement"
        ) {
          setDefaultIncomeDoc("Demat Holding Statement");
        } else if (isIncomeProof[0].DocumentName === "Networth Certificate") {
          setDefaultIncomeDoc("Networth Certificate");
        }

        incomeObj.id = "incomeDoc";
        incomeObj.disable = false;
        incomeObj.uploadPer = 100;
        incomeObj.fileName = `${GlobalStore.applicationID}_Income`;
        incomeObj.showFile = false;
        incomeObj.hideProgress = false;
        incomeObj.mimeType = isIncomeProof[0].MimeType;
        incomeObj.documentId = isIncomeProof[0].DocumentId;
        incomeObj.documentCategoryId = isIncomeProof[0].DocumentCategoryId;
        setIncomeObj(incomeObj);
        ADownloadDocument(
          getIncomeImage,
          isIncomeProof[0].FileName,
          isIncomeProof[0].UploadedDocPath
        );
      }
    } else {
      setPanObj((panObj) => {
        return panObj;
      });
      setFirstBankObj(firstBankObj);
      setPermAddressObj(permAddressObj);
      setCorrAddressObj(corrAddressObj);
      setSignatureObj(signatureObj);
      setIncomeObj(incomeObj);
      gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR124-S" });
    }
    setIsLoading(false);
  };

  const getUploadedSignatures = (arr: any) => {
    arr.map((sign: any, i: number) => {
      if (sign.FileName && sign.UploadedDocPath)
        ADownloadDocument(
          (res: any) => getSignatureImageArr(res, i, arr),
          sign.FileName,
          sign.UploadedDocPath
        );
    })
  }

  const popularSignatures = {
    JVBERi0: "application/pdf",
    R0lGODdh: "image/gif",
    R0lGODlh: "image/gif",
    iVBORw0KGgo: "image/png",
    "/9j/": "image/jpg",
    Qk02U: "image/bmp",
  };

  function detectMimeType(base64 = "") {
    for (const [signature, type] of Object.entries(popularSignatures)) {
      if (base64.startsWith(signature)) {
        return type;
      }
    }
    return undefined; // Explicitly return undefined if no match is found
  }

  function getbase64(dataString: string, obj: DocDetailFormat) {
    if (obj.mimeType === "" || obj.mimeType == ".") {
      let mimeType = detectMimeType(dataString);
      return "data:" + mimeType + ";base64," + dataString;
    } else {
      return (
        "data:" +
        (obj.mimeType === "application/pdf"
          ? "application/pdf"
          : "image/jpeg") +
        ";base64," +
        dataString
      );
    }
  }
  // NomineeSecondImage
  const NomineeFirstImage = (res: any, documentType: string) => {
    if (!res || res.error) {
      // setErrCode(164)
      // gtmService({
      //   action: "DownloadDocumentFromS3",
      //   label: "ERROR || ERR126",
      // });
    } else {
      if (res.data) {
        if (documentType === "photo") {
          const base64 = getbase64(res.data.base64document, nomineeFirstObj[0]);
          let imageOBJ = [...nomineeFirstObj];
          imageOBJ[0].imgUrl = base64;
          setNomineeFirstObj(imageOBJ);
        } else {
          const base64 = getbase64(res.data.base64document, nomineeFirstObj[1]);
          let imageOBJ = [...nomineeFirstObj];
          imageOBJ[1].imgUrl = base64;
          setNomineeFirstObj(imageOBJ);
        }
      } else {
        // gtmService({
        //   action: "DownloadDocumentFromS3",
        //   label: "ERROR || ERR126-S",
        // });
      }
    }
    setIsLoading(false);
  };
  const NomineeSecondImage = (res: any, documentType: string) => {
    if (!res || res.error) {
      // setErrCode(164)
      // gtmService({
      //   action: "DownloadDocumentFromS3",
      //   label: "ERROR || ERR126",
      // });
    } else {
      if (res.data) {
        if (documentType === "photo") {
          const base64 = getbase64(
            res.data.base64document,
            nomineeSecondObj[0]
          );
          let imageOBJ = [...nomineeSecondObj];
          imageOBJ[0].imgUrl = base64;
          setNomineeSecondObj(imageOBJ);
        } else {
          const base64 = getbase64(
            res.data.base64document,
            nomineeSecondObj[1]
          );
          let imageOBJ = [...nomineeSecondObj];
          imageOBJ[1].imgUrl = base64;
          setNomineeSecondObj(imageOBJ);
        }
      } else {
        // gtmService({
        //   action: "DownloadDocumentFromS3",
        //   label: "ERROR || ERR126-S",
        // });
      }
    }
    setIsLoading(false);
  };
  const NomineeThirdImage = (res: any, documentType: string) => {
    if (!res || res.error) {
      // setErrCode(164)
      // gtmService({
      //   action: "DownloadDocumentFromS3",
      //   label: "ERROR || ERR126",
      // });
    } else {
      if (res.data) {
        if (documentType === "photo") {
          const base64 = getbase64(res.data.base64document, nomineeThirdObj[0]);
          let imageOBJ = [...nomineeThirdObj];
          imageOBJ[0].imgUrl = base64;
          setNomineeThirdObj(imageOBJ);
        } else {
          const base64 = getbase64(res.data.base64document, nomineeThirdObj[1]);
          let imageOBJ = [...nomineeThirdObj];
          imageOBJ[1].imgUrl = base64;
          setNomineeThirdObj(imageOBJ);
        }
      } else {
        // gtmService({
        //   action: "DownloadDocumentFromS3",
        //   label: "ERROR || ERR126-S",
        // });
      }
    }
    setIsLoading(false);
  };

  const GuardianFirstImage = (res: any, documentType: string) => {
    if (!res || res.error) {
      // setErrCode(164)
      // gtmService({
      //   action: "DownloadDocumentFromS3",
      //   label: "ERROR || ERR126",
      // });
    } else {
      if (res.data) {
        if (documentType === "photo") {
          const base64 = getbase64(
            res.data.base64document,
            guardianFirstObj[0]
          );
          let imageOBJ = [...guardianFirstObj];
          imageOBJ[0].imgUrl = base64;
          setGuardianFirstObj(imageOBJ);
        } else {
          const base64 = getbase64(
            res.data.base64document,
            guardianFirstObj[1]
          );
          let imageOBJ = [...guardianFirstObj];
          imageOBJ[1].imgUrl = base64;
          setGuardianFirstObj(imageOBJ);
        }
      } else {
        // gtmService({
        //   action: "DownloadDocumentFromS3",
        //   label: "ERROR || ERR126-S",
        // });
      }
    }
    setIsLoading(false);
  };

  const GuardianSecondImage = (res: any, documentType: string) => {
    if (!res || res.error) {
      // setErrCode(164)
      // gtmService({
      //   action: "DownloadDocumentFromS3",
      //   label: "ERROR || ERR126",
      // });
    } else {
      if (res.data) {
        if (documentType === "photo") {
          const base64 = getbase64(
            res.data.base64document,
            guardianSecondObj[0]
          );
          let imageOBJ = [...guardianSecondObj];
          imageOBJ[0].imgUrl = base64;
          setGuardianSecondObj(imageOBJ);
        } else {
          const base64 = getbase64(
            res.data.base64document,
            guardianSecondObj[1]
          );
          let imageOBJ = [...guardianSecondObj];
          imageOBJ[1].imgUrl = base64;
          setGuardianSecondObj(imageOBJ);
        }
      } else {
        // gtmService({
        //   action: "DownloadDocumentFromS3",
        //   label: "ERROR || ERR126-S",
        // });
      }
    }
    setIsLoading(false);
  };
  const GuardianThirdImage = (res: any, documentType: string) => {
    if (!res || res.error) {
      // setErrCode(164)
      // gtmService({
      //   action: "DownloadDocumentFromS3",
      //   label: "ERROR || ERR126",
      // });
    } else {
      if (res.data) {
        if (documentType === "photo") {
          const base64 = getbase64(
            res.data.base64document,
            guardianThirdObj[0]
          );
          let imageOBJ = [...guardianThirdObj];
          imageOBJ[0].imgUrl = base64;
          setGuardianThirdObj(imageOBJ);
        } else {
          const base64 = getbase64(
            res.data.base64document,
            guardianThirdObj[1]
          );
          let imageOBJ = [...guardianThirdObj];
          imageOBJ[1].imgUrl = base64;
          setGuardianThirdObj(imageOBJ);
        }
      } else {
        // gtmService({
        //   action: "DownloadDocumentFromS3",
        //   label: "ERROR || ERR126-S",
        // });
      }
    }
    setIsLoading(false);
  };
  const renderUISampleThings = (showPopup: boolean) => {
    let returnUI: any = "";
    switch (showPopup) {
      case showPhotoPopup:
        returnUI = (
          <>
            <ViewPhotoSamplePopup
              setShowPopup={setShowPhotoPopup}
              showPopup={showPhotoPopup}
            />
          </>
        );
        break;
      case showSignaturePopup:
        returnUI = (
          <>
            <ViewSignatureSamplePopup
              setShowPopup={setShowSignaturePopup}
              showPopup={showSignaturePopup}
            />
          </>
        );
        break;
      case showSignatureMobilePopup:
        returnUI = (
          <ViewSignatureSamplePopupMobileView
            setShowPopup={setShowSignatureMobilePopup}
            showPopup={showSignatureMobilePopup}
          />
        );
        break;
      default:
        returnUI = "";
        break;
    }
    return returnUI;
  };

  const getPhotoImage = (res: any) => {
    if (!res || res.error) {
      // setErrCode(164)
      setErrCode(errCode + res.error);
      gtmService({
        action: "DownloadDocumentFromS3",
        label: "ERROR || ERR126",
      });
    } else {
      if (res.data) {
        setIsLoading(false);
        setPhotoBase64(res.data.base64document);
        const base64 = getbase64(res.data.base64document, photoObj);
        let imageOBJ = { ...photoObj };
        imageOBJ.imgUrl = base64;
        setPhotoObj(imageOBJ);
        uploadedPhotoRefElement.current!.hidden = false;
      } else {
        gtmService({
          action: "DownloadDocumentFromS3",
          label: "ERROR || ERR126-S",
        });
      }
    }
  };

  const getBankImage = (res: any) => {
    if (!res || res.error) {
      // setErrCode(164)
      setErrCode(errCode + res.error);
      gtmService({
        action: "DownloadDocumentFromS3",
        label: "ERROR || ERR128",
      });
    } else {
      if (res.data) {
        setIsLoading(false);
        const base64 = getbase64(res.data.base64document, firstBankObj);
        firstBankObj.imgUrl = base64;
        setFirstBankObj(firstBankObj);
      } else {
        gtmService({
          action: "DownloadDocumentFromS3",
          label: "ERROR || ERR128-S",
        });
      }
    }
  };
  const getAddressImage = (res: any) => {
    if (!res || res.error) {
      // setErrCode(164)
      setErrCode(errCode + res.error);
      gtmService({
        action: "DownloadDocumentFromS3",
        label: "ERROR || ERR129",
      });
    } else {
      if (res.data) {
        setIsLoading(false);
        const base64 = getbase64(res.data.base64document, permAddressObj);
        permAddressObj.imgUrl = base64;
        if (detectMimeType(res.data.base64document) !== "application/pdf") {
          permAddressObj.base64 = base64;
        } else permAddressObj.base64 = base64!.split(",")[1];

        setPermAddressObj(permAddressObj);
      } else {
        gtmService({
          action: "DownloadDocumentFromS3",
          label: "ERROR || ERR129-S",
        });
      }
    }
  };

  const getCorrAddressImage = (res: any) => {
    if (!res || res.error) {
      // setErrCode(164)
      setErrCode(errCode + res.error);
      gtmService({
        action: "DownloadDocumentFromS3",
        label: "ERROR || ERR130",
      });
    } else {
      if (res.data) {
        setIsLoading(false);
        const base64 = getbase64(res.data.base64document, corrAddressObj);
        corrAddressObj.imgUrl = base64;
        setCorrAddressObj(corrAddressObj);
      } else {
        gtmService({
          action: "DownloadDocumentFromS3",
          label: "ERROR || ERR130-S",
        });
      }
    }
  };

  const getSignatureImage = (res: any) => {
    if (!res || res.error) {
      // setErrCode(164)
      setErrCode(errCode + res.error);
      gtmService({
        action: "DownloadDocumentFromS3",
        label: "ERROR || ERR131",
      });
    } else {
      if (res.data) {
        setIsLoading(false);
        const base64 = getbase64(res.data.base64document, signatureObj);
        signatureObj.imgUrl = base64;
        setSignatureObj(signatureObj);
      } else {
        gtmService({
          action: "DownloadDocumentFromS3",
          label: "ERROR || ERR131-S",
        });
      }
    }
  };

  const getSignatureImageArr = (res: any, i: number, arr: any) => {
    if (!res || res.error) {
      // setErrCode(164)
      setErrCode(errCode + res.error);
      gtmService({
        action: "DownloadDocumentFromS3",
        label: "ERROR || ERR131",
      });
    } else {
      if (res.data) {
        setIsLoading(false);
        const base64 = getbase64(res.data.base64document, arr[i]);
        arr[i].imgUrl = base64;
        setSignaturesArr(arr);
      } else {
        gtmService({
          action: "DownloadDocumentFromS3",
          label: "ERROR || ERR131-S",
        });
      }
    }
  };
  const getIncomeImage = (res: any) => {
    if (!res || res.error) {
      // setErrCode(164)
      setErrCode(errCode + res.error);
      gtmService({
        action: "DownloadDocumentFromS3",
        label: "ERROR || ERR132",
      });
    } else {
      if (res.data) {
        setIsLoading(false);
        const base64 = getbase64(res.data.base64document, incomeObj);
        incomeObj.imgUrl = base64;
        setIncomeObj(incomeObj);
      } else {
        gtmService({
          action: "DownloadDocumentFromS3",
          label: "ERROR || ERR132-S",
        });
      }
    }
  };

  const getPendingDoc = (res: any) => {
    if (!res || res.error) {
      // setErrCode(164)
      setErrCode(errCode + res.error);
      gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR122" });
    } else {
      if (res.data) {
        const penDoc = JSON.parse(res.data);
        const isPhotoPending = penDoc.filter(
          // prev api response
          //   (x: any) => x.documentcategory === "Photograph"
          (x: any) =>
            x.DocumentCategory == "Photograph" &&
            x.DocumentCategoryId == DocumentCategoryIdForphotographId
        );
        const isCorrPending = penDoc.filter(
          //   (x: any) => x.documentcategory === "Address Proof Correspondence"
          (x: any) => x.DocumentCategory == "Address Proof Correspondence"
        );

        const firstBankDetails = penDoc.filter(
          (x: any) => x.DocumentCategoryId == 9
        );
        const secondBankDetails = penDoc.filter(
          (x: any) => x.DocumentCategoryId == 60
        );
        const thirdBankDetails = penDoc.filter(
          (x: any) => x.DocumentCategoryId == 61
        );
        const fourthBankDetails = penDoc.filter(
          (x: any) => x.DocumentCategoryId == 70
        );
        const fifthBankDetails = penDoc.filter(
          (x: any) => x.DocumentCategoryId == 71
        );
        setFirstBankDetails(firstBankDetails[0]);
        setSecondBankDetails(secondBankDetails[0]);
        setThirdBankDetails(thirdBankDetails[0]);
        setFourthBankDetails(fourthBankDetails[0]);
        setFifthBankDetails(fifthBankDetails[0]);

        if (isCorrPending.length > 0) {
          setShowCorr(true);
        }
        if (isPhotoPending.length === 0) {
          setIsPhotoPendingFlag(true);
          videoRefElement.current!.hidden = true;
          uploadedPhotoRefElement.current!.hidden = false;
          turnOfCamera && turnOfCamera.getVideoTracks()[0].stop();
          setShowRetake(true);
        } else {
          uploadedPhotoRefElement.current!.hidden = true;
          turnOnCamera();
        }
        if (penDoc.length > 0) {
          if (penDoc[0].Count === 0 && signatureObj.iscropped === true) {
            // const sendDataObjForQC = {
            //     "applicationid": GlobalStore.applicationID
            // }
            // ASendApplicationForQC(postQCData, sendDataObjForQC);
          } else {
            // const appTicketObj = {
            //     applicationid: GlobalStore.applicationID,
            //     clientprimarydetailid: parseInt(GlobalStore.clientPrimaryDetailId) || 0,
            //     stageinfoid: 6,
            // };
            // AcreateApplicationTicket(applicationTicketforDocuments, appTicketObj);
          }
        }
        const mandPenDoc = penDoc.filter(
          (x: any) =>
            // x.mandatory === true && x.documentcategory !== "Photograph"
            (x.Mandatory === true && x.DocumentCategory === "Photograph") ||
            (x.Mandatory === true && x.DocumentCategory === "Signature")
        );

        setPendingDocObj(
          mandPenDoc.filter(
            (y: any) => y.DocumentCategory !== "In Person Verification"
          )
        );
        if (GlobalStore.isDigiLocker) {
          setPendingDocObj(
            mandPenDoc.filter(
              (y: any) => y.DocumentCategory !== "Address Proof Permanent"
            )
          );
        }
      } else {
        // setErrCode(164)
        gtmService({
          action: "GetDocumentDetails",
          label: "ERROR || ERR122-S",
        });
      }
    }
  };

  const onPhotographUpload = (
    val: any,
    fileName: string,
    id: string,
    type: string
  ) => {
    setIsLoading(true);
    // setLoaderSign(true);
    let saveDocumentInfor = [];
    photoObj.imgUrl = val!.split(",")[1];
    setPhotoObj(photoObj);
    setPhotoBase64(val!.split(",")[1]);
    setPanButDisable(false);
    const modifiedBy = window.sessionStorage.getItem('empCode')
    let uploadObj = {
      applicationid: GlobalStore.applicationID,
      base64document: val!.split(",")[1],
      filename: fileName,
      panNo: GlobalStore?.personaldetails.pan,
      ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
    };
    let savePhotoObj = {
      documentCategoryId: photoObj.documentCategoryId?.toString(),
      documentId: photoObj.documentId?.toString(),
      documentexpirydate: "",
      fileName: fileName,
      isfilecropped: true,
      mimeType:
        photoObj?.mimeType && photoObj?.mimeType !== ""
          ? photoObj?.mimeType
          : "image/jpeg",
      panno: GlobalStore.personaldetails.pan,
      personaldetailsid: "0",
      autoqc: autoQc,
      iskycdocument: false,
      isWatsappFlag: true,
    };
    saveDocumentInfor.push(savePhotoObj);
    const saveObj = {
      applicationId: GlobalStore.applicationID,
      clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
      documentInfo: saveDocumentInfor,
      leadId: GlobalStore.leadId,
      // objUTM_Info: objUTM_Info,
    };
    AUploadDocument(
      (res: any) => getFetchResponse(res, fileName),
      uploadObj,
      () => { },
      saveObj
    );
    const ipvObj = {
      leadid: GlobalStore.leadId,
      clientprimarydetailid: GlobalStore.clientPrimaryDetailId,
      applicationid: GlobalStore.applicationID,
      placeofDeclaration: "mumbai",
      empName: "diy user",
      designation: "online rm",
      branch: "mumbai",
      empCode: "0",
      organization: "Nuvama Wealth & investment Ltd",
      organizationCode: "2",
      // geo_location: location,
      latitude: location.lat,
      longitude: location.long,
      ipaddress: "192.168.200.80",
      source: "DocVerification",
      createdBy: parseInt(userId),
    };
    ASaveIPVerificationDetails(
      (res: any) => iPVerificationSaved(res, ipvObj),
      ipvObj
    );
  };
  const HandleNewSDKSelfieRes = (data: any) => {
    if (data && data.errMsg) {
      setBrowserPermission(true);
    } else if (data.is_valid == "1" && data.Latitude && data.Longitude) {
      setIsLoading(true);
      setIsNewPhoto(true);
      const new_File = new File(
        [Blob as unknown as BlobPart],
        "personalPhoto.jpeg",
        {
          type: "image/jpeg",
          lastModified: Date.now(),
        }
      );

      uploadedPhotoRefElement.current!.hidden = false;
      let base64 = data?.cropped_image;
      photoObj.imgUrl = `data:image/jpeg;base64, ${base64}`;
      setPhotoObj(photoObj);
      setPhotoBase64(base64);
      // data.Country="ID";

      if (data?.Country && data?.Country.toLowerCase() == "india") {
        setLiveLocationCheck({
          ...liveLocationCheck,
          checkLocation: false,
          checkPhotoLiveness: false,
        });

        if (base64?.toString()) {
          let saveDocumentInfor = [];
          let savePhotoObj = {
            documentCategoryId: photoObj.documentCategoryId?.toString(),
            documentId: photoObj.documentId?.toString(),
            documentexpirydate: "",
            fileName: new_File.name,
            isfilecropped: true,
            mimeType:
              photoObj?.mimeType && photoObj?.mimeType !== ""
                ? photoObj?.mimeType
                : "image/jpeg",
            panno: GlobalStore.personaldetails.pan,
            personaldetailsid: "0",
            autoqc: autoQc,
            iskycdocument: false,
            isWatsappFlag: true,
          };
          saveDocumentInfor.push(savePhotoObj);
          const modifiedBy = window.sessionStorage.getItem('empCode')
          const saveObj = {
            applicationId: GlobalStore.applicationID,
            clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
            documentInfo: saveDocumentInfor,
            leadId: GlobalStore.leadId,
            // objUTM_Info: objUTM_Info,
          };
          let uploadObj = {
            applicationid: GlobalStore.applicationID,
            base64document: base64,
            filename: new_File.name,
            panNo: GlobalStore?.personaldetails.pan,
            ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
          };
          setIsLoading(true);
          setLoaderSign(true);

          // ACheckPhotoLiveness(
          //   (res: any) => getExtractPhotoLiveness(res),
          //   base64,
          //   GlobalStore.leadId
          // );

          AUploadDocument(
            (res: any) => getFetchResponse(res, new_File.name),
            uploadObj,
            () => { },
            saveObj
          );
          if (
            data?.Latitude !== null &&
            data?.Longitude !== null &&
            data?.Latitude !== undefined &&
            data?.Longitude !== undefined &&
            ((data?.Latitude !== "" && data?.Longitude !== "") ||
              (data?.Latitude !== 0 && data?.Longitude !== 0))
          ) {
            const ipvObj = {
              leadid: GlobalStore.leadId,
              clientprimarydetailid: GlobalStore.clientPrimaryDetailId,
              applicationid: GlobalStore.applicationID,
              placeofDeclaration: "mumbai",
              empName: "diy user",
              designation: "online rm",
              branch: "mumbai",
              empCode: "0",
              organization: "Nuvama Wealth & investment Ltd",
              organizationCode: "2",
              // geo_location: location,
              latitude: data.Latitude,
              longitude: data.Longitude,
              ipaddress: "192.168.200.80",
              source: "DocVerification",
              createdBy: parseInt(userId),
              geoLocationCity: data?.City,
              geoLocationCountry: data?.Country
            };
            ASaveIPVerificationDetails(
              (res: any) => iPVerificationSaved(res, ipvObj),
              ipvObj
            );
          } else {
            if (
              GlobalStore?.location !== null &&
              GlobalStore?.location !== undefined &&
              GlobalStore?.location?.lat !== null &&
              GlobalStore?.location?.lat !== undefined &&
              GlobalStore?.location?.lat !== "" &&
              GlobalStore?.location?.long !== null &&
              GlobalStore?.location?.long !== undefined &&
              GlobalStore?.location?.long !== ""
            ) {
              const ipvObj = {
                leadid: GlobalStore.leadId,
                clientprimarydetailid: GlobalStore.clientPrimaryDetailId,
                applicationid: GlobalStore.applicationID,
                placeofDeclaration: "mumbai",
                empName: "diy user",
                designation: "online rm",
                branch: "mumbai",
                empCode: "0",
                organization: "Nuvama Wealth & investment Ltd",
                organizationCode: "2",
                // geo_location: location,
                latitude: GlobalStore?.location?.lat,
                longitude: GlobalStore?.location?.long,
                ipaddress: "192.168.200.80",
                source: "DocVerification",
                createdBy: parseInt(userId),
              };
              ASaveIPVerificationDetails(
                (res: any) => iPVerificationSaved(res, ipvObj),
                ipvObj
              );
            }
            // else {
            //   setErrCode(
            //     errCode
            //       ? errCode
            //       : " " +
            //           "Oops, you are not in permitted range of account opening as per regulatory guidelines."
            //   );
            // }
          }
        }
      } else {
        setLiveLocationCheck({
          ...liveLocationCheck,
          checkLocation: true,
        });

        setErrCode(
          errCode
            ? errCode
            : "" +
            "Oops, you are not in permitted range of account opening as per regulatory guidelines."
        );
      }
      setIsLoading(false);
    }
  };

  const getscreenShotURL = async (blob: Blob) => {
    const new_File = new File([blob as BlobPart], "personalPhoto.jpeg", {
      type: "image/jpeg",
      lastModified: Date.now(),
    });
    if (new_File.size > 50000000) {
      alert("video size exceeds maximum limit. Please upload it again");
      return false;
    }
    if (new_File.size < 1000) {
      alert("video size should be greater than 1KB. Please upload it again");
      return false;
    }
    const fileReader = new FileReader();
    fileReader.onload = function (e) {
      let base64 = (e.target && e.target.result)?.toString();
      photoObj.imgUrl = "";
      setPhotoObj(photoObj);
      setPhotoBase64(base64!.split(",")[1]);
      if (base64?.toString()) {
        const modifiedBy = window.sessionStorage.getItem('empCode')
        let uploadObj = {
          applicationid: GlobalStore.applicationID,
          base64document: base64!.split(",")[1],
          filename: new_File.name,
          panNo: GlobalStore?.personaldetails.pan,
          ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
        };
        setIsLoading(true);
        setLoaderSign(true);

        ACheckPhotoLiveness(
          (res: any) => getExtractPhotoLiveness(res),
          base64!.split(",")[1],
          GlobalStore.leadId
        );
        AUploadDocument(
          (res: any) => getFetchResponse(res, new_File.name),
          uploadObj
        );
        const ipvObj = {
          leadid: GlobalStore.leadId,
          clientprimarydetailid: GlobalStore.clientPrimaryDetailId,
          applicationid: GlobalStore.applicationID,
          placeofDeclaration: "mumbai",
          empName: "diy user",
          designation: "online rm",
          branch: "mumbai",
          empCode: "0",
          organization: "Nuvama Wealth & investment Ltd",
          organizationCode: "2",
          // geo_location: location,
          latitude: location.lat,
          longitude: location.long,
          ipaddress: "192.168.200.80",
          source: "DocVerification",
          createdBy: parseInt(userId),
        };
        ASaveIPVerificationDetails(
          (res: any) => iPVerificationSaved(res, ipvObj),
          ipvObj
        );
      }
    };
    fileReader.readAsDataURL(new_File);
  };

  const capturePhoto = () => {
    if (
      location !== "" &&
      location !== undefined &&
      location.lat !== "" &&
      location.lat !== undefined &&
      location.long !== "" &&
      location.long !== undefined
    ) {
      setIsLoading(true);
      setIsNewPhoto(true);
      setShowRetake(true);
      showPhotoPreview(true);
      let canvasPic: HTMLCanvasElement = document.getElementById(
        "capture"
      ) as HTMLCanvasElement;
      let videoPic: HTMLVideoElement = document.getElementById(
        "videoPersonal"
      ) as HTMLVideoElement;
      captureScreenShot(canvasPic, videoPic, getscreenShotURL);
      turnOfCamera && turnOfCamera.getVideoTracks()[0].stop();
    } else {
      setBrowserPermission(true);
    }
  };

  function captureScreenShot(
    canvas: HTMLCanvasElement,
    video: HTMLVideoElement,
    callback: CallableFunction
  ) {
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas
      .getContext("2d")!
      .drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
    canvas.toBlob((blob) => {
      callback(blob);
    });
  }

  const retakePhoto = () => {
    if (
      location !== undefined &&
      location !== "" &&
      location.lat !== "" &&
      location.lat !== undefined &&
      location.long !== "" &&
      location.long !== undefined
    ) {
      setIsNewPhoto(false);
      turnOnCamera();
      showPhotoPreview(false);
      setShowRetake(false);
      setIsPhotoPendingFlag(false);
      videoRefElement.current!.hidden = false;
      uploadedPhotoRefElement.current!.hidden = true;
    } else {
      setBrowserPermission(true);
    }
  };

  const iPVerificationSaved = async (res: any, ipvObj: any) => {
    if (!res || res.error) {
      setErrCode(errCode + res.error);
      gtmService({
        action: "SaveIpverificationDetails",
        label: "ERROR || ERR143",
      });
      setIsLoading(false);
    } else {
      setIsLoading(false);
      setLoaderSign(false);
      gtmService({
        action: "SaveIpverificationDetails",
        label: "ERROR || ERR143-S",
      });
    }
  };
  const showGuideText = (idObj: any) => {
    let showText: boolean = false;
    if (
      idObj?.DocumentCategoryId == photographCategoryId ||
      idObj?.DocumentCategoryId == signatureCategoryId
    ) {
      showText = true;
    }
    return showText;
  };
  const setSamplePopupups = (idObj: any) => {
    if (idObj?.DocumentCategoryId == signatureCategoryId) {
      setShowPhotoPopup(false);
      setShowPhotoMobilePopup(false);
      if (DeviceContext()?.isMobile) {
        setShowSignatureMobilePopup(true);
      } else setShowSignaturePopup(true);
    } else if (idObj?.DocumentCategoryId == photographCategoryId) {
      setShowSignaturePopup(false);
      setShowSignatureMobilePopup(false);
      if (DeviceContext()?.isMobile) {
        setShowPhotoMobilePopup(true);
      } else setShowPhotoPopup(true);
    }
  };
  const getExtractPhotoLiveness = (res: any) => {
    if (!res || res.error) {
      // setErrCode("116 - Error in fetching Pan details from our system.");
      // setErrCode(errorMessage.panDetailsFailed);
      if (errCode !== res.error) setErrCode(errCode ? errCode : "" + res.error);
      setPhotoErrorMsg("");
      setLoaderSign(false);
      setLiveLocationCheck({
        ...liveLocationCheck,
        checkPhotoLiveness: true,
      });
      setIsLoading(false);
      gtmService({ action: "checkPhotoLiveness", label: "ERROR || ERR998" });
    } else {
      if (res.data && res.data.IsLive) {
        setPhotoErrorMsg(res.data.Message);
        liveLocationCheck.checkPhotoLiveness = false;
        setLiveLocationCheck({
          ...liveLocationCheck,
          checkPhotoLiveness: false,
        });
      } else if (!res.data.IsLive) {
        setLiveLocationCheck({
          ...liveLocationCheck,
          checkPhotoLiveness: true,
        });
        setPhotoErrorMsg(res.data.Message);
      }
      setIsLoading(false);
      setLoaderSign(false);
    }
  };

  const getFetchResponse = (res: any, fileName: string) => {
    if (!res || res.error) {
      // setErrCode("1361- Error in uploading the file.");
      setErrCode(errCode + res.error);
      gtmService({ action: "UploadDocumentToS3", label: "ERROR || ERR139" });
      setIsLoading(false);
    } else {
      if (res.data) {
        setIsLoading(false);
        // photoObj.fileName = res.data.Guid;
        // photoObj.mimeType = res.data.Guid.split(".")[1];
        if (photoBase64 !== undefined && panBase64 !== undefined) {
          // setErrCode(errCode);
        }
      } else {
        setErrCode(errCode + res.error);
        gtmService({
          action: "UploadDocumentToS3",
          label: "ERROR || ERR139-S",
        });
      }
    }
  };
  const onRemovePhotoObj = () => {
    setPhotoObj((photoObj) => {
      photoObj.base64 = "";
      photoObj.imgUrl = "";
      return photoObj;
    });
  };
  function onRemove(doc: any, docType: string) {
    if (docType === "panObj") {
      setPanObj((panObj) => {
        panObj.base64 = "";
        panObj.imgUrl = "";
        return panObj;
      });
      setPanBase64("");
      setPanButDisable(true);
    } else if (docType === "permAddressObj") {
      permAddressObj.base64 = "";
      permAddressObj.imgUrl = "";
      setPermAddressObj(permAddressObj);
      setPermAddButDisable(true);
    }
  }
  function onPanDocUploadComplete(
    val: any,
    fileName: string,
    id: string,
    type: string
  ) {
    const modifiedBy = window.sessionStorage.getItem('empCode')
    setIsLoading(true);
    setErrCode("");
    setPanObj((panObj) => {
      panObj.imgUrl = "";
      return panObj;
    });
    setPanBase64(val!.split(",")[1]);
    setPanButDisable(false);
    let uploadObj = {
      applicationid: GlobalStore.applicationID,
      base64document: val!.split(",")[1],
      filename: fileName,
      panNo: GlobalStore?.personaldetails.pan,
      ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
    };
    const panOCR = {
      applicationid: GlobalStore.applicationID,
      base64document: val!.split(",")[1],
      documentcategory: "PAN Card",
      documentid: panObj.documentId,
      source: DIY,
    };

    /*
 if (
          clientPartialDetails_ao.pan !==
            res.data.result.extraction_output.id_number &&
          moment(clientPartialDetails_ao.birthDate).format("YYYY-MM-DD") !==
            res.data.result.extraction_output.date_of_birth
        ) {
          setIsPanAndDobMatch(false);
          setErrCode(errorMessage.imgNotMatchWithPan);
          setPanCardError(errorMessage.imgNotMatchWithPan);
        } else {
          setIsPanAndDobMatch(true);
          setPanCardError("");
          setErrCode("");
        }
    */
    let saveDetails: any[] = [];
    let savePanObj = {
      documentCategoryId: panObj.documentCategoryId?.toString(),
      documentId: panObj.documentId?.toString(),
      documentexpirydate: "",
      fileName: panName || panObj.fileName,
      isfilecropped: true,
      mimeType: getMimeType(val!.split(",")[1]),
      panno: GlobalStore.personaldetails.pan,
      isWatsappFlag: panObj.isWatsappFlag,
      personaldetailsid: "0",
      autoqc: false,
    };
    //let autoQc: boolean = false;
    AextractPan((res: any) => {
      if (!res || res.error) {
        gtmService({ action: "UploadDocumentToS3", label: "ERROR || ERR140" });

        if (res?.data?.error) {
          setErrCode(res?.data?.error);
          setIsLoading(false);
          // gtmService({
          //   action: "ExtractDocumentData",
          //   label: "ERROR || ERR134-E",
          // });
        } else {
          setErrCode(res.error);
        }
        setIsLoading(false);
      } else {
        if (res.data) {
          if (res?.data?.error) {
            setErrCode(res?.data?.error);
            let panCopy = { ...panObj };
            panCopy.id = id;
            panCopy.disable = false;
            panCopy.uploadPer = 100;
            panCopy.showFile = false;
            panCopy.hideProgress = false;
            panCopy.fileName = fileName;
            panCopy.mimeType = type;
            setPanObj(panCopy);
            setPanButDisable(true);
            setIsLoading(false);
            // gtmService({
            //   action: "ExtractDocumentData",
            //   label: "ERROR || ERR134-E",
            // });
          } else {
            setPanButDisable(false);
            const clientPartialDetails_ao = JSON.parse(
              window.localStorage.getItem("clientPartialDetails_ao") || "{}"
            );
            if (
              false
              // clientPartialDetails_ao.pan !==
              // res.data.result.extraction_output.id_number
            ) {
              savePanObj.autoqc = false;
              saveDetails.push(savePanObj);
              const saveObj = {
                applicationId: GlobalStore.applicationID,
                clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
                documentInfo: saveDetails,
                leadId: GlobalStore.leadId,
                // objUTM_Info: objUTM_Info,
              };
              AUploadDocument(
                (res: any) => {
                  if (!res || res.error) {
                    mixpanelService({
                      event: mixpanelEvents.ERROR_TRIGGERED,
                      screen_name: getScreenName(window.location.pathname),
                      error_object: res.error,
                    });
                  }
                  getUploadRes(res, id, val, fileName);
                },
                uploadObj,
                (event: ProgressEvent) =>
                  onUploadProgress(event, id, fileName, type),
                saveObj
              );
              // setIsPanAndDobMatch(false);
              // setErrCode(errorMessage.imgNotMatchWithPan);
              // setPanCardError(errorMessage.imgNotMatchWithPan);
            } else {
              savePanObj.autoqc = false;
              saveDetails.push(savePanObj);
              const saveObj = {
                applicationId: GlobalStore.applicationID,
                clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
                documentInfo: saveDetails,
                leadId: GlobalStore.leadId,
                // objUTM_Info: objUTM_Info,
              };
              if (shouldDisable()) {
                setErrCode("Account is already submitted.");
              } else {
                AUploadDocument(
                  (res: any) => {
                    if (!res || res.error) {
                      mixpanelService({
                        event: mixpanelEvents.ERROR_TRIGGERED,
                        screen_name: getScreenName(window.location.pathname),
                        error_object: res.error,
                      });
                    }
                    getUploadRes(res, id, val, fileName);
                  },
                  uploadObj,
                  (event: ProgressEvent) =>
                    onUploadProgress(event, id, fileName, type),
                  saveObj
                );
              }
              // setIsPanAndDobMatch(true);
              // setPanCardError("");
              // setErrCode("");
            }
          }
        }
      }
    }, panOCR);
  }

  function onFirstBankDocUploadComplete(
    val: any,
    fileName: string,
    id: string,
    type: string
  ) {
    setIsLoading(true);
    firstBankObj.imgUrl = "";
    setFirstBankObj(firstBankObj);
    const modifiedBy = window.sessionStorage.getItem('empCode')
    let uploadObj = {
      applicationid: GlobalStore.applicationID,
      base64document: val!.split(",")[1],
      filename: fileName,
      panNo: GlobalStore?.personaldetails.pan,
      ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
    };
    const savebankDetails = [];
    let firstBanObj = {
      documentCategoryId: firstBankObj.documentCategoryId?.toString(),
      documentId: firstBankObj.documentId?.toString(),
      documentexpirydate: "",
      fileName: fileName,
      isfilecropped: true,
      mimeType: getMimeType(val),
      panno: GlobalStore.personaldetails.pan,
      isWatsappFlag: firstBankObj.isWatsappFlag,
      personaldetailsid: "0",
      autoqc: false,
    };
    savebankDetails.push(firstBanObj);
    const saveObj = {
      applicationId: GlobalStore.applicationID,
      clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
      documentInfo: savebankDetails,
      leadId: GlobalStore.leadId,
      // objUTM_Info: objUTM_Info,
    };
    setErrCode("");
    if (shouldDisable()) {
      setErrCode("Account is already submitted.");
    } else {
      AUploadDocument(
        (res: any) => {
          if (!res || res.error) {
            mixpanelService({
              event: mixpanelEvents.ERROR_TRIGGERED,
              screen_name: getScreenName(window.location.pathname),
              error_object: res.error,
            });
          }
          getUploadRes(res, id, val, fileName);
        },
        uploadObj,
        (event: ProgressEvent) => onUploadProgress(event, id, fileName, type),
        saveObj
      );
    }
  }

  function onSecondBankDocUploadComplete(
    val: any,
    fileName: string,
    id: string,
    type: string
  ) {
    setIsLoading(true);
    secondBankObj.imgUrl = "";
    setSecondBankObj(secondBankObj);
    const modifiedBy = window.sessionStorage.getItem('empCode')
    let uploadObj = {
      applicationid: GlobalStore.applicationID,
      base64document: val!.split(",")[1],
      filename: fileName,
      panNo: GlobalStore?.personaldetails.pan,
      ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
    };
    const savebankDetails = [];
    let secondBanObj = {
      documentCategoryId: secondBankObj.documentCategoryId?.toString(),
      documentId: secondBankObj.documentId?.toString(),
      documentexpirydate: "",
      fileName: fileName,
      isfilecropped: true,
      mimeType: getMimeType(val),
      panno: GlobalStore.personaldetails.pan,
      isWatsappFlag: secondBankObj.isWatsappFlag,
      personaldetailsid: "0",
      autoqc: false,
    };
    savebankDetails.push(secondBanObj);
    const saveObj = {
      applicationId: GlobalStore.applicationID,
      clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
      documentInfo: savebankDetails,
      leadId: GlobalStore.leadId,
      // objUTM_Info: objUTM_Info,
    };
    AUploadDocument(
      (res: any) => {
        if (!res || res.error) {
          mixpanelService({
            event: mixpanelEvents.ERROR_TRIGGERED,
            screen_name: getScreenName(window.location.pathname),
            error_object: res.error,
          });
        }
        getUploadRes(res, id, val, fileName);
      },
      uploadObj,
      (event: ProgressEvent) => onUploadProgress(event, id, fileName, type),
      saveObj
    );
  }

  function onThirdBankDocUploadComplete(
    val: any,
    fileName: string,
    id: string,
    type: string
  ) {
    setIsLoading(true);
    thirdBankObj.imgUrl = "";
    setThirdBankObj(thirdBankObj);
    const savebankDetails = [];
    let thirdBank = {
      documentCategoryId: thirdBankObj.documentCategoryId?.toString(),
      documentId: thirdBankObj.documentId?.toString(),
      documentexpirydate: "",
      fileName: fileName,
      isfilecropped: true,
      mimeType: getMimeType(val),
      panno: GlobalStore.personaldetails.pan,
      isWatsappFlag: thirdBankObj.isWatsappFlag,
      personaldetailsid: "0",
      autoqc: false,
    };
    savebankDetails.push(thirdBank);
    const modifiedBy = window.sessionStorage.getItem('empCode')
    const saveObj = {
      applicationId: GlobalStore.applicationID,
      clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
      documentInfo: savebankDetails,
      leadId: GlobalStore.leadId,
      // objUTM_Info: objUTM_Info,
    };
    let uploadObj = {
      applicationid: GlobalStore.applicationID,
      base64document: val!.split(",")[1],
      filename: fileName,
      panNo: GlobalStore?.personaldetails.pan,
      ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
    };
    AUploadDocument(
      (res: any) => {
        if (!res || res.error) {
          mixpanelService({
            event: mixpanelEvents.ERROR_TRIGGERED,
            screen_name: getScreenName(window.location.pathname),
            error_object: res.error,
          });
        }
        getUploadRes(res, id, val, fileName);
      },
      uploadObj,
      (event: ProgressEvent) => onUploadProgress(event, id, fileName, type),
      saveObj
    );
  }

  function onFourthBankDocUploadComplete(
    val: any,
    fileName: string,
    id: string,
    type: string
  ) {
    setIsLoading(true);
    fourthBankObj.imgUrl = "";
    setFourthBankObj(fourthBankObj);
    const modifiedBy = window.sessionStorage.getItem('empCode')
    let uploadObj = {
      applicationid: GlobalStore.applicationID,
      base64document: val!.split(",")[1],
      filename: fileName,
      panNo: GlobalStore?.personaldetails.pan,
      ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
    };
    const savebankDetails = [];
    let foruthBank = {
      documentCategoryId: fourthBankObj.documentCategoryId?.toString(),
      documentId: fourthBankObj.documentId?.toString(),
      documentexpirydate: "",
      fileName: fileName,
      isfilecropped: true,
      mimeType: getMimeType(val),
      panno: GlobalStore.personaldetails.pan,
      isWatsappFlag: fourthBankObj.isWatsappFlag,
      personaldetailsid: "0",
      autoqc: false,
    };
    savebankDetails.push(foruthBank);
    const saveObj = {
      applicationId: GlobalStore.applicationID,
      clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
      documentInfo: savebankDetails,
      leadId: GlobalStore.leadId,
      // objUTM_Info: objUTM_Info,
    };
    AUploadDocument(
      (res: any) => {
        if (!res || res.error) {
          mixpanelService({
            event: mixpanelEvents.ERROR_TRIGGERED,
            screen_name: getScreenName(window.location.pathname),
            error_object: res.error,
          });
        }
        getUploadRes(res, id, val, fileName);
      },
      uploadObj,
      (event: ProgressEvent) => onUploadProgress(event, id, fileName, type),
      saveObj
    );
  }

  function onFifthBankDocUploadComplete(
    val: any,
    fileName: string,
    id: string,
    type: string
  ) {
    setIsLoading(true);
    fifthBankObj.imgUrl = "";
    setFifthBankObj(fifthBankObj);
    const modifiedBy = window.sessionStorage.getItem('empCode')
    let uploadObj = {
      applicationid: GlobalStore.applicationID,
      base64document: val!.split(",")[1],
      filename: fileName,
      panNo: GlobalStore?.personaldetails.pan,
      ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
    };
    const savebankDetails = [];
    let saveBank = {
      documentCategoryId: fifthBankObj.documentCategoryId?.toString(),
      documentId: fifthBankObj.documentId?.toString(),
      documentexpirydate: "",
      fileName: fileName,
      isfilecropped: true,
      mimeType: getMimeType(val),
      panno: GlobalStore.personaldetails.pan,
      isWatsappFlag: fifthBankObj.isWatsappFlag,
      personaldetailsid: "0",
      autoqc: false,
    };
    savebankDetails.push(saveBank);
    const saveObj = {
      applicationId: GlobalStore.applicationID,
      clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
      documentInfo: savebankDetails,
      leadId: GlobalStore.leadId,
      // objUTM_Info: objUTM_Info,
    };
    AUploadDocument(
      (res: any) => {
        if (!res || res.error) {
          mixpanelService({
            event: mixpanelEvents.ERROR_TRIGGERED,
            screen_name: getScreenName(window.location.pathname),
            error_object: res.error,
          });
        }
        getUploadRes(res, id, val, fileName);
      },
      uploadObj,
      (event: ProgressEvent) => onUploadProgress(event, id, fileName, type),
      saveObj
    );
  }
  function getMimeType(base64String?: string) {
    // Split the string to get the metadata part before the comma
    if (base64String !== null && base64String !== undefined) {
      const mimeType = base64String.match(/^data:([^;]+);base64,/);

      // Return MIME type if present, otherwise return null
      return mimeType ? mimeType[1] : ".";
    }
    return ".";
  }
  function onFirstPermAddressUploadComplete(
    val: any,
    fileName: string,
    id: string,
    type: string
  ) {
    setIsLoading(true);
    permAddressObj.imgUrl = val;
    permAddressObj.base64 = val!.split(",")[1];
    permAddressObj.fileName = fileName;
    setPermAddressObj(permAddressObj);
    if (fileName.split(".")[1] !== "pdf" && permAddressObj.documentId !== 125) {
      setSecondDoc(true);
      if (
        permAddressObj.documentId === aadhaarDocumnetId ||
        permAddressObj.documentId === corrAadhaarDocumnetId
      ) {
        const aadharObj = {
          applicationid: GlobalStore.applicationID,
          base64document: permAddressObj.base64,
          documentcategory: "Address Proof Permanent",
          documentid: permAddressObj.documentId,
          source: DIY,
        };
        AmaskAadhaar(
          (res: any) => maskedAadhar(res, id, fileName, type),
          aadharObj
        );
      } else {
        const modifiedBy = window.sessionStorage.getItem('empCode')
        let uploadObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          filename: fileName,
          panNo: GlobalStore?.personaldetails.pan,
          ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
        };
        let saveAddressDetails = [];
        let savepermAddressObj = {
          documentCategoryId: permAddressObj.documentCategoryId?.toString(),
          documentId: permAddressObj.documentId?.toString(),
          documentexpirydate: "",
          fileName: fileName,
          isfilecropped: true,
          mimeType: getMimeType(val),
          panno: GlobalStore.personaldetails.pan,
          isWatsappFlag: true,
          personaldetailsid: "0",
          autoqc: false,
          iskycdocument: false,
        };
        saveAddressDetails.push(savepermAddressObj);
        const saveObj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
          documentInfo: saveAddressDetails,
          leadId: GlobalStore.leadId,
          // objUTM_Info: objUTM_Info,
        };
        if (shouldDisable()) {
          setErrCode("Account is already submitted.");
        } else {
          AUploadDocument(
            (res: any) => {
              if (!res || res.error) {
                mixpanelService({
                  event: mixpanelEvents.ERROR_TRIGGERED,
                  screen_name: getScreenName(window.location.pathname),
                  error_object: res.error,
                });
              }
              getUploadRes(res, id, val, fileName);
            },
            uploadObj,
            (event: ProgressEvent) =>
              onUploadProgress(event, id, fileName, type),
            saveObj
          );
        }
      }
    } else {
      // if PDF
      setSecondDoc(false);
      setAnotherFile(false);
      if (
        permAddressObj.documentId === aadhaarDocumnetId ||
        permAddressObj.documentId === corrAadhaarDocumnetId
      ) {
        const aadharObj = {
          applicationid: GlobalStore.applicationID,
          base64document: permAddressObj.base64,
          documentcategory: "Address Proof Permanent",
          documentid: permAddressObj.documentId,
          source: DIY,
        };
        AmaskAadhaar(
          (res: any) => maskedAadhar(res, id, fileName, type),
          aadharObj
        );
      } else {
        const modifiedBy = window.sessionStorage.getItem('empCode')
        let uploadObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          filename: fileName,
          panNo: GlobalStore?.personaldetails.pan,
          ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
        };
        let saveAddressDetails = [];
        let savepermAddressObj = {
          documentCategoryId: permAddressObj.documentCategoryId?.toString(),
          documentId: permAddressObj.documentId?.toString(),
          documentexpirydate: "",
          fileName: fileName,
          isfilecropped: true,
          mimeType: getMimeType(val),
          panno: GlobalStore.personaldetails.pan,
          isWatsappFlag: true,
          personaldetailsid: "0",
          autoqc: false,
          iskycdocument: false,
        };
        saveAddressDetails.push(savepermAddressObj);
        const saveObj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
          documentInfo: saveAddressDetails,
          leadId: GlobalStore.leadId,
          // objUTM_Info: objUTM_Info,
        };
        if (shouldDisable()) {
          setErrCode("Account is already submitted.");
        } else {
          AUploadDocument(
            (res: any) => {
              if (!res || res.error) {
                mixpanelService({
                  event: mixpanelEvents.ERROR_TRIGGERED,
                  screen_name: getScreenName(window.location.pathname),
                  error_object: res.error,
                });
              }
              getUploadRes(res, id, val, fileName);
            },
            uploadObj,
            (event: ProgressEvent) =>
              onUploadProgress(event, id, fileName, type),
            saveObj
          );
        }
      }
    }
  }
  const getUISamplePopups = (addressProodID: any) => {
    switch (addressProodID) {
      case aadhaarDocumnetId:
        return (
          <div>
            <SampleAadharPopup
              showPopup={renderSamplePopups}
              setShowPopup={setRenderSamplePopup}
              parentClassName="aadhar-popuo"
            />
          </div>
        );
      case dlDocumentId:
        return (
          <SampleDrivingLicensePopup
            showPopup={renderSamplePopups}
            setShowPopup={setRenderSamplePopup}
            parentClassName="dl-popup"
          />
        );
      case voterIdDocumentId:
        return (
          <SampleVoterIDPopup
            showPopup={renderSamplePopups}
            setShowPopup={setRenderSamplePopup}
            parentClassName="votreId-popuo"
          />
        );
      case passportDocumnetId:
        return (
          <SamplePassportPopup
            showPopup={renderSamplePopups}
            setShowPopup={setRenderSamplePopup}
            parentClassName="passport-popuo"
          />
        );
    }
  };
  const getUISampleMobilePopups = (addressProodID: any) => {
    switch (addressProodID) {
      case aadhaarDocumnetId:
        return (
          <SampleAadharMobileViewProps
            showPopup={renderSamplePopups}
            setShowPopup={setRenderSamplePopup}
          />
        );
      case dlDocumentId:
        return (
          <SampleSDLMobileViewProps
            showPopup={renderSamplePopups}
            setShowPopup={setRenderSamplePopup}
          />
        );
      case voterIdDocumentId:
        return (
          <SampleVoterIDMobileViewProps
            showPopup={renderSamplePopups}
            setShowPopup={setRenderSamplePopup}
          />
        );
      case passportDocumnetId:
        return (
          <SamplePassportMobileViewProps
            showPopup={renderSamplePopups}
            setShowPopup={setRenderSamplePopup}
          />
        );
    }
  };
  const getUICorrSamplePopups = (addressProodID: any) => {
    switch (addressProodID) {
      case corrAadhaarDocumnetId:
        return (
          <SampleAadharPopup
            showPopup={renderCorrSamplePopups}
            setShowPopup={setRenderCorrSamplePopup}
            parentClassName="corraadhar-popuo"
          />
        );
      case corrDlDocumentId:
        return (
          <SampleDrivingLicensePopup
            showPopup={renderCorrSamplePopups}
            setShowPopup={setRenderCorrSamplePopup}
            parentClassName="corrdl-popup"
          />
        );
      case corrVoterIdDocumentId:
        return (
          <SampleVoterIDPopup
            showPopup={renderCorrSamplePopups}
            setShowPopup={setRenderCorrSamplePopup}
            parentClassName="corrvotreId-popuo"
          />
        );
      case corrPassportDocumnetId:
        return (
          <SamplePassportPopup
            showPopup={renderCorrSamplePopups}
            setShowPopup={setRenderCorrSamplePopup}
            parentClassName="corrpassport-popuo"
          />
        );
    }
  };
  const getUISampleCorrMobilePopups = (addressProodID: any) => {
    switch (addressProodID) {
      case corrAadhaarDocumnetId:
        return (
          <SampleAadharMobileViewProps
            showPopup={renderCorrSamplePopups}
            setShowPopup={setRenderCorrSamplePopup}
          />
        );
      case corrDlDocumentId:
        return (
          <SampleSDLMobileViewProps
            showPopup={renderCorrSamplePopups}
            setShowPopup={setRenderCorrSamplePopup}
          />
        );
      case corrVoterIdDocumentId:
        return (
          <SampleVoterIDMobileViewProps
            showPopup={renderCorrSamplePopups}
            setShowPopup={setRenderCorrSamplePopup}
          />
        );
      case corrPassportDocumnetId:
        return (
          <SamplePassportMobileViewProps
            showPopup={renderCorrSamplePopups}
            setShowPopup={setRenderCorrSamplePopup}
          />
        );
    }
  };
  function onSecondPermAddressUploadComplete(
    val: any,
    fileName: string,
    id: string,
    type: string
  ) {
    setIsLoading(true);
    permSecondAddressObj.imgUrl = "";
    permSecondAddressObj.fileName = fileName;
    permSecondAddressObj.base64 = val!.split(",")[1];
    setPermSecondAddressObj(permSecondAddressObj);
    if (
      fileName.split(".")[1] !== "pdf" &&
      permSecondAddressObj.documentId !== 125
    ) {
      setSecondDoc(true);
      if (
        permAddressObj.documentId === aadhaarDocumnetId ||
        permAddressObj.documentId === corrAadhaarDocumnetId
      ) {
        const aadharObj = {
          applicationid: GlobalStore.applicationID,
          base64document: permSecondAddressObj.base64,
          documentcategory: "Address Proof Permanent",
          documentid: permSecondAddressObj.documentId,
          source: DIY,
        };
        AmaskAadhaar(
          (res: any) => maskedAadhar(res, id, fileName, type),
          aadharObj
        );
      } else {
        const modifiedBy = window.sessionStorage.getItem('empCode')
        const uploadObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          filename: fileName,
          panNo: GlobalStore?.personaldetails.pan,
          ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
        };
        let saveAddressDetails = [];
        let savepermAddressObj = {
          documentCategoryId: permAddressObj.documentCategoryId?.toString(),
          documentId: permAddressObj.documentId?.toString(),
          documentexpirydate: "",
          fileName: fileName,
          isfilecropped: true,
          mimeType: getMimeType(val),
          panno: GlobalStore.personaldetails.pan,
          isWatsappFlag: true,
          personaldetailsid: "0",
          autoqc: false,
          iskycdocument: false,
        };
        saveAddressDetails.push(savepermAddressObj);
        const saveObj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
          documentInfo: saveAddressDetails,
          leadId: GlobalStore.leadId,
          // objUTM_Info: objUTM_Info,
        };
        if (shouldDisable()) {
          setErrCode("Account is already submitted.");
        } else {
          AUploadDocument(
            (res: any) => {
              if (!res || res.error) {
                mixpanelService({
                  event: mixpanelEvents.ERROR_TRIGGERED,
                  screen_name: getScreenName(window.location.pathname),
                  error_object: res.error,
                });
              }
              getUploadRes(res, id, val, fileName);
            },
            uploadObj,
            (event: ProgressEvent) =>
              onUploadProgress(event, id, fileName, type),
            saveObj
          );
        }
      }
    } else {
      setIsLoading(false);
      setSecondDoc(false);
      setAnotherFile(false);
    }
  }

  function onFirstCorrAddressUploadComplete(
    val: any,
    fileName: string,
    id: string,
    type: string
  ) {
    setIsLoading(true);
    corrAddressObj.imgUrl = "";
    corrAddressObj.base64 = val!.split(",")[1];
    corrAddressObj.fileName = fileName;
    setCorrAddressObj(corrAddressObj);
    if (fileName.split(".")[1] !== "pdf" && corrAddressObj.documentId !== 133) {
      setCorrSecondDoc(true);

      if (
        corrAddressObj.documentId === aadhaarDocumnetId ||
        corrAddressObj.documentId === corrAadhaarDocumnetId
      ) {
        const aadharObj = {
          applicationid: GlobalStore.applicationID,
          base64document: corrAddressObj.base64,
          documentcategory: "Corr Address Proof Permanent",
          documentid: corrAddressObj.documentId,
          source: DIY,
        };
        AmaskAadhaar(
          (res: any) => maskedAadhar(res, id, fileName, type),
          aadharObj
        );
      } else {
        const modifiedBy = window.sessionStorage.getItem('empCode')
        let uploadObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          filename: fileName,
          panNo: GlobalStore?.personaldetails.pan,
          ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
        };
        let saveAddressDetails = [];
        let saveCorrAddressObj = {
          documentCategoryId: corrAddressObj.documentCategoryId?.toString(),
          documentId: corrAddressObj.documentId?.toString(),
          documentexpirydate: "",
          fileName: fileName,
          isfilecropped: true,
          mimeType: getMimeType(val),
          panno: GlobalStore.personaldetails.pan,
          isWatsappFlag: true,
          personaldetailsid: "0",
          autoqc: false,
          iskycdocument: false,
        };
        saveAddressDetails.push(saveCorrAddressObj);
        const saveObj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
          documentInfo: saveAddressDetails,
          leadId: GlobalStore.leadId,
          // objUTM_Info: objUTM_Info,
        };
        if (shouldDisable()) {
          setErrCode("Account is already submitted.");
        } else {
          AUploadDocument(
            (res: any) => {
              if (!res || res.error) {
                mixpanelService({
                  event: mixpanelEvents.ERROR_TRIGGERED,
                  screen_name: getScreenName(window.location.pathname),
                  error_object: res.error,
                });
              }
              getUploadRes(res, id, val, fileName);
            },
            uploadObj,
            (event: ProgressEvent) =>
              onUploadProgress(event, id, fileName, type),
            saveObj
          );
        }
      }
    } else {
      // if PDF
      setCorrSecondDoc(false);
      setCorrAnotherFile(false);

      if (
        corrAddressObj.documentId === aadhaarDocumnetId ||
        corrAddressObj.documentId === corrAadhaarDocumnetId
      ) {
        const aadharObj = {
          applicationid: GlobalStore.applicationID,
          base64document: corrAddressObj.base64,
          documentcategory: "Corr Address Proof Permanent",
          documentid: corrAddressObj.documentId,
          source: DIY,
        };
        AmaskAadhaar(
          (res: any) => maskedAadhar(res, id, fileName, type),
          aadharObj
        );
      } else {
        const modifiedBy = window.sessionStorage.getItem('empCode')
        let uploadObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          filename: fileName,
          panNo: GlobalStore?.personaldetails.pan,
          ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
        };
        let saveAddressDetails = [];
        let saveCorrAddressObj = {
          documentCategoryId: corrAddressObj.documentCategoryId?.toString(),
          documentId: corrAddressObj.documentId?.toString(),
          documentexpirydate: "",
          fileName: fileName,
          isfilecropped: true,
          mimeType: getMimeType(val),
          panno: GlobalStore.personaldetails.pan,
          isWatsappFlag: true,
          personaldetailsid: "0",
          autoqc: false,
          iskycdocument: false,
        };
        saveAddressDetails.push(saveCorrAddressObj);
        const saveObj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
          documentInfo: saveAddressDetails,
          leadId: GlobalStore.leadId,
          // objUTM_Info: objUTM_Info,
        };
        if (shouldDisable()) {
          setErrCode("Account is already submitted.");
        } else {
          AUploadDocument(
            (res: any) => {
              if (!res || res.error) {
                mixpanelService({
                  event: mixpanelEvents.ERROR_TRIGGERED,
                  screen_name: getScreenName(window.location.pathname),
                  error_object: res.error,
                });
              }
              getUploadRes(res, id, val, fileName);
            },
            uploadObj,
            (event: ProgressEvent) =>
              onUploadProgress(event, id, fileName, type),
            saveObj
          );
        }
      }
    }
  }

  function onSecondCorrAddressUploadComplete(
    val: any,
    fileName: string,
    id: string,
    type: string
  ) {
    setIsLoading(true);
    corrSecondAddressObj.imgUrl = "";
    corrSecondAddressObj.fileName = fileName;
    corrSecondAddressObj.base64 = val!.split(",")[1];
    setCorrSecondAddressObj(corrSecondAddressObj);
    if (
      fileName.split(".")[1] !== "pdf" &&
      corrSecondAddressObj.documentId !== 133
    ) {
      setCorrSecondDoc(true);
      if (
        corrAddressObj.documentId === aadhaarDocumnetId ||
        corrAddressObj.documentId === corrAadhaarDocumnetId
      ) {
        const aadharObj = {
          applicationid: GlobalStore.applicationID,
          base64document: corrSecondAddressObj.base64,
          documentcategory: "Address Proof Permanent",
          documentid: corrSecondAddressObj.documentId,
          source: DIY,
        };
        AmaskAadhaar(
          (res: any) => maskedAadhar(res, id, fileName, type),
          aadharObj
        );
      } else {
        const modifiedBy = window.sessionStorage.getItem('empCode')
        const uploadObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          filename: fileName,
          panNo: GlobalStore?.personaldetails.pan,
          ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
        };
        let saveAddressDetails = [];
        let saveCorrAddressObj = {
          documentCategoryId: corrAddressObj.documentCategoryId?.toString(),
          documentId: corrAddressObj.documentId?.toString(),
          documentexpirydate: "",
          fileName: fileName,
          isfilecropped: true,
          mimeType: getMimeType(val),
          panno: GlobalStore.personaldetails.pan,
          isWatsappFlag: true,
          personaldetailsid: "0",
          autoqc: false,
          iskycdocument: false,
        };
        saveAddressDetails.push(saveCorrAddressObj);
        const saveObj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
          documentInfo: saveAddressDetails,
          leadId: GlobalStore.leadId,
          // objUTM_Info: objUTM_Info,
        };
        if (shouldDisable()) {
          setErrCode("Account is already submitted.");
        } else {
          AUploadDocument(
            (res: any) => {
              if (!res || res.error) {
                mixpanelService({
                  event: mixpanelEvents.ERROR_TRIGGERED,
                  screen_name: getScreenName(window.location.pathname),
                  error_object: res.error,
                });
              }
              getUploadRes(res, id, val, fileName);
            },
            uploadObj,
            (event: ProgressEvent) =>
              onUploadProgress(event, id, fileName, type),
            saveObj
          );
        }
      }
    } else {
      setCorrSecondDoc(false);
      setCorrAnotherFile(false);
    }
  }

  const maskedAadhar = (
    res: any,
    id: string,
    fileName: string,
    type: string
  ) => {
    if (!res || res.error) {
      // setErrCode("Aadhar number masking failed");
      setIsLoading(false);
      gtmService({ action: "ExtractDocumentData", label: "ERROR || ERR138" });
      mixpanelService({
        event: mixpanelEvents.ERROR_TRIGGERED,
        screen_name: getScreenName(window.location.pathname),
        error_object: res.error,
      });
      if (res.data.error) {
        setErrCode(errCode + "Aadhar Masking failed: " + res.error);
        setIsLoading(false);
      } else {
        setErrCode(errCode + res.error);
      }
    } else if (res.data) {
      if (res.data.error) {
        setErrCode(errCode + "Aadhar Masking failed: " + res.error);
        setIsLoading(false);
        mixpanelService({
          event: mixpanelEvents.ERROR_TRIGGERED,
          screen_name: getScreenName(window.location.pathname),
          error_object: res.data.error,
        });
      } else {
        let saveAddressDetails = [];

        // Masking API returns only JPG images, even if input is PDF.
        const modifiedBy = window.sessionStorage.getItem('empCode')
        let uploadObj: uploadDocObj;
        if (id === "permAddress") {
          if (res.data.result.id_number_found) {
            permAddressObj.base64 = res.data.result.base64_image;
            permAddressObj.mimeType = "image/jpeg";
            permAddressObj.fileName =
              permAddressObj.fileName.split(".")[0] + ".jpg";
            type = "image/jpeg";
            let saveAddressObj = {
              documentCategoryId: permAddressObj.documentCategoryId?.toString(),
              documentId: permAddressObj.documentId?.toString(),
              documentexpirydate: "",
              fileName: permAddressObj.fileName.split(".")[0] + ".jpg",
              isfilecropped: true,
              mimeType: getMimeType(res.data.result.base64_image),
              panno: GlobalStore.personaldetails.pan,
              isWatsappFlag: true,
              personaldetailsid: "0",
              autoqc: false,
              iskycdocument: false,
            };
            saveAddressDetails.push(saveAddressObj);
            setPermAddressObj(permAddressObj);
            setPermAddButDisable(false);
          }

          uploadObj = {
            applicationid: GlobalStore.applicationID,
            base64document: permAddressObj.base64 || "",
            filename: permAddressObj.fileName,
            panNo: GlobalStore?.personaldetails.pan,
            ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
          };
        } else if (id === "permSecondAddress") {
          if (res.data.result.id_number_found) {
            permSecondAddressObj.base64 = res.data.result.base64_image;
            permSecondAddressObj.mimeType = "image/jpeg";
            permSecondAddressObj.fileName =
              permSecondAddressObj.fileName.split(".")[0] + ".jpg";
            type = "image/jpeg";
            setPermSecondAddressObj(permSecondAddressObj);
          }
          let saveAddressObj = {
            documentCategoryId:
              permSecondAddressObj.documentCategoryId?.toString(),
            documentId: permSecondAddressObj.documentId?.toString(),
            documentexpirydate: "",
            fileName: permSecondAddressObj.fileName.split(".")[0] + ".jpg",
            isfilecropped: true,
            mimeType: getMimeType(res.data.result.base64_image),
            panno: GlobalStore.personaldetails.pan,
            isWatsappFlag: true,
            personaldetailsid: "0",
            autoqc: false,
            iskycdocument: false,
          };
          saveAddressDetails.push(saveAddressObj);
          uploadObj = {
            applicationid: GlobalStore.applicationID,
            base64document: permSecondAddressObj.base64 || "",
            filename: permSecondAddressObj.fileName,
            panNo: GlobalStore?.personaldetails.pan,
            ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
          };
        } else if (id === "corrAddress") {
          if (res.data.result.id_number_found) {
            corrAddressObj.base64 = res.data.result.base64_image;
            corrAddressObj.mimeType = "image/jpeg";
            corrAddressObj.fileName =
              corrAddressObj.fileName.split(".")[0] + ".jpg";
            type = "image/jpeg";
            setCorrAddressObj(corrAddressObj);
          }
          let saveAddressObj = {
            documentCategoryId: corrAddressObj.documentCategoryId?.toString(),
            documentId: corrAddressObj.documentId?.toString(),
            documentexpirydate: "",
            fileName: corrAddressObj.fileName.split(".")[0] + ".jpg",
            isfilecropped: true,
            mimeType: getMimeType(res.data.result.base64_image),
            panno: GlobalStore.personaldetails.pan,
            isWatsappFlag: true,
            personaldetailsid: "0",
            autoqc: false,
            iskycdocument: false,
          };
          saveAddressDetails.push(saveAddressObj);
          uploadObj = {
            applicationid: GlobalStore.applicationID,
            base64document: corrAddressObj.base64 || "",
            filename: corrAddressObj.fileName,
            panNo: GlobalStore?.personaldetails.pan,
            ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
          };
        } else {
          if (res.data.result.id_number_found) {
            corrSecondAddressObj.base64 = res.data.result.base64_image;
            corrSecondAddressObj.mimeType = "image/jpeg";
            corrSecondAddressObj.fileName =
              corrSecondAddressObj.fileName.split(".")[0] + ".jpg";
            type = "image/jpeg";
            setCorrSecondAddressObj(corrSecondAddressObj);
          }
          let saveAddressObj = {
            documentCategoryId:
              corrSecondAddressObj.documentCategoryId?.toString(),
            documentId: corrSecondAddressObj.documentId?.toString(),
            documentexpirydate: "",
            fileName: corrSecondAddressObj.fileName.split(".")[0] + ".jpg",
            isfilecropped: true,
            mimeType: getMimeType(res.data.result.base64_image),
            panno: GlobalStore.personaldetails.pan,
            isWatsappFlag: true,
            personaldetailsid: "0",
            autoqc: false,
            iskycdocument: false,
          };
          saveAddressDetails.push(saveAddressObj);
          uploadObj = {
            applicationid: GlobalStore.applicationID,
            base64document: corrSecondAddressObj.base64 || "",
            filename: corrSecondAddressObj.fileName,
            panNo: GlobalStore?.personaldetails.pan,
            ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
          };
        }

        const saveObj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
          documentInfo: saveAddressDetails,
          leadId: GlobalStore.leadId,
          // objUTM_Info: objUTM_Info,
        };
        if (shouldDisable()) {
          setErrCode("Account is already submitted.");
        } else {
          AUploadDocument(
            (res: any) => {
              if (!res || res.error) {
                mixpanelService({
                  event: mixpanelEvents.ERROR_TRIGGERED,
                  screen_name: getScreenName(window.location.pathname),
                  error_object: res.error,
                });
              }
              getUploadRes(
                res,
                id,
                uploadObj.base64document,
                uploadObj.filename
              );
            },
            uploadObj,
            (event: ProgressEvent) =>
              onUploadProgress(event, id, fileName, type),
            saveObj
          );
        }
      }
    } else {
      gtmService({
        action: "ExtractDocumentData",
        label: "ERROR || ERR138-S",
      });
    }
  };

  const getPDFData = (res: any) => {
    if (!res || res.error) {
      // setErrCode(137);
      setErrCode(errCode + res.error);
      gtmService({
        action: "MargeMultipleImagestoPDF",
        label: "ERROR || ERR136",
      });
      setIsLoading(false);
    } else {
      if (res.data) {
        setIsLoading(false);
        setAddressName(res.data.Guid);
        permAddressObj.mimeType = "application/pdf";
        const addressOCR = {
          applicationid: GlobalStore.applicationID,
          base64document: res.data.Mergedimagespdfbase64,
          documentcategory: permAddressObj.documentcategory,
          documentid: permAddressObj.documentId,
          source: DIY,
        };
        setIsLoading(false);
        // if (permAddressObj.documentId === aadhaarDocumnetId) {
        //   setIsLoading(true);
        //   AextractAadhaar(
        //     (res: any) => storeOcrData(res, addressOCR),
        //     addressOCR
        //   );
        // } else if (permAddressObj.documentId === passportDocumnetId) {
        //   setIsLoading(true);
        //   AextractPassport(
        //     (res: any) => storeOcrData(res, addressOCR),
        //     addressOCR
        //   );
        // } else if (permAddressObj.documentId === voterIdDocumentId) {
        //   setIsLoading(true);
        //   AextractVoterid(
        //     (res: any) => storeOcrData(res, addressOCR),
        //     addressOCR
        //   );
        // } else if (permAddressObj.documentId === dlDocumentId) {
        //   setIsLoading(true);
        //   AextractDl((res: any) => storeOcrData(res, addressOCR), addressOCR);
        // }
      } else {
        gtmService({
          action: "MargeMultipleImagestoPDF",
          label: "ERROR || ERR136-S",
        });
      }
    }
  };

  const getCorrPDFData = (res: any) => {
    if (!res || res.error) {
      // setErrCode(137);
      setErrCode(errCode + res.error);
      gtmService({
        action: "MargeMultipleImagestoPDF",
        label: "ERROR || ERR137",
      });
      setIsLoading(false);
    } else {
      if (res.data) {
        setIsLoading(false);
        setCorrAddressName(res.data.Guid);
        corrAddressObj.mimeType = "application/pdf";
        const addressOCR = {
          applicationid: GlobalStore.applicationID,
          base64document: res.data.Mergedimagespdfbase64,
          documentcategory: corrAddressObj.documentcategory,
          documentid: corrAddressObj.documentId,
          source: DIY,
        };
        // if (corrAddressObj.documentId === corrAadhaarDocumnetId) {
        //   setIsLoading(true);
        //   AextractAadhaar(
        //     (res: any) => storeOcrData(res, addressOCR),
        //     addressOCR
        //   );
        // } else if (corrAddressObj.documentId === corrPassportDocumnetId) {
        //   setIsLoading(true);
        //   AextractPassport(
        //     (res: any) => storeOcrData(res, addressOCR),
        //     addressOCR
        //   );
        // } else if (corrAddressObj.documentId === corrVoterIdDocumentId) {
        //   setIsLoading(true);
        //   AextractVoterid(
        //     (res: any) => storeOcrData(res, addressOCR),
        //     addressOCR
        //   );
        // } else if (corrAddressObj.documentId === corrDlDocumentId) {
        //   setIsLoading(true);
        //   AextractDl((res: any) => storeOcrData(res, addressOCR), addressOCR);
        // }
      } else {
        gtmService({
          action: "MargeMultipleImagestoPDF",
          label: "ERROR || ERR137-S",
        });
      }
    }
  };
  function onNomineeUploadComplete(
    val: any,
    fileName: string,
    id: string,
    type: string,
    index: number
  ) {
    let panNo: string = "";
    const clientPartialDetails_ao1 = JSON.parse(
      window.localStorage.getItem("clientPartialDetails_ao") || "{}"
    );
    panNo = clientPartialDetails_ao1.pan;
    const modifiedBy = window.sessionStorage.getItem('empCode')
    switch (id) {
      case "nomFirstPhotoId":
        let fnpext = fileName.split(".").pop();
        let fnpnewfileName = "firstNominee_Photo." + fnpext;
        let nomFirstPhotCopy = [...nomineeFirstObj];
        nomFirstPhotCopy[0].documentCategoryId =
          nomineeDocsIds.nomineeOne.photo.documentCategoryId.toString();
        nomFirstPhotCopy[0].documentId =
          nomineeDocsIds.nomineeOne.photo.documentId;
        nomFirstPhotCopy[0].documentcategory = "Photograph";
        nomFirstPhotCopy[0].imgUrl = val;
        setNomineeFirstObj(nomFirstPhotCopy);
        let nomFirstPhotoObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          filename: fnpnewfileName,
          panNo: GlobalStore?.personaldetails.pan,
          ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
        };
        let saveDocuments = [];
        let saveDocObj = {
          documentcategory: "Photograph",
          documentCategoryId:
            nomineeDocsIds.nomineeOne.photo.documentCategoryId.toString(),
          documentId: nomineeDocsIds.nomineeOne.photo.documentId,
          documentexpirydate: "",
          fileName: fnpnewfileName,
          isfilecropped: true,
          mimeType: getMimeType(val),
          panno:
            panNo && panNo !== "" ? panNo : GlobalStore.personaldetails.pan,
          isWatsappFlag: true,
          personaldetailsid: "0",
          autoqc: false,
          iskycdocument: false,
        };
        saveDocuments.push(saveDocObj);

        const saveObj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
          documentInfo: saveDocuments,
          leadId: GlobalStore.leadId,

          // objUTM_Info: objUTM_Info,
        };
        if (shouldDisable()) {
          setErrCode("Account is already submitted.");
        } else {
          AUploadDocument(
            (res: any) => {
              if (!res || res.error) {
                mixpanelService({
                  event: mixpanelEvents.ERROR_TRIGGERED,
                  screen_name: getScreenName(window.location.pathname),
                  error_object: res.error,
                });
              }
              getUploadRes(res, id, val, fileName);
            },
            nomFirstPhotoObj,
            (event: ProgressEvent) =>
              onUploadProgress(event, id, fileName, type),
            saveObj
          );
        }
        break;
      case "nomFirstSignature":
        let fnsext = fileName.split(".").pop();
        let fnsnewfileName = "firstNominee_Signature." + fnsext;
        let nomFirstSignatureCopy = [...nomineeFirstObj];
        nomFirstSignatureCopy[1].documentCategoryId =
          nomineeDocsIds.nomineeOne.signature.documentCategoryId.toString();
        nomFirstSignatureCopy[1].documentId =
          nomineeDocsIds.nomineeOne.signature.documentId;
        nomFirstSignatureCopy[1].documentcategory = "Signature";
        nomFirstSignatureCopy[1].imgUrl = val;
        setNomineeFirstObj(nomFirstSignatureCopy);
        let nomFirstSignatureObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          filename: fnsnewfileName,
          panNo: GlobalStore?.personaldetails.pan,
          ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
        };

        let saveTwoDocuments = [];
        let saveTwpDocObj = {
          documentcategory: "Signature",
          documentCategoryId:
            nomineeDocsIds.nomineeOne.signature.documentCategoryId.toString(),
          documentId: nomineeDocsIds.nomineeOne.signature.documentId,
          documentexpirydate: "",
          fileName: fnsnewfileName,
          isfilecropped: true,
          mimeType: getMimeType(val),
          panno:
            panNo && panNo !== "" ? panNo : GlobalStore.personaldetails.pan,
          isWatsappFlag: true,
          personaldetailsid: "0",
          autoqc: false,
          iskycdocument: false,
        };
        saveTwoDocuments.push(saveTwpDocObj);

        const savetwoObj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
          documentInfo: saveTwoDocuments,
          leadId: GlobalStore.leadId,
          // objUTM_Info: objUTM_Info,
        };
        if (shouldDisable()) {
          setErrCode("Account is already submitted.");
        } else {
          AUploadDocument(
            (res: any) => {
              if (!res || res.error) {
                mixpanelService({
                  event: mixpanelEvents.ERROR_TRIGGERED,
                  screen_name: getScreenName(window.location.pathname),
                  error_object: res.error,
                });
              }
              getUploadRes(res, id, val, fileName);
            },
            nomFirstSignatureObj,
            (event: ProgressEvent) =>
              onUploadProgress(event, id, fileName, type),
            savetwoObj
          );
        }
        break;
      case "nomSecondPhotoId":
        let snpext = fileName.split(".").pop();
        let snpnewfileName = "secondNominee_Photo." + snpext;
        let nomSecondPhotoCopy = [...nomineeSecondObj];
        nomSecondPhotoCopy[0].documentCategoryId =
          nomineeDocsIds.nomineeTwo.photo.documentCategoryId.toString();
        nomSecondPhotoCopy[0].documentId =
          nomineeDocsIds.nomineeTwo.photo.documentId;
        nomSecondPhotoCopy[0].documentcategory = "Photograph";
        nomSecondPhotoCopy[0].imgUrl = val;
        setNomineeSecondObj(nomSecondPhotoCopy);
        let nomSecondPhotoObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          filename: snpnewfileName,
          panNo: GlobalStore?.personaldetails.pan,
          ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
        };

        let saveThreeDocuments = [];
        let saveThreeDocObj = {
          documentcategory: "Photograph",
          documentCategoryId:
            nomineeDocsIds.nomineeTwo.photo.documentCategoryId.toString(),
          documentId: nomineeDocsIds.nomineeTwo.photo.documentId,
          documentexpirydate: "",
          fileName: snpnewfileName,
          isfilecropped: true,
          mimeType: getMimeType(val),
          panno:
            panNo && panNo !== "" ? panNo : GlobalStore.personaldetails.pan,
          isWatsappFlag: true,
          personaldetailsid: "0",
          autoqc: false,
          iskycdocument: false,
        };
        saveThreeDocuments.push(saveThreeDocObj);

        const savethreeObj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
          documentInfo: saveThreeDocuments,
          leadId: GlobalStore.leadId,
          // objUTM_Info: objUTM_Info,
        };
        if (shouldDisable()) {
          setErrCode("Account is already submitted.");
        } else {
          AUploadDocument(
            (res: any) => {
              if (!res || res.error) {
                mixpanelService({
                  event: mixpanelEvents.ERROR_TRIGGERED,
                  screen_name: getScreenName(window.location.pathname),
                  error_object: res.error,
                });
              }
              getUploadRes(res, id, val, fileName);
            },
            nomSecondPhotoObj,
            (event: ProgressEvent) =>
              onUploadProgress(event, id, fileName, type),
            savethreeObj
          );
        }
        break;
      case "nomSecondSignature":
        let nssext = fileName.split(".").pop();
        let nssnewfileName = "secondNominee_Signature." + nssext;
        let nomSecondSignatureCopy = [...nomineeSecondObj];
        nomSecondSignatureCopy[1].documentCategoryId =
          nomineeDocsIds.nomineeTwo.signature.documentCategoryId.toString();
        nomSecondSignatureCopy[1].documentId =
          nomineeDocsIds.nomineeTwo.signature.documentId;
        nomSecondSignatureCopy[1].documentcategory = "Signature";
        nomSecondSignatureCopy[1].imgUrl = val;
        setNomineeSecondObj(nomSecondSignatureCopy);
        let nomSecondSignatureObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          filename: nssnewfileName,
          panNo: GlobalStore?.personaldetails.pan,
          ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
        };

        let savefourthDocuments = [];
        let savefourthDocObj = {
          documentcategory: "Signature",
          documentCategoryId:
            nomineeDocsIds.nomineeTwo.signature.documentCategoryId.toString(),
          documentId: nomineeDocsIds.nomineeTwo.signature.documentId,
          documentexpirydate: "",
          fileName: nssnewfileName,
          isfilecropped: true,
          mimeType: getMimeType(val),
          panno:
            panNo && panNo !== "" ? panNo : GlobalStore.personaldetails.pan,
          isWatsappFlag: true,
          personaldetailsid: "0",
          autoqc: false,
          iskycdocument: false,
        };
        savefourthDocuments.push(savefourthDocObj);

        const savefourthObj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
          documentInfo: savefourthDocuments,
          leadId: GlobalStore.leadId,
          // objUTM_Info: objUTM_Info,
        };
        if (shouldDisable()) {
          setErrCode("Account is already submitted.");
        } else {
          AUploadDocument(
            (res: any) => {
              if (!res || res.error) {
                mixpanelService({
                  event: mixpanelEvents.ERROR_TRIGGERED,
                  screen_name: getScreenName(window.location.pathname),
                  error_object: res.error,
                });
              }
              getUploadRes(res, id, val, fileName);
            },
            nomSecondSignatureObj,
            (event: ProgressEvent) =>
              onUploadProgress(event, id, fileName, type),
            savefourthObj
          );
        }
        break;
      case "nomThirdPhotoId":
        let ntpext = fileName.split(".").pop();
        let ntpnewfileName = "thirdNominee_Photo." + ntpext;
        let nomThirdPhotoCopy = [...nomineeThirdObj];
        nomThirdPhotoCopy[0].documentCategoryId =
          nomineeDocsIds.nomineeThree.photo.documentCategoryId.toString();
        nomThirdPhotoCopy[0].documentId =
          nomineeDocsIds.nomineeThree.photo.documentId;
        nomThirdPhotoCopy[0].documentcategory = "Photograph";
        nomThirdPhotoCopy[0].imgUrl = val;
        setNomineeThirdObj(nomThirdPhotoCopy);
        let nomThirdPhotoObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          filename: ntpnewfileName,
          panNo: GlobalStore?.personaldetails.pan,
          ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
        };
        let savefiveDocuments = [];
        let savefiveDocObj = {
          documentcategory: "Photograph",
          documentCategoryId:
            nomineeDocsIds.nomineeThree.photo.documentCategoryId.toString(),
          documentId: nomineeDocsIds.nomineeThree.photo.documentId,
          documentexpirydate: "",
          fileName: ntpnewfileName,
          isfilecropped: true,
          mimeType: getMimeType(val),
          panno:
            panNo && panNo !== "" ? panNo : GlobalStore.personaldetails.pan,
          isWatsappFlag: true,
          personaldetailsid: "0",
          autoqc: false,
          iskycdocument: false,
        };
        savefiveDocuments.push(savefiveDocObj);

        const savefiveObj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
          documentInfo: savefiveDocuments,
          leadId: GlobalStore.leadId,
          // objUTM_Info: objUTM_Info,
        };
        if (shouldDisable()) {
          setErrCode("Account is already submitted.");
        } else {
          AUploadDocument(
            (res: any) => {
              if (!res || res.error) {
                mixpanelService({
                  event: mixpanelEvents.ERROR_TRIGGERED,
                  screen_name: getScreenName(window.location.pathname),
                  error_object: res.error,
                });
              }
              getUploadRes(res, id, val, fileName);
            },
            nomThirdPhotoObj,
            (event: ProgressEvent) =>
              onUploadProgress(event, id, fileName, type),
            savefiveObj
          );
        }
        break;
      case "nomThirdSignature":
        let ntsext = fileName.split(".").pop();
        let ntsnewfileName = "thirdNominee_Signature." + ntsext;
        let nomThirdSignatureCopy = [...nomineeThirdObj];
        nomThirdSignatureCopy[1].documentCategoryId =
          nomineeDocsIds.nomineeThree.signature.documentCategoryId.toString();
        nomThirdSignatureCopy[1].documentId =
          nomineeDocsIds.nomineeThree.signature.documentId;
        nomThirdSignatureCopy[1].documentcategory = "Signature";
        nomThirdSignatureCopy[1].imgUrl = val;
        setNomineeThirdObj(nomThirdSignatureCopy);
        let nomThirdSignatureObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          filename: ntsnewfileName,
          panNo: GlobalStore?.personaldetails.pan,
          ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
        };
        let savesixDocuments = [];
        let savesixDocObj = {
          documentcategory: "Signature",
          documentCategoryId:
            nomineeDocsIds.nomineeThree.signature.documentCategoryId.toString(),
          documentId: nomineeDocsIds.nomineeThree.signature.documentId,
          documentexpirydate: "",
          fileName: ntsnewfileName,
          isfilecropped: true,
          mimeType: getMimeType(val),
          panno:
            panNo && panNo !== "" ? panNo : GlobalStore.personaldetails.pan,
          isWatsappFlag: true,
          personaldetailsid: "0",
          autoqc: false,
          iskycdocument: false,
        };
        savesixDocuments.push(savesixDocObj);

        const savesixObj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
          documentInfo: savesixDocuments,
          leadId: GlobalStore.leadId,
          // objUTM_Info: objUTM_Info,
        };
        if (shouldDisable()) {
          setErrCode("Account is already submitted.");
        } else {
          AUploadDocument(
            (res: any) => {
              if (!res || res.error) {
                mixpanelService({
                  event: mixpanelEvents.ERROR_TRIGGERED,
                  screen_name: getScreenName(window.location.pathname),
                  error_object: res.error,
                });
              }
              getUploadRes(res, id, val, fileName);
            },
            nomThirdSignatureObj,
            (event: ProgressEvent) =>
              onUploadProgress(event, id, fileName, type),
            savesixObj
          );
        }
        break;

      case "guardianFirstPhotoId":
        let guardFirstPhotoCopy = [...guardianFirstObj];
        guardFirstPhotoCopy[0].documentCategoryId =
          nomineeDocsIds.nomineeOne.guardianDetails.photo.documentCategoryId.toString();
        guardFirstPhotoCopy[0].documentId =
          nomineeDocsIds.nomineeOne.guardianDetails.photo.documentId;
        guardFirstPhotoCopy[0].documentcategory = "Photograph";
        guardFirstPhotoCopy[0].imgUrl = val;
        setGuardianFirstObj(guardFirstPhotoCopy);
        let guardianFirstPhotoObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          filename: fileName,
          panNo: GlobalStore?.personaldetails.pan,
          ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
        };

        let savesevenDocuments = [];
        let savesevenDocObj = {
          documentcategory: "Photograph",
          documentCategoryId:
            nomineeDocsIds.nomineeOne.guardianDetails.photo.documentCategoryId.toString(),
          documentId:
            nomineeDocsIds.nomineeOne.guardianDetails.photo.documentId,
          documentexpirydate: "",
          fileName: fileName,
          isfilecropped: true,
          mimeType: getMimeType(val),
          panno:
            panNo && panNo !== "" ? panNo : GlobalStore.personaldetails.pan,
          isWatsappFlag: true,
          personaldetailsid: "0",
          autoqc: false,
          iskycdocument: false,
        };
        savesevenDocuments.push(savesevenDocObj);

        const savesevenObj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
          documentInfo: savesevenDocuments,
          leadId: GlobalStore.leadId,
          // objUTM_Info: objUTM_Info,
        };
        if (shouldDisable()) {
          setErrCode("Account is already submitted.");
        } else {
          AUploadDocument(
            (res: any) => {
              if (!res || res.error) {
                mixpanelService({
                  event: mixpanelEvents.ERROR_TRIGGERED,
                  screen_name: getScreenName(window.location.pathname),
                  error_object: res.error,
                });
              }
              getUploadRes(res, id, val, fileName);
            },
            guardianFirstPhotoObj,
            (event: ProgressEvent) =>
              onUploadProgress(event, id, fileName, type),
            savesevenObj
          );
        }
        break;
      case "guardianFirstSignature":
        let guardFirstSignatureCopy = [...guardianFirstObj];
        guardFirstSignatureCopy[1].documentCategoryId =
          nomineeDocsIds.nomineeOne.guardianDetails.signature.documentCategoryId.toString();
        guardFirstSignatureCopy[1].documentId =
          nomineeDocsIds.nomineeOne.guardianDetails.signature.documentId;
        guardFirstSignatureCopy[1].documentcategory = "Signature";
        guardFirstSignatureCopy[1].imgUrl = val;
        setGuardianFirstObj(guardFirstSignatureCopy);
        let guardianFirstSignatureObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          filename: fileName,
          panNo: GlobalStore?.personaldetails.pan,
          ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
        };

        let save8Documents = [];
        let save8DocObj = {
          documentcategory: "Signature",
          documentCategoryId:
            nomineeDocsIds.nomineeOne.guardianDetails.signature.documentCategoryId.toString(),
          documentId:
            nomineeDocsIds.nomineeOne.guardianDetails.signature.documentId,
          documentexpirydate: "",
          fileName: fileName,
          isfilecropped: true,
          mimeType: getMimeType(val),
          panno:
            panNo && panNo !== "" ? panNo : GlobalStore.personaldetails.pan,
          isWatsappFlag: true,
          personaldetailsid: "0",
          autoqc: false,
          iskycdocument: false,
        };
        save8Documents.push(save8DocObj);

        const save8Obj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
          documentInfo: save8Documents,
          leadId: GlobalStore.leadId,
          // objUTM_Info: objUTM_Info,
        };
        if (shouldDisable()) {
          setErrCode("Account is already submitted.");
        } else {
          AUploadDocument(
            (res: any) => {
              if (!res || res.error) {
                mixpanelService({
                  event: mixpanelEvents.ERROR_TRIGGERED,
                  screen_name: getScreenName(window.location.pathname),
                  error_object: res.error,
                });
              }
              getUploadRes(res, id, val, fileName);
            },
            guardianFirstSignatureObj,
            (event: ProgressEvent) =>
              onUploadProgress(event, id, fileName, type),
            save8Obj
          );
        }
        break;
      case "guardianSecondPhotoId":
        let guardSecondPhotoCopy = [...guardianSecondObj];
        guardSecondPhotoCopy[0].documentCategoryId =
          nomineeDocsIds.nomineeTwo.guardianDetails.photo.documentCategoryId.toString();
        guardSecondPhotoCopy[0].documentId =
          nomineeDocsIds.nomineeTwo.guardianDetails.photo.documentId;
        guardSecondPhotoCopy[0].documentcategory = "Photograph";
        guardSecondPhotoCopy[0].imgUrl = val;
        setGuardianSecondObj(guardSecondPhotoCopy);
        let guardianSecondPhotoObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          filename: fileName,
          panNo: GlobalStore?.personaldetails.pan,
          ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
        };
        let save9Documents = [];
        let save9DocObj = {
          documentcategory: "Photograph",
          documentCategoryId:
            nomineeDocsIds.nomineeTwo.guardianDetails.photo.documentCategoryId.toString(),
          documentId:
            nomineeDocsIds.nomineeTwo.guardianDetails.photo.documentId,
          documentexpirydate: "",
          fileName: fileName,
          isfilecropped: true,
          mimeType: getMimeType(val),
          panno:
            panNo && panNo !== "" ? panNo : GlobalStore.personaldetails.pan,
          isWatsappFlag: true,
          personaldetailsid: "0",
          autoqc: false,
          iskycdocument: false,
        };
        save9Documents.push(save9DocObj);

        const save9Obj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
          documentInfo: save9Documents,
          leadId: GlobalStore.leadId,
          // objUTM_Info: objUTM_Info,
        };
        if (shouldDisable()) {
          setErrCode("Account is already submitted.");
        } else {
          AUploadDocument(
            (res: any) => {
              if (!res || res.error) {
                mixpanelService({
                  event: mixpanelEvents.ERROR_TRIGGERED,
                  screen_name: getScreenName(window.location.pathname),
                  error_object: res.error,
                });
              }
              getUploadRes(res, id, val, fileName);
            },
            guardianSecondPhotoObj,
            (event: ProgressEvent) =>
              onUploadProgress(event, id, fileName, type),
            save9Obj
          );
        }
        break;
      case "guardianSecondSignature":
        let guardSecondSignatureCopy = [...guardianSecondObj];
        guardSecondSignatureCopy[1].documentCategoryId =
          nomineeDocsIds.nomineeTwo.guardianDetails.signature.documentCategoryId.toString();
        guardSecondSignatureCopy[1].documentId =
          nomineeDocsIds.nomineeTwo.guardianDetails.signature.documentId;
        guardSecondSignatureCopy[1].documentcategory = "Signature";
        guardSecondSignatureCopy[1].imgUrl = val;
        setGuardianSecondObj(guardSecondSignatureCopy);
        let guardianSecondSignatureObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          filename: fileName,
          panNo: GlobalStore?.personaldetails.pan,
          ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
        };
        let save10Documents = [];
        let save10DocObj = {
          documentcategory: "Signature",
          documentCategoryId:
            nomineeDocsIds.nomineeTwo.guardianDetails.signature.documentCategoryId.toString(),
          documentId:
            nomineeDocsIds.nomineeTwo.guardianDetails.signature.documentId,
          documentexpirydate: "",
          fileName: fileName,
          isfilecropped: true,
          mimeType: getMimeType(val),
          panno:
            panNo && panNo !== "" ? panNo : GlobalStore.personaldetails.pan,
          isWatsappFlag: true,
          personaldetailsid: "0",
          autoqc: false,
          iskycdocument: false,
        };
        save10Documents.push(save10DocObj);

        const save10Obj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
          documentInfo: save10Documents,
          leadId: GlobalStore.leadId,
          // objUTM_Info: objUTM_Info,
        };
        if (shouldDisable()) {
          setErrCode("Account is already submitted.");
        } else {
          AUploadDocument(
            (res: any) => {
              if (!res || res.error) {
                mixpanelService({
                  event: mixpanelEvents.ERROR_TRIGGERED,
                  screen_name: getScreenName(window.location.pathname),
                  error_object: res.error,
                });
              }
              getUploadRes(res, id, val, fileName);
            },
            guardianSecondSignatureObj,
            (event: ProgressEvent) =>
              onUploadProgress(event, id, fileName, type),
            save10Obj
          );
        }
        break;
      case "guardianThirdPhotoId":
        let guardThirdPhotoCopy = [...guardianThirdObj];
        guardThirdPhotoCopy[0].documentCategoryId =
          nomineeDocsIds.nomineeThree.guardianDetails.photo.documentCategoryId.toString();
        guardThirdPhotoCopy[0].documentId =
          nomineeDocsIds.nomineeThree.guardianDetails.photo.documentId;
        guardThirdPhotoCopy[0].documentcategory = "Photograph";
        guardThirdPhotoCopy[0].imgUrl = val;
        setGuardianThirdObj(guardThirdPhotoCopy);
        let guardianThirdPhotoObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          filename: fileName,
          panNo: GlobalStore?.personaldetails.pan,
          ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
        };
        let save11Documents = [];
        let save11DocObj = {
          documentcategory: "Photograph",
          documentCategoryId:
            nomineeDocsIds.nomineeThree.guardianDetails.photo.documentCategoryId.toString(),
          documentId:
            nomineeDocsIds.nomineeThree.guardianDetails.photo.documentId,
          documentexpirydate: "",
          fileName: fileName,
          isfilecropped: true,
          mimeType: getMimeType(val),
          panno:
            panNo && panNo !== "" ? panNo : GlobalStore.personaldetails.pan,
          isWatsappFlag: true,
          personaldetailsid: "0",
          autoqc: false,
          iskycdocument: false,
        };
        save11Documents.push(save11DocObj);

        const save11Obj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
          documentInfo: save11Documents,
          leadId: GlobalStore.leadId,
          // objUTM_Info: objUTM_Info,
        };
        if (shouldDisable()) {
          setErrCode("Account is already submitted.");
        } else {
          AUploadDocument(
            (res: any) => {
              if (!res || res.error) {
                mixpanelService({
                  event: mixpanelEvents.ERROR_TRIGGERED,
                  screen_name: getScreenName(window.location.pathname),
                  error_object: res.error,
                });
              }
              getUploadRes(res, id, val, fileName);
            },
            guardianThirdPhotoObj,
            (event: ProgressEvent) =>
              onUploadProgress(event, id, fileName, type),
            save11Obj
          );
        }
        break;
      case "guardianThirdSignature":
        let guardThirdSignatureCopy = [...guardianThirdObj];
        guardThirdSignatureCopy[1].documentCategoryId =
          nomineeDocsIds.nomineeThree.guardianDetails.signature.documentCategoryId.toString();
        guardThirdSignatureCopy[1].documentId =
          nomineeDocsIds.nomineeThree.guardianDetails.signature.documentId;
        guardThirdSignatureCopy[1].documentcategory = "Signature";
        guardThirdSignatureCopy[1].imgUrl = val;
        setGuardianThirdObj(guardThirdSignatureCopy);
        let guardianThirdSignatureObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          filename: fileName,
          panNo: GlobalStore?.personaldetails.pan,
          ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
        };
        let save12Documents = [];
        let save12DocObj = {
          documentcategory: "Signature",
          documentCategoryId:
            nomineeDocsIds.nomineeThree.guardianDetails.signature.documentCategoryId.toString(),
          documentId:
            nomineeDocsIds.nomineeThree.guardianDetails.signature.documentId,
          documentexpirydate: "",
          fileName: fileName,
          isfilecropped: true,
          mimeType: getMimeType(val),
          panno:
            panNo && panNo !== "" ? panNo : GlobalStore.personaldetails.pan,
          isWatsappFlag: true,
          personaldetailsid: "0",
          autoqc: false,
          iskycdocument: false,
        };
        save12Documents.push(save12DocObj);

        const save12Obj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
          documentInfo: save12Documents,
          leadId: GlobalStore.leadId,
          // objUTM_Info: objUTM_Info,
        };
        if (shouldDisable()) {
          setErrCode("Account is already submitted.");
        } else {
          AUploadDocument(
            (res: any) => {
              if (!res || res.error) {
                mixpanelService({
                  event: mixpanelEvents.ERROR_TRIGGERED,
                  screen_name: getScreenName(window.location.pathname),
                  error_object: res.error,
                });
              }
              getUploadRes(res, id, val, fileName);
            },
            guardianThirdSignatureObj,
            (event: ProgressEvent) =>
              onUploadProgress(event, id, fileName, type),
            save12Obj
          );
        }
        break;

      default:
        break;
    }
  }

  function handleRemoveDoc(index: number, id: string, docObj: any) {
    switch (id) {
      case "nomFirstPhotoId":
        let nomFirstPhotCopy = [...nomineeFirstObj];
        nomFirstPhotCopy[0].imgUrl = "";
        nomFirstPhotCopy[0].fileName = "";
        setNomineeFirstObj(nomFirstPhotCopy);
        break;
      case "nomFirstSignature":
        let nomFirstSignatureCopy = [...nomineeFirstObj];
        nomFirstSignatureCopy[1].imgUrl = "";
        nomFirstSignatureCopy[1].fileName = "";

        setNomineeFirstObj(nomFirstSignatureCopy);
        break;
      case "nomSecondPhotoId":
        let nomSecondPhotoCopy = [...nomineeSecondObj];
        nomSecondPhotoCopy[0].imgUrl = "";
        nomSecondPhotoCopy[0].fileName = "";

        setNomineeSecondObj(nomSecondPhotoCopy);
        break;
      case "nomSecondSignature":
        let nomSecondSignatureCopy = [...nomineeSecondObj];
        nomSecondSignatureCopy[1].imgUrl = "";
        nomSecondSignatureCopy[1].fileName = "";

        setNomineeSecondObj(nomSecondSignatureCopy);
        break;
      case "nomThirdPhotoId":
        let nomThirdPhotoCopy = [...nomineeThirdObj];

        nomThirdPhotoCopy[0].imgUrl = "";
        nomThirdPhotoCopy[0].fileName = "";

        setNomineeThirdObj(nomThirdPhotoCopy);
        break;
      case "nomThirdSignature":
        let nomThirdSignatureCopy = [...nomineeThirdObj];
        nomThirdSignatureCopy[1].documentCategoryId =
          nomThirdSignatureCopy[1].imgUrl = "";
        nomThirdSignatureCopy[1].fileName = "";

        setNomineeThirdObj(nomThirdSignatureCopy);
        break;
      case "guardianFirstPhotoId":
        let guardFirstPhotoCopy = [...guardianFirstObj];
        guardFirstPhotoCopy[0].imgUrl = "";
        guardFirstPhotoCopy[0].fileName = "";

        setGuardianFirstObj(guardFirstPhotoCopy);
        break;
      case "guardianFirstSignature":
        let guardFirstSignatureCopy = [...guardianFirstObj];
        guardFirstSignatureCopy[1].imgUrl = "";
        guardFirstSignatureCopy[1].fileName = "";

        setGuardianFirstObj(guardFirstSignatureCopy);
        break;
      case "guardianSecondPhotoId":
        let guardSecondPhotoCopy = [...guardianSecondObj];
        guardSecondPhotoCopy[0].imgUrl = "";
        guardSecondPhotoCopy[0].fileName = "";

        setGuardianSecondObj(guardSecondPhotoCopy);
        break;
      case "guardianSecondSignature":
        let guardSecondSignatureCopy = [...guardianSecondObj];
        guardSecondSignatureCopy[1].imgUrl = "";
        guardSecondSignatureCopy[1].fileName = "";

        setGuardianSecondObj(guardSecondSignatureCopy);
        break;
      case "guardianThirdPhotoId":
        let guardThirdPhotoCopy = [...guardianThirdObj];
        guardThirdPhotoCopy[0].imgUrl = "";
        guardThirdPhotoCopy[0].fileName = "";

        setGuardianThirdObj(guardThirdPhotoCopy);
        break;
      case "guardianThirdSignature":
        let guardThirdSignatureCopy = [...guardianThirdObj];
        guardThirdSignatureCopy[1].imgUrl = "";
        guardThirdSignatureCopy[1].fileName = "";

        setGuardianThirdObj(guardThirdSignatureCopy);
        break;
      default:
        break;
    }
  }

  function signatureUpload(
    val: any,
    fileName: string,
    id: string,
    type: string,
    isElogSignOpted: boolean = false,
  ) {
    if (id === 'signature') {
      onSignatureUploadComplete(val, fileName, id, type, isElogSignOpted, signatureObj)
    }
    else {
      let signObj = signaturesArr.find(a => a.documentCategoryId == id.split('_')[1])
      onSignatureUploadComplete(val, fileName, id, type, isElogSignOpted, signObj)
    }
  }

  function onSignatureUploadComplete(
    val: any,
    fileName: string,
    id: string,
    type: string,
    isElogSignOpted: boolean = false,
    signatureObj: any
  ) {
    setIsLoading(true);
    let holderIndx = null
    let accHolderDetails: any = sessionStorage.getItem("accHolders")
    signatureObj.imgUrl = "";
    if (id === 'signature') {
      setSignatureObj(signatureObj)
    }
    else {
      holderIndx = signaturesArr.findIndex(a => a.documentCategoryId == id.split('_')[1]);
      let tempArr = signaturesArr
      if (holderIndx !== -1) {
        tempArr[holderIndx] = signatureObj;
      }
      setSignaturesArr(tempArr);
    }
    setErrCode("");
    let fileNameCheck = fileName.includes(".") ? true : false;
    let typeCreater = type.includes("/") ? type.split("/")[1] : type;
    let panNo = holderIndx != null && accHolderDetails ? JSON.parse(accHolderDetails)[holderIndx]?.panNo : GlobalStore.personaldetails.pan

    if (signatureObj.base64 !== undefined && signatureObj.base64 !== "") {
      let saveDetails = [];
      let saveSignatureObj = {
        documentCategoryId: signatureObj.documentCategoryId?.toString(),
        documentId: signatureObj.documentId?.toString(),
        documentexpirydate: "",
        fileName: fileNameCheck,
        isfilecropped: true,
        mimeType: getMimeType(val),
        panno: panNo,
        isWatsappFlag: signatureObj.isWatsappFlag,
        personaldetailsid: "0",
        autoqc: false,
        isElogSignOpted: isElogSignOpted
      };
      saveDetails.push(saveSignatureObj);
      const saveObj = {
        applicationId: GlobalStore.applicationID,
        clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
        documentInfo: saveDetails,
        leadId: GlobalStore.leadId,
        // objUTM_Info: objUTM_Info,
      };
      const modifiedBy = window.sessionStorage.getItem('empCode')
      let uploadObj = {
        applicationid: GlobalStore.applicationID,
        base64document: signatureObj.base64!.split(",")[1],
        panNo: panNo,
        filename: fileNameCheck
          ? `${GlobalStore.applicationID}_Signature.${typeCreater}`
          : `${GlobalStore.applicationID}_Signature}.${typeCreater}`,
        DocType: "1",
        QltyByPassFlag: "0",
        ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
      };
      if (shouldDisable()) {
        setErrCode("Account is already submitted.");
      } else {
        AUploadDocument(
          (res: any) => {
            if (!res || res.error) {
              mixpanelService({
                event: mixpanelEvents.ERROR_TRIGGERED,
                screen_name: getScreenName(window.location.pathname),
                error_object: res.error,
              });
            }
            getUploadRes(res, id, val, fileName);
          },
          uploadObj,
          (event: ProgressEvent) => onUploadProgress(event, id, fileName, type),
          saveObj
        );
      }
    } else {
      const modifiedBy = window.sessionStorage.getItem('empCode')
      let uploadObj = {
        applicationid: GlobalStore.applicationID,
        base64document: val!.split(",")[1],
        panNo: panNo,
        filename: `${GlobalStore.applicationID}_Signature.${type!.split("/")[1]
          }`,
        DocType: "1",
        QltyByPassFlag: "0",
        ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
      };
      let saveDetails = [];
      let saveSignatureObj = {
        documentCategoryId: signatureObj.documentCategoryId?.toString(),
        documentId: signatureObj.documentId?.toString(),
        documentexpirydate: "",
        fileName: fileName,
        isfilecropped: true,
        mimeType: getMimeType(val),
        panno: panNo,
        isWatsappFlag: signatureObj.isWatsappFlag,
        personaldetailsid: "0",
        autoqc: false,
        isElogSignOpted: isElogSignOpted
      };
      saveDetails.push(saveSignatureObj);
      const saveObj = {
        applicationId: GlobalStore.applicationID,
        clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
        documentInfo: saveDetails,
        leadId: GlobalStore.leadId,
        // objUTM_Info: objUTM_Info,
      };
      if (shouldDisable()) {
        setErrCode("Account is already submitted.");
      } else {
        AUploadDocument(
          (res: any) => {
            if (!res || res.error) {
              mixpanelService({
                event: mixpanelEvents.ERROR_TRIGGERED,
                screen_name: getScreenName(window.location.pathname),
                error_object: res.error,
              });
            }
            getUploadRes(res, id, val, fileName);
          },
          uploadObj,
          (event: ProgressEvent) => onUploadProgress(event, id, fileName, type),
          saveObj
        );
      }
    }
  }

  function onSignatureUploadCompleteElog(
    val: any,
    fileName: string,
    id: string,
    type: string,
    isElogSignOpted: boolean = false
  ) {
    // debugger  
    const modifiedBy = window.sessionStorage.getItem('empCode')
    let uploadObj = {
      applicationid: GlobalStore.applicationID,
      base64document: val!.split(",")[1],
      panNo: GlobalStore?.personaldetails.pan,
      filename: `${GlobalStore.applicationID}_Signature.${type!.split("/")[1]
        }`,
      DocType: "1",
      QltyByPassFlag: "0",
      ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0,
      // entitySubType: GlobalStore.entitySubType
    };
    let saveDetails = [];
    let saveSignatureObj = {
      documentCategoryId: signatureObj.documentCategoryId?.toString(),
      documentId: signatureObj.documentId?.toString(),
      documentexpirydate: "",
      fileName: fileName,
      isfilecropped: true,
      mimeType: getMimeType(val),
      panno: GlobalStore.personaldetails.pan,
      isWatsappFlag: signatureObj.isWatsappFlag,
      personaldetailsid: "0",
      autoqc: false,
      isElogSignOpted: isElogSignOpted
    };
    saveDetails.push(saveSignatureObj);
    const saveObj = {
      applicationId: GlobalStore.applicationID,
      clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
      documentInfo: saveDetails,
      leadId: GlobalStore.leadId,
      entitySubType: GlobalStore.entitySubType
      // objUTM_Info: objUTM_Info,
    };
    if (shouldDisable()) {
      setErrCode("Account is already submitted.");
    } else {
      AUploadDocument(
        (res: any) => {
          if (!res || res.error) {
            mixpanelService({
              event: mixpanelEvents.ERROR_TRIGGERED,
              screen_name: getScreenName(window.location.pathname),
              error_object: res.error,
            });
          }
          if (res.data) {
            AGetDocumentList(getDocList, GlobalStore.applicationID); //2
          }
        },
        uploadObj,
        (event: ProgressEvent) => { },
        saveObj
      );
    }

  }

  function onIncomeUploadComplete(
    val: any,
    fileName: string,
    id: string,
    type: string
  ) {
    setIsLoading(true);
    incomeObj.imgUrl = "";
    setIncomeObj(incomeObj);
    const modifiedBy = window.sessionStorage.getItem('empCode')
    let uploadObj = {
      applicationid: GlobalStore.applicationID,
      base64document: val!.split(",")[1],
      filename: fileName,
      panNo: GlobalStore?.personaldetails.pan,
      ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
    };
    let saveDetails = [];
    let saveIncomeObj = {
      documentCategoryId: incomeObj.documentCategoryId?.toString(),
      documentId: incomeObj.documentId?.toString(),
      documentexpirydate: "",
      fileName: incomeName || incomeObj.fileName,
      isfilecropped: true,
      mimeType: incomeObj.mimeType,
      panno: GlobalStore.personaldetails.pan,
      isWatsappFlag: incomeObj.isWatsappFlag,
      personaldetailsid: "0",
      autoqc: false,
    };
    saveDetails.push(saveIncomeObj);
    const saveObj = {
      applicationId: GlobalStore.applicationID,
      clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
      documentInfo: saveDetails,
      leadId: GlobalStore.leadId,
      // objUTM_Info: objUTM_Info,
    };
    if (shouldDisable()) {
      setErrCode("Account is already submitted.");
    } else {
      AUploadDocument(
        (res: any) => {
          if (!res || res.error) {
            mixpanelService({
              event: mixpanelEvents.ERROR_TRIGGERED,
              screen_name: getScreenName(window.location.pathname),
              error_object: res.error,
            });
          }
          getUploadRes(res, id, val, fileName);
        },
        uploadObj,
        (event: ProgressEvent) => onUploadProgress(event, id, fileName, type),
        saveObj
      );
    }
  }

  function handErrorForFileUpload(id: string, res: any) {
    if (id === "firstBankDoc") {
      setFirstBankListError(res.error);
    }
    if (id === "secondBankDoc") {
      setSecondBankListError(res.error);
    }
    if (id === "thirdBankDoc") {
      setThirdBankListError(res.error);
    }
    if (id === "fourthBankDoc") {
      setFourthBankListError(res.error);
    }
    if (id === "fifthBankDoc") {
      setFifthBankListError(res.error);
    }
    if (id === "permAddress") {
      setPermAddListError(res.error);
    }
    if (id === "corrAddress") {
      setCorrAddListError(res.error);
    }
    if (id === "signature") {
      setSignatureListError(res.error);
    }
    if (id.includes('signature_')) {
      setSignatureArrError([...signatureArrError, { id: id, err: res.error }])
    }
    if (id === "incomeDoc") {
      setIncomeListError(res.error);
    }
    if (id === "permSecondAddress") {
      setSecondDocError(res.error);
    }
    if (id === "corrSecondAddress") {
      setCorrSecondDocError(res.error);
    }

    if (id === "nomFirstPhotoId") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        nomFirstPhotoId: res.error,
      });
    }
    if (id === "nomFirstSignature") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        nomFirstSignature: res.error,
      });
    }
    if (id === "nomSecondPhotoId") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        nomSecondPhotoId: res.error,
      });
    }
    if (id === "nomSecondSignature") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        nomSecondSignature: res.error,
      });
    }
    if (id === "nomThirdPhotoId") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        nomThirdPhotoId: res.error,
      });
    }
    if (id === "nomThirdSignature") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        nomThirdSignature: res.error,
      });
    }
    if (id === "guardianFirstPhotoId") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        guardianFirstPhotoId: res.error,
      });
    }
    if (id === "guardianFirstSignature") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        guardianFirstSignature: res.error,
      });
    }
    if (id === "guardianSecondPhotoId") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        guardianSecondPhotoId: res.error,
      });
    }
    if (id === "guardianSecondSignature") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        guardianSecondSignature: res.error,
      });
    }
    if (id === "guardianThirdPhotoId") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        guardianThirdPhotoId: res.error,
      });
    }
    if (id === "guardianThirdSignature") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        guardianThirdSignature: res.error,
      });
    }
  }
  const getUploadRes = (res: any, id: string, val: any, fileName: string) => {
    if (!res || res.error) {
      gtmService({ action: "UploadDocumentToS3", label: "ERROR || ERR140" });
      setIsLoading(false);
      // setErrCode("1361- Error in uploading the file.");\
      handErrorForFileUpload(id, res);
      if (
        !res?.errorCode?.includes("C11BE292") &&
        !res?.errorCode?.includes("C11BE422")
      ) {
        setErrCode(errCode + res.error);
      }
    } else {
      if (res.data) {
        //     setErrCode(errCode);
        if (id === "panCard") {
          setIsLoading(false);
          setIsNewPan(true);
          // setPanName(res.data.Guid);
          panObj.documentId = panDocumentId;
          const panOCR = {
            applicationid: GlobalStore.applicationID,
            base64document: val!.split(",")[1],
            documentcategory: "PAN Card",
            documentid: panObj.documentId,
            source: DIY,
          };

          // AextractPan((res: any) => storeOcrData(res, panOCR), panOCR);
          // if (photoBase64 !== undefined && panBase64 !== undefined) {
          //   setErrCode(errCode);
          // }
        } else if (id === "firstBankDoc") {
          setIsLoading(false);
          setFirstBankListError("");
          setIsNewFirstBank(true);
          setFirstBankName(res.data.Guid);

          // const firstBankOCR = {
          //   applicationid: GlobalStore.applicationID,
          //   base64document: val!.split(",")[1],
          //   documentcategory: firstBankObj.documentcategory,
          //   documentid: firstBankObj.documentId,
          //   source: DIY,
          //   bankName: firstBankDetails.BankName,
          //   accountType: firstBankDetails.AccountType,
          // };
          // if (firstBankObj.documentId === firstChequeDocumnetId) {
          //   setIsLoading(false);
          //   // AextractCheque(
          //   //   (res: any) => storeOcrData(res, firstBankOCR),
          //   //   firstBankOCR
          //   // );
          // } else if (firstBankObj.documentId === firstBankStatementDocumnetId) {
          //   setIsLoading(false);
          //   // AextractBankStatement(
          //   //   (res: any) => storeOcrData(res, firstBankOCR),
          //   //   firstBankOCR
          //   // );
          // } else {
          //   setIsLoading(false);
          // }
        } else if (id === "secondBankDoc") {
          setIsLoading(false);
          setSecondBankListError("");
          setIsNewSecondBank(true);
          setSecondBankName(res.data.Guid);

          const secondBankOCR = {
            applicationid: GlobalStore.applicationID,
            base64document: val!.split(",")[1],
            documentcategory: secondBankObj.documentcategory,
            documentid: secondBankObj.documentId,
            source: DIY,
            bankName: secondBankDetails.BankName,
            accountType: secondBankDetails.AccountType,
          };
          if (secondBankObj.documentId === secondChequeDocumnetId) {
            setIsLoading(true);
            // AextractCheque(
            //   (res: any) => storeOcrData(res, secondBankOCR),
            //   secondBankOCR
            // );
          } else if (
            secondBankObj.documentId === secondBankStatementDocumnetId
          ) {
            setIsLoading(true);
            // AextractBankStatement(
            //   (res: any) => storeOcrData(res, secondBankOCR),
            //   secondBankOCR
            // );
          } else {
            setIsLoading(false);
          }
        } else if (id === "thirdBankDoc") {
          setIsLoading(false);
          setThirdBankListError("");
          setIsNewThirdBank(true);
          setThirdBankName(res.data.Guid);

          const thirdBankOCR = {
            applicationid: GlobalStore.applicationID,
            base64document: val!.split(",")[1],
            documentcategory: thirdBankObj.documentcategory,
            documentid: thirdBankObj.documentId,
            source: DIY,
            bankName: thirdBankDetails.BankName,
            accountType: thirdBankDetails.AccountType,
          };
          if (thirdBankObj.documentId === thirdChequeDocumnetId) {
            setIsLoading(true);
            // AextractCheque(
            //   (res: any) => storeOcrData(res, thirdBankOCR),
            //   thirdBankOCR
            // );
          } else if (thirdBankObj.documentId === thirdBankStatementDocumnetId) {
            setIsLoading(true);
            // AextractBankStatement(
            //   (res: any) => storeOcrData(res, thirdBankOCR),
            //   thirdBankOCR
            // );
          } else {
            setIsLoading(false);
          }
        } else if (id === "fourthBankDoc") {
          setIsLoading(false);
          setFourthBankListError("");
          setIsNewFourthBank(true);
          setFourthBankName(res.data.Guid);
          const fourthBankOCR = {
            applicationid: GlobalStore.applicationID,
            base64document: val!.split(",")[1],
            documentcategory: fourthBankObj.documentcategory,
            documentid: fourthBankObj.documentId,
            source: DIY,
            bankName: fourthBankDetails.BankName,
            accountType: fourthBankDetails.AccountType,
          };
          if (fourthBankObj.documentId === fourthChequeDocumnetId) {
            setIsLoading(true);
            // AextractCheque(
            //   (res: any) => storeOcrData(res, fourthBankOCR),
            //   fourthBankOCR
            // );
          } else if (
            fourthBankObj.documentId === fourthBankStatementDocumnetId
          ) {
            setIsLoading(true);
            // AextractBankStatement(
            //   (res: any) => storeOcrData(res, fourthBankOCR),
            //   fourthBankOCR
            // );
          } else {
            setIsLoading(false);
          }
        } else if (id === "fifthBankDoc") {
          setIsLoading(false);
          setFifthBankListError("");
          setIsNewFifthBank(true);
          setFifthBankName(res.data.Guid);
          const fifthBankOCR = {
            applicationid: GlobalStore.applicationID,
            base64document: val!.split(",")[1],
            documentcategory: fifthBankObj.documentcategory,
            documentid: fifthBankObj.documentId,
            source: DIY,
            bankName: fifthBankDetails.BankName,
            accountType: fifthBankDetails.AccountType,
          };
          if (fifthBankObj.documentId === fifthChequeDocumnetId) {
            setIsLoading(true);
            // AextractCheque(
            //   (res: any) => storeOcrData(res, fifthBankOCR),
            //   fifthBankOCR
            // );
          } else if (fifthBankObj.documentId === fifthBankStatementDocumnetId) {
            setIsLoading(true);
            // AextractBankStatement(
            //   (res: any) => storeOcrData(res, fifthBankOCR),
            //   fifthBankOCR
            // );
          } else {
            setIsLoading(false);
          }
        } else if (id === "permAddress" && fileName.split(".")[1] === "pdf") {
          setIsLoading(false);
          setPermAddListError("");
          setIsNewPermAddress(true);
          setAddressName(res.data.Guid);
          const addressOCR = {
            applicationid: GlobalStore.applicationID,
            base64document: permAddressObj.base64,
            documentcategory: permAddressObj.documentcategory,
            documentid: permAddressObj.documentId,
            source: DIY,
          };
          // if (permAddressObj.documentId === aadhaarDocumnetId) {
          //   setIsLoading(true);
          //   AextractAadhaar(
          //     (res: any) => storeOcrData(res, addressOCR),
          //     addressOCR
          //   );
          // } else if (permAddressObj.documentId === passportDocumnetId) {
          //   setIsLoading(true);
          //   AextractPassport(
          //     (res: any) => storeOcrData(res, addressOCR),
          //     addressOCR
          //   );
          // } else if (permAddressObj.documentId === voterIdDocumentId) {
          //   setIsLoading(true);
          //   AextractVoterid(
          //     (res: any) => storeOcrData(res, addressOCR),
          //     addressOCR
          //   );
          // } else if (permAddressObj.documentId === dlDocumentId) {
          //   setIsLoading(true);
          //   AextractDl((res: any) => storeOcrData(res, addressOCR), addressOCR);
          // }
        } else if (id === "permAddress" && fileName.split(".")[1] !== "pdf") {
          setPermAddListError("");
          setIsNewPermAddress(true);
          setIsLoading(false);
          // setAddressName(res.data.Guid);
          // if (permAddressObj.documentId === aadhaarDocumnetId) {
          //   setIsLoading(true);
          //   const aadharOCR = {
          //     applicationid: GlobalStore.applicationID,
          //     base64document: permAddressObj.base64,
          //     documentcategory: permAddressObj.documentcategory,
          //     documentid: permAddressObj.documentId,
          //     source: DIY,
          //   };
          //   AextractAadhaar(
          //     (res: any) => storeOcrData(res, aadharOCR),
          //     aadharOCR
          //   );
          // } else setIsLoading(false);
        } else if (id === "permSecondAddress") {
          setSecondDocError("");
          setIsLoading(true);
          setIsNewPermAddress(true);
          let uploadImageObj = {
            applicationId: GlobalStore.applicationID,
            image1: permAddressObj.base64,
            image2: permSecondAddressObj.base64,
            imagename1: permAddressObj.fileName,
            imagename2: permSecondAddressObj.fileName,
          };
          AgetPdf(getPDFData, uploadImageObj);
        } else if (id === "corrAddress" && fileName.split(".")[1] === "pdf") {
          setIsLoading(false);
          setCorrAddListError("");
          setIsNewCorrAddress(true);
          setCorrAddressName(res.data.Guid);
          const addressOCR = {
            applicationid: GlobalStore.applicationID,
            base64document: corrAddressObj.base64,
            documentcategory: corrAddressObj.documentcategory,
            documentid: corrAddressObj.documentId,
            source: DIY,
          };
          // if (corrAddressObj.documentId === corrAadhaarDocumnetId) {
          //   setIsLoading(true);
          //   AextractAadhaar(
          //     (res: any) => storeOcrData(res, addressOCR),
          //     addressOCR
          //   );
          // } else if (corrAddressObj.documentId === corrPassportDocumnetId) {
          //   setIsLoading(true);
          //   AextractPassport(
          //     (res: any) => storeOcrData(res, addressOCR),
          //     addressOCR
          //   );
          // } else if (corrAddressObj.documentId === corrVoterIdDocumentId) {
          //   setIsLoading(true);
          //   AextractVoterid(
          //     (res: any) => storeOcrData(res, addressOCR),
          //     addressOCR
          //   );
          // } else if (corrAddressObj.documentId === corrDlDocumentId) {
          //   setIsLoading(true);
          //   AextractDl((res: any) => storeOcrData(res, addressOCR), addressOCR);
          // }
        } else if (id === "corrAddress" && fileName.split(".")[1] !== "pdf") {
          setIsNewCorrAddress(true);
          setCorrAddListError("");
          setCorrAddressName(res.data.Guid);
          setIsLoading(false);
          // if (corrAddressObj.documentId === corrAadhaarDocumnetId) {
          //   setIsLoading(true);
          //   const aadharOCR = {
          //     applicationid: GlobalStore.applicationID,
          //     base64document: corrAddressObj.base64,
          //     documentcategory: corrAddressObj.documentcategory,
          //     documentid: corrAddressObj.documentId,
          //     source: DIY,
          //   };
          //   AextractAadhaar(
          //     (res: any) => storeOcrData(res, aadharOCR),
          //     aadharOCR
          //   );
          // } else setIsLoading(false);
        } else if (
          id === "corrAddress" &&
          fileName.split(".")[1] !== "pdf" &&
          corrSecondAddressObj.base64 !== undefined
        ) {
          setIsLoading(true);
          setCorrAddListError("");
          setIsNewCorrAddress(true);
          let uploadImageObj = {
            applicationId: GlobalStore.applicationID,
            image1: corrAddressObj.base64,
            image2: corrSecondAddressObj.base64,
            imagename1: corrAddressObj.fileName,
            imagename2: corrSecondAddressObj.fileName,
          };
          AgetPdf(getCorrPDFData, uploadImageObj);
        } else if (id === "corrSecondAddress") {
          setIsLoading(true);
          setCorrSecondDocError("");
          setIsNewCorrAddress(true);
          let uploadImageObj = {
            applicationId: GlobalStore.applicationID,
            image1: corrAddressObj.base64,
            image2: corrSecondAddressObj.base64,
            imagename1: corrAddressObj.fileName,
            imagename2: corrSecondAddressObj.fileName,
          };
          AgetPdf(getCorrPDFData, uploadImageObj);
        } else if (id === "signature") {
          setIsLoading(false);
          setSignatureListError("");
          setIsNewSignature(true);
          setSignatureName(res.data.Guid);
          signatureObj.documentId = signatureDocumentId;
        } else if (id.includes('signature_')) {
          setIsLoading(false);
          setSignatureArrError([]);
        } else if (id === "incomeDoc") {
          setIsLoading(false);
          setIncomeListError("");
          setIsNewIncome(true);
          setIncomeName(res.data.Guid);
        } else if (id === "nomFirstPhotoId") {
          let nomineeOneCopy = [...nomineeFirstObj];
          nomineeOneCopy[0].fileName = res.data.Guid;
          setNomineeFirstObj(nomineeOneCopy);
          setIsLoading(false);
          setNomineeGuardianError({
            ...nomineeGuardianError,
            nomFirstPhotoId: "",
          });
          setIsNomineeGuardian({
            ...isNomineeGuardian,
            isNomFirstPhoto: true,
          });
        } else if (id === "nomFirstSignature") {
          let nomineeOneCopy = [...nomineeFirstObj];
          nomineeOneCopy[1].fileName = res.data.Guid;
          setNomineeFirstObj(nomineeOneCopy);
          setIsLoading(false);
          setNomineeGuardianError({
            ...nomineeGuardianError,
            nomFirstSignature: "",
          });
          setIsNomineeGuardian({
            ...isNomineeGuardian,
            isNomFirstSignature: true,
          });
        } else if (id === "nomSecondPhotoId") {
          let nomineeTwoCopy = [...nomineeSecondObj];
          nomineeTwoCopy[0].fileName = res.data.Guid;
          setNomineeSecondObj(nomineeTwoCopy);
          setIsLoading(false);
          setNomineeGuardianError({
            ...nomineeGuardianError,
            nomSecondPhotoId: "",
          });
          setIsNomineeGuardian({
            ...isNomineeGuardian,
            isNomSecondPhoto: true,
          });
        } else if (id === "nomSecondSignature") {
          let nomineeTwoCopy = [...nomineeSecondObj];
          nomineeTwoCopy[1].fileName = res.data.Guid;
          setNomineeSecondObj(nomineeTwoCopy);
          setIsLoading(false);
          setNomineeGuardianError({
            ...nomineeGuardianError,
            nomSecondSignature: "",
          });
          setIsNomineeGuardian({
            ...isNomineeGuardian,
            isNomSecondSignature: true,
          });
        } else if (id === "nomThirdPhotoId") {
          let nomineeThreeCopy = [...nomineeThirdObj];
          nomineeThreeCopy[0].fileName = res.data.Guid;
          setNomineeThirdObj(nomineeThreeCopy);
          setIsLoading(false);
          setNomineeGuardianError({
            ...nomineeGuardianError,
            nomThirdPhotoId: "",
          });
          setIsNomineeGuardian({
            ...isNomineeGuardian,
            isNomThirdPhoto: true,
          });
        } else if (id === "nomThirdSignature") {
          let nomineeThreeCopy = [...nomineeThirdObj];
          nomineeThreeCopy[1].fileName = res.data.Guid;
          setNomineeThirdObj(nomineeThreeCopy);
          setIsLoading(false);
          setNomineeGuardianError({
            ...nomineeGuardianError,
            nomThirdSignature: "",
          });
          setIsNomineeGuardian({
            ...isNomineeGuardian,
            isNomThirdSignature: true,
          });
        } else if (id === "guardianFirstPhotoId") {
          let GuardianOneCopy = [...guardianFirstObj];
          GuardianOneCopy[0].fileName = res.data.Guid;
          setGuardianFirstObj(GuardianOneCopy);
          setIsLoading(false);
          setNomineeGuardianError({
            ...nomineeGuardianError,
            guardianFirstPhotoId: "",
          });
          setIsNomineeGuardian({
            ...isNomineeGuardian,
            isGuardianFirstPhoto: true,
          });
        } else if (id === "guardianFirstSignature") {
          let GuardianOneCopy = [...guardianFirstObj];
          GuardianOneCopy[1].fileName = res.data.Guid;
          setGuardianFirstObj(GuardianOneCopy);
          setIsLoading(false);
          setNomineeGuardianError({
            ...nomineeGuardianError,
            guardianFirstSignature: "",
          });
          setIsNomineeGuardian({
            ...isNomineeGuardian,
            isGuardianFirstSignature: true,
          });
        } else if (id === "guardianSecondPhotoId") {
          let GuardianTwoCopy = [...guardianSecondObj];
          GuardianTwoCopy[0].fileName = res.data.Guid;
          setGuardianSecondObj(GuardianTwoCopy);
          setIsLoading(false);
          setNomineeGuardianError({
            ...nomineeGuardianError,
            guardianSecondPhotoId: "",
          });
          setIsNomineeGuardian({
            ...isNomineeGuardian,
            isGuardianSecondPhoto: true,
          });
        } else if (id === "guardianSecondSignature") {
          setIsLoading(false);
          let GuardianTwoCopy = [...guardianSecondObj];
          GuardianTwoCopy[1].fileName = res.data.Guid;
          setGuardianSecondObj(GuardianTwoCopy);
          setNomineeGuardianError({
            ...nomineeGuardianError,
            guardianSecondSignature: "",
          });
          setIsNomineeGuardian({
            ...isNomineeGuardian,
            isGuardianSecondSignature: true,
          });
        } else if (id === "guardianThirdPhotoId") {
          let GuardianThreeCopy = [...guardianThirdObj];
          GuardianThreeCopy[0].fileName = res.data.Guid;
          setGuardianThirdObj(GuardianThreeCopy);
          setIsLoading(false);
          setNomineeGuardianError({
            ...nomineeGuardianError,
            guardianThirdPhotoId: "",
          });
          setIsNomineeGuardian({
            ...isNomineeGuardian,
            isGuardianThirdPhoto: true,
          });
        } else if (id === "guardianThirdSignature") {
          let GuardianThreeCopy = [...guardianThirdObj];
          GuardianThreeCopy[1].fileName = res.data.Guid;
          setGuardianThirdObj(GuardianThreeCopy);
          setIsLoading(false);
          setNomineeGuardianError({
            ...nomineeGuardianError,
            guardianThirdSignature: "",
          });
          setIsNomineeGuardian({
            ...isNomineeGuardian,
            isGuardianThirdSignature: true,
          });
        }
        setIsLoading(false);
      } else {
        setErrCode(errCode + res.error);
        gtmService({
          action: "UploadDocumentToS3",
          label: "ERROR || ERR140-S",
        });
      }
    }
  };

  const onUploadProgress = (
    event: ProgressEvent,
    id: string,
    fileName: string,
    type: string
  ) => {
    const { loaded, total } = event;
    let percentage = Math.floor((loaded * 100) / total);
    let panCopy = { ...panObj };
    let firstBankCopy = { ...firstBankObj };
    let secondBankCopy = { ...secondBankObj };
    let thirdBankCopy = { ...thirdBankObj };
    let fourthBankCopy = { ...fourthBankObj };
    let fifthBankCopy = { ...fifthBankObj };
    let permAddressCopy = { ...permAddressObj };
    let permSecondAddressCopy = { ...permSecondAddressObj };
    let corrAddressCopy = { ...corrAddressObj };
    let corrSecondAddressCopy = { ...corrSecondAddressObj };
    let signatureCopy = { ...signatureObj };
    let signatureArrCopy = [...signaturesArr];
    let incomeCopy = { ...incomeObj };
    let nomineeOneCopy = [...nomineeFirstObj];
    let nomineeTwoCopy = [...nomineeSecondObj];
    let nomineeThreeCopy = [...nomineeThirdObj];
    let GuardianOneCopy = [...guardianFirstObj];
    let GuardianTwoCopy = [...guardianSecondObj];
    let GuardianThreeCopy = [...guardianThirdObj];

    if (percentage < 100) {
      if (id === "panCard") {
        panCopy.id = id;
        panCopy.disable = false;
        panCopy.uploadPer = percentage;
        panCopy.hideProgress = true;
        panCopy.showFile = false;
        setPanObj(panCopy);
      } else if (id === "firstBankDoc") {
        firstBankCopy.id = id;
        firstBankCopy.disable = false;
        firstBankCopy.uploadPer = percentage;
        firstBankCopy.hideProgress = true;
        firstBankCopy.showFile = false;
        setFirstBankObj(firstBankCopy);
      } else if (id === "secondBankDoc") {
        secondBankCopy.id = id;
        secondBankCopy.disable = false;
        secondBankCopy.uploadPer = percentage;
        secondBankCopy.hideProgress = true;
        secondBankCopy.showFile = false;
        setSecondBankObj(secondBankCopy);
      } else if (id === "thirdBankDoc") {
        thirdBankCopy.id = id;
        thirdBankCopy.disable = false;
        thirdBankCopy.uploadPer = percentage;
        thirdBankCopy.hideProgress = true;
        thirdBankCopy.showFile = false;
        setThirdBankObj(thirdBankCopy);
      } else if (id === "fourthBankDoc") {
        fourthBankCopy.id = id;
        fourthBankCopy.disable = false;
        fourthBankCopy.uploadPer = percentage;
        fourthBankCopy.hideProgress = true;
        fourthBankCopy.showFile = false;
        setFourthBankObj(fourthBankCopy);
      } else if (id === "fifthBankDoc") {
        fifthBankCopy.id = id;
        fifthBankCopy.disable = false;
        fifthBankCopy.uploadPer = percentage;
        fifthBankCopy.hideProgress = true;
        fifthBankCopy.showFile = false;
        setFifthBankObj(fifthBankCopy);
      } else if (id === "permAddress") {
        permAddressCopy.id = id;
        permAddressCopy.disable = false;
        permAddressCopy.uploadPer = percentage;
        permAddressCopy.hideProgress = true;
        permAddressCopy.showFile = false;
        setPermAddressObj(permAddressCopy);
      } else if (id === "permSecondAddress") {
        permSecondAddressCopy.id = id;
        permSecondAddressCopy.disable = false;
        permSecondAddressCopy.uploadPer = percentage;
        permSecondAddressCopy.hideProgress = true;
        permSecondAddressCopy.showFile = false;
        setPermSecondAddressObj(permSecondAddressCopy);
      } else if (id === "corrAddress") {
        corrAddressCopy.id = id;
        corrAddressCopy.disable = false;
        corrAddressCopy.uploadPer = percentage;
        corrAddressCopy.hideProgress = true;
        corrAddressCopy.showFile = false;
        setCorrAddressObj(corrAddressCopy);
      } else if (id === "corrSecondAddress") {
        corrSecondAddressCopy.id = id;
        corrSecondAddressCopy.disable = false;
        corrSecondAddressCopy.uploadPer = percentage;
        corrSecondAddressCopy.hideProgress = true;
        corrSecondAddressCopy.showFile = false;
        setCorrSecondAddressObj(corrSecondAddressCopy);
      } else if (id === "signature") {
        signatureCopy.id = id;
        signatureCopy.disable = false;
        signatureCopy.uploadPer = percentage;
        signatureCopy.hideProgress = true;
        signatureCopy.showFile = false;
        setSignatureObj({ ...signatureCopy });
      }
      else if (id.includes('signature_')) {
        let signObj = signatureArrCopy.find(a => a.documentCategoryId == id.split('_')[1])
        if (signObj) {
          signObj.id = id;
          signObj.disable = false;
          signObj.uploadPer = percentage;
          signObj.showFile = false;
          signObj.hideProgress = false;
          signObj.mimeType = type;
          signObj.fileName = fileName;
          const index = signatureArrCopy.findIndex(a => a.documentCategoryId == id.split('_')[1]);
          let tempArr = signatureArrCopy
          if (index !== -1) {
            tempArr[index] = signObj;
          }
          setSignaturesArr(tempArr);
        }
      } else if (id === "incomeDoc") {
        incomeCopy.id = id;
        incomeCopy.disable = false;
        incomeCopy.uploadPer = percentage;
        incomeCopy.hideProgress = true;
        incomeCopy.showFile = false;
        setIncomeObj(incomeCopy);
      } else if (id === "nomFirstPhotoId") {
        nomineeOneCopy[0].disable = false;
        nomineeOneCopy[0].uploadPer = percentage;
        nomineeOneCopy[0].hideProgress = true;
        nomineeOneCopy[0].showFile = false;
        setNomineeFirstObj(nomineeOneCopy);
      } else if (id === "nomFirstSignature") {
        nomineeOneCopy[1].disable = false;
        nomineeOneCopy[1].uploadPer = percentage;
        nomineeOneCopy[1].hideProgress = true;
        nomineeOneCopy[1].showFile = false;
        setNomineeFirstObj(nomineeOneCopy);
      } else if (id === "nomSecondPhotoId") {
        nomineeTwoCopy[0].disable = false;
        nomineeTwoCopy[0].uploadPer = percentage;
        nomineeTwoCopy[0].hideProgress = true;
        nomineeTwoCopy[0].showFile = false;
        setNomineeSecondObj(nomineeTwoCopy);
      } else if (id === "nomSecondSignature") {
        nomineeTwoCopy[1].disable = false;
        nomineeTwoCopy[1].uploadPer = percentage;
        nomineeTwoCopy[1].hideProgress = true;
        nomineeTwoCopy[1].showFile = false;
        setNomineeSecondObj(nomineeTwoCopy);
      } else if (id === "nomThirdPhotoId") {
        nomineeThreeCopy[0].disable = false;
        nomineeThreeCopy[0].uploadPer = percentage;
        nomineeThreeCopy[0].hideProgress = true;
        nomineeThreeCopy[0].showFile = false;
        setNomineeThirdObj(nomineeThreeCopy);
      } else if (id === "nomThirdSignature") {
        nomineeThreeCopy[1].disable = false;
        nomineeThreeCopy[1].uploadPer = percentage;
        nomineeThreeCopy[1].hideProgress = true;
        nomineeThreeCopy[1].showFile = false;
        setNomineeThirdObj(nomineeThreeCopy);
      } else if (id === "guardianFirstPhotoId") {
        GuardianOneCopy[0].disable = false;
        GuardianOneCopy[0].uploadPer = percentage;
        GuardianOneCopy[0].hideProgress = true;
        GuardianOneCopy[0].showFile = false;
        setGuardianFirstObj(GuardianOneCopy);
      } else if (id === "guardianFirstSignature") {
        GuardianOneCopy[1].disable = false;
        GuardianOneCopy[1].uploadPer = percentage;
        GuardianOneCopy[1].hideProgress = true;
        GuardianOneCopy[1].showFile = false;
        setGuardianFirstObj(GuardianOneCopy);
      } else if (id === "guardianSecondPhotoId") {
        GuardianTwoCopy[0].disable = false;
        GuardianTwoCopy[0].uploadPer = percentage;
        GuardianTwoCopy[0].hideProgress = true;
        GuardianTwoCopy[0].showFile = false;
        setGuardianSecondObj(GuardianTwoCopy);
      } else if (id === "guardianSecondSignature") {
        GuardianTwoCopy[1].disable = false;
        GuardianTwoCopy[1].uploadPer = percentage;
        GuardianTwoCopy[1].hideProgress = true;
        GuardianTwoCopy[1].showFile = false;
        setGuardianSecondObj(GuardianTwoCopy);
      } else if (id === "guardianThirdPhotoId") {
        GuardianThreeCopy[0].disable = false;
        GuardianThreeCopy[0].uploadPer = percentage;
        GuardianThreeCopy[0].hideProgress = true;
        GuardianThreeCopy[0].showFile = false;
        setGuardianThirdObj(GuardianThreeCopy);
      } else if (id === "guardianThirdSignature") {
        GuardianThreeCopy[1].disable = false;
        GuardianThreeCopy[1].uploadPer = percentage;
        GuardianThreeCopy[1].hideProgress = true;
        GuardianThreeCopy[1].showFile = false;
        setGuardianThirdObj(GuardianThreeCopy);
      }
    } else if (percentage === 100) {
      if (id === "panCard") {
        panCopy.id = id;
        panCopy.disable = false;
        panCopy.uploadPer = percentage;
        panCopy.showFile = false;
        panCopy.hideProgress = false;
        panCopy.fileName = fileName;
        panCopy.mimeType = type;
        setPanObj(panCopy);
      } else if (id === "firstBankDoc") {
        firstBankCopy.id = id;
        firstBankCopy.disable = false;
        firstBankCopy.uploadPer = percentage;
        firstBankCopy.fileName = fileName;
        firstBankCopy.showFile = false;
        firstBankCopy.hideProgress = false;
        firstBankCopy.mimeType = type;
        setFirstBankObj(firstBankCopy);
      } else if (id === "secondBankDoc") {
        secondBankCopy.id = id;
        secondBankCopy.disable = false;
        secondBankCopy.uploadPer = percentage;
        secondBankCopy.fileName = fileName;
        secondBankCopy.showFile = false;
        secondBankCopy.hideProgress = false;
        secondBankCopy.mimeType = type;
        setSecondBankObj(secondBankCopy);
      } else if (id === "thirdBankDoc") {
        thirdBankCopy.id = id;
        thirdBankCopy.disable = false;
        thirdBankCopy.uploadPer = percentage;
        thirdBankCopy.fileName = fileName;
        thirdBankCopy.showFile = false;
        thirdBankCopy.hideProgress = false;
        thirdBankCopy.mimeType = type;
        setThirdBankObj(thirdBankCopy);
      } else if (id === "fourthBankDoc") {
        fourthBankCopy.id = id;
        fourthBankCopy.disable = false;
        fourthBankCopy.uploadPer = percentage;
        fourthBankCopy.fileName = fileName;
        fourthBankCopy.showFile = false;
        fourthBankCopy.hideProgress = false;
        fourthBankCopy.mimeType = type;
        setFourthBankObj(fourthBankCopy);
      } else if (id === "fifthBankDoc") {
        fifthBankCopy.id = id;
        fifthBankCopy.disable = false;
        fifthBankCopy.uploadPer = percentage;
        fifthBankCopy.fileName = fileName;
        fifthBankCopy.showFile = false;
        fifthBankCopy.hideProgress = false;
        fifthBankCopy.mimeType = type;
        setFifthBankObj(fifthBankCopy);
      } else if (id === "permAddress") {
        permAddressCopy.id = id;
        permAddressCopy.disable = false;
        permAddressCopy.uploadPer = percentage;
        permAddressCopy.showFile = false;
        permAddressCopy.hideProgress = false;
        permAddressCopy.mimeType = type;
        permAddressCopy.fileName = fileName;
        setPermAddressObj(permAddressCopy);
      } else if (id === "permSecondAddress") {
        permSecondAddressCopy.id = id;
        permSecondAddressCopy.disable = false;
        permSecondAddressCopy.uploadPer = percentage;
        permSecondAddressCopy.showFile = false;
        permSecondAddressCopy.hideProgress = false;
        permSecondAddressCopy.mimeType = type;
        permSecondAddressCopy.fileName = fileName;
        setPermSecondAddressObj(permSecondAddressCopy);
      } else if (id === "corrAddress") {
        corrAddressCopy.id = id;
        corrAddressCopy.disable = false;
        corrAddressCopy.uploadPer = percentage;
        corrAddressCopy.showFile = false;
        corrAddressCopy.hideProgress = false;
        corrAddressCopy.mimeType = type;
        corrAddressCopy.fileName = fileName;
        setCorrAddressObj(corrAddressCopy);
      } else if (id === "corrSecondAddress") {
        corrSecondAddressCopy.id = id;
        corrSecondAddressCopy.disable = false;
        corrSecondAddressCopy.uploadPer = percentage;
        corrSecondAddressCopy.showFile = false;
        corrSecondAddressCopy.hideProgress = false;
        corrSecondAddressCopy.mimeType = type;
        corrSecondAddressCopy.fileName = fileName;
        setCorrSecondAddressObj(corrSecondAddressCopy);
      } else if (id === "signature") {
        signatureCopy.id = id;
        signatureCopy.disable = false;
        signatureCopy.uploadPer = percentage;
        signatureCopy.showFile = false;
        signatureCopy.hideProgress = false;
        signatureCopy.mimeType = type;
        signatureCopy.fileName = fileName;
        setSignatureObj(signatureCopy);
      } else if (id.includes('signature_')) {
        let signObj = signatureArrCopy.find(a => a.documentCategoryId == id.split('_')[1])
        if (signObj) {
          signObj.id = id;
          signObj.disable = false;
          signObj.uploadPer = percentage;
          signObj.showFile = false;
          signObj.hideProgress = false;
          signObj.mimeType = type;
          signObj.fileName = fileName;
          const index = signatureArrCopy.findIndex(a => a.documentCategoryId == id.split('_')[1]);
          let tempArr = signatureArrCopy
          if (index !== -1) {
            tempArr[index] = signObj;
          }
          setSignaturesArr(tempArr);
        }
      } else if (id === "incomeDoc") {
        incomeCopy.id = id;
        incomeCopy.disable = false;
        incomeCopy.uploadPer = percentage;
        incomeCopy.showFile = false;
        incomeCopy.hideProgress = false;
        incomeCopy.mimeType = type;
        incomeCopy.fileName = fileName;
        setIncomeObj(incomeCopy);
      } else if (id === "nomFirstPhotoId") {
        nomineeOneCopy[0].disable = false;
        nomineeOneCopy[0].uploadPer = percentage;
        nomineeOneCopy[0].showFile = false;
        nomineeOneCopy[0].hideProgress = false;
        nomineeOneCopy[0].mimeType = type;
        setNomineeFirstObj(nomineeOneCopy);
      } else if (id === "nomFirstSignature") {
        nomineeOneCopy[1].disable = false;
        nomineeOneCopy[1].uploadPer = percentage;
        nomineeOneCopy[1].showFile = false;
        nomineeOneCopy[1].hideProgress = false;
        nomineeOneCopy[1].mimeType = type;
        setNomineeFirstObj(nomineeOneCopy);
      } else if (id === "nomSecondPhotoId") {
        nomineeTwoCopy[0].disable = false;
        nomineeTwoCopy[0].uploadPer = percentage;
        nomineeTwoCopy[0].showFile = false;
        nomineeTwoCopy[0].hideProgress = false;
        nomineeTwoCopy[0].mimeType = type;
        setNomineeSecondObj(nomineeTwoCopy);
      } else if (id === "nomSecondSignature") {
        nomineeTwoCopy[1].disable = false;
        nomineeTwoCopy[1].uploadPer = percentage;
        nomineeTwoCopy[1].showFile = false;
        nomineeTwoCopy[1].hideProgress = false;
        nomineeTwoCopy[1].mimeType = type;
        setNomineeSecondObj(nomineeTwoCopy);
      } else if (id === "nomThirdPhotoId") {
        nomineeThreeCopy[0].disable = false;
        nomineeThreeCopy[0].uploadPer = percentage;
        nomineeThreeCopy[0].showFile = false;
        nomineeThreeCopy[0].hideProgress = false;
        nomineeThreeCopy[0].mimeType = type;
        setNomineeThirdObj(nomineeThreeCopy);
      } else if (id === "nomThirdSignature") {
        nomineeThreeCopy[1].disable = false;
        nomineeThreeCopy[1].uploadPer = percentage;
        nomineeThreeCopy[1].showFile = false;
        nomineeThreeCopy[1].hideProgress = false;
        nomineeThreeCopy[1].mimeType = type;
        setNomineeThirdObj(nomineeThreeCopy);
      } else if (id === "guardianFirstPhotoId") {
        GuardianOneCopy[0].disable = false;
        GuardianOneCopy[0].uploadPer = percentage;
        GuardianOneCopy[0].showFile = false;
        GuardianOneCopy[0].hideProgress = false;
        GuardianOneCopy[0].mimeType = type;
        setGuardianFirstObj(GuardianOneCopy);
      } else if (id === "guardianFirstSignature") {
        GuardianOneCopy[1].disable = false;
        GuardianOneCopy[1].uploadPer = percentage;
        GuardianOneCopy[1].showFile = false;
        GuardianOneCopy[1].hideProgress = false;
        GuardianOneCopy[1].mimeType = type;
        setGuardianFirstObj(GuardianOneCopy);
      } else if (id === "guardianSecondPhotoId") {
        GuardianTwoCopy[0].disable = false;
        GuardianTwoCopy[0].uploadPer = percentage;
        GuardianTwoCopy[0].showFile = false;
        GuardianTwoCopy[0].hideProgress = false;
        GuardianTwoCopy[0].mimeType = type;
        setGuardianSecondObj(GuardianTwoCopy);
      } else if (id === "guardianSecondSignature") {
        GuardianTwoCopy[1].disable = false;
        GuardianTwoCopy[1].uploadPer = percentage;
        GuardianTwoCopy[1].showFile = false;
        GuardianTwoCopy[1].hideProgress = false;
        GuardianTwoCopy[1].mimeType = type;
        setGuardianSecondObj(GuardianTwoCopy);
      } else if (id === "guardianThirdPhotoId") {
        GuardianThreeCopy[0].disable = false;
        GuardianThreeCopy[0].uploadPer = percentage;
        GuardianThreeCopy[0].showFile = false;
        GuardianThreeCopy[0].hideProgress = false;
        GuardianThreeCopy[0].mimeType = type;
        setGuardianThirdObj(GuardianThreeCopy);
      } else if (id === "guardianThirdSignature") {
        GuardianThreeCopy[1].disable = false;
        GuardianThreeCopy[1].uploadPer = percentage;
        GuardianThreeCopy[1].showFile = false;
        GuardianThreeCopy[1].hideProgress = false;
        GuardianThreeCopy[1].mimeType = type;
        setGuardianThirdObj(GuardianThreeCopy);
      }
    }
  };

  const uploadDoc = () => {
    gtmService({
      action: "DOCUMENT_VERIFICATION",
      label: "DOCUMENT_UPLOAD | UPLOAD",
    });
    setUploadDocFlag(true);
    setUploadViaWatsAppFlag(false);
    // getLocation();
  };

  const saveViaWatsApp = () => {
    const saveDetails = [];
    if (photoObj && photoObj.fileName === "") {
      let savePhotoObj = {
        documentCategoryId: photoObj.documentCategoryId?.toString(),
        documentId: photoObj.documentId?.toString(),
        documentexpirydate: "",
        fileName: ".",
        isfilecropped: true,
        mimeType: ".",
        panno: GlobalStore.personaldetails.pan,
        personaldetailsid: "0",
        autoqc: autoQc,
        iskycdocument: false,
        isWatsappFlag: true,
      };
      saveDetails.push(savePhotoObj);
    }

    if (
      photoObj &&
      isNewPhoto &&
      (photoObj.fileName !== "" || photoObj.fileName !== undefined)
    ) {
      let savePhotoObj = {
        documentCategoryId: photoObj.documentCategoryId?.toString(),
        documentId: photoObj.documentId?.toString(),
        documentexpirydate: "",
        fileName: photoObj.fileName,
        isfilecropped: true,
        mimeType: photoObj.mimeType,
        panno: GlobalStore.personaldetails.pan,
        personaldetailsid: "0",
        autoqc: autoQc,
        iskycdocument: false,
        isWatsappFlag: false,
      };
      saveDetails.push(savePhotoObj);
    }
    if (panObj && panObj.fileName === "") {
      let savePanObj = {
        documentCategoryId: panObj.documentCategoryId?.toString(),
        documentId: panObj.documentId?.toString(),
        documentexpirydate: "",
        fileName: ".",
        isfilecropped: true,
        mimeType: ".",
        panno: GlobalStore.personaldetails.pan,
        isWatsappFlag: true,
        personaldetailsid: "0",
        autoqc: false,
        iskycdocument: false,
      };
      saveDetails.push(savePanObj);
    }

    if (
      firstBankObj &&
      firstBankObj.fileName === "" &&
      firstBankObj.documentCategoryId !== ""
    ) {
      let firstBanObj = {
        documentCategoryId: firstBankObj.documentCategoryId?.toString(),
        documentId: firstBankObj.documentId?.toString(),
        documentexpirydate: "",
        fileName: ".",
        isfilecropped: true,
        mimeType: ".",
        panno: GlobalStore.personaldetails.pan,
        isWatsappFlag: true,
        personaldetailsid: "0",
        autoqc: false,
        iskycdocument: false,
      };
      saveDetails.push(firstBanObj);
    }

    if (
      secondBankObj &&
      secondBankObj.fileName === "" &&
      secondBankObj.documentCategoryId !== ""
    ) {
      let saveSecondBankObj = {
        documentCategoryId: secondBankObj.documentCategoryId?.toString(),
        documentId: secondBankObj.documentId?.toString(),
        documentexpirydate: "",
        fileName: ".",
        isfilecropped: true,
        mimeType: ".",
        panno: GlobalStore.personaldetails.pan,
        isWatsappFlag: true,
        personaldetailsid: "0",
        autoqc: false,
        iskycdocument: false,
      };
      saveDetails.push(saveSecondBankObj);
    }

    if (
      thirdBankObj &&
      thirdBankObj.fileName === "" &&
      thirdBankObj.documentCategoryId !== ""
    ) {
      let saveThirdBankObj = {
        documentCategoryId: thirdBankObj.documentCategoryId?.toString(),
        documentId: thirdBankObj.documentId?.toString(),
        documentexpirydate: "",
        fileName: ".",
        isfilecropped: true,
        mimeType: ".",
        panno: GlobalStore.personaldetails.pan,
        isWatsappFlag: true,
        personaldetailsid: "0",
        autoqc: false,
        iskycdocument: false,
      };
      saveDetails.push(saveThirdBankObj);
    }

    if (
      fourthBankObj &&
      fourthBankObj.fileName === "" &&
      fourthBankObj.documentCategoryId !== ""
    ) {
      let saveFourthBankObj = {
        documentCategoryId: fourthBankObj.documentCategoryId?.toString(),
        documentId: fourthBankObj.documentId?.toString(),
        documentexpirydate: "",
        fileName: ".",
        isfilecropped: true,
        mimeType: ".",
        panno: GlobalStore.personaldetails.pan,
        isWatsappFlag: true,
        personaldetailsid: "0",
        autoqc: false,
        iskycdocument: false,
      };
      saveDetails.push(saveFourthBankObj);
    }

    if (
      fifthBankObj &&
      fifthBankObj.fileName === "" &&
      fifthBankObj.documentCategoryId !== ""
    ) {
      let saveFifthBankObj = {
        documentCategoryId: fifthBankObj.documentCategoryId?.toString(),
        documentId: fifthBankObj.documentId?.toString(),
        documentexpirydate: "",
        fileName: ".",
        isfilecropped: true,
        mimeType: ".",
        panno: GlobalStore.personaldetails.pan,
        isWatsappFlag: true,
        personaldetailsid: "0",
        autoqc: false,
        iskycdocument: false,
      };
      saveDetails.push(saveFifthBankObj);
    }

    if (
      permAddressObj &&
      permAddressObj.fileName === "" &&
      permAddressObj.documentCategoryId !== ""
    ) {
      let savepermAddressObj = {
        documentCategoryId: permAddressObj.documentCategoryId?.toString(),
        documentId: permAddressObj.documentId?.toString(),
        documentexpirydate: "",
        fileName: ".",
        isfilecropped: true,
        mimeType: ".",
        panno: GlobalStore.personaldetails.pan,
        isWatsappFlag: true,
        personaldetailsid: "0",
        autoqc: false,
        iskycdocument: false,
      };
      saveDetails.push(savepermAddressObj);
    }
    if (
      corrAddressObj &&
      corrAddressObj.fileName === "" &&
      corrAddressObj.documentCategoryId !== ""
    ) {
      let saveCorrAddressObj = {
        documentCategoryId: corrAddressObj.documentCategoryId?.toString(),
        documentId: corrAddressObj.documentId?.toString(),
        documentexpirydate: "",
        fileName: ".",
        isfilecropped: true,
        mimeType: ".",
        panno: GlobalStore.personaldetails.pan,
        isWatsappFlag: true,
        personaldetailsid: "0",
        autoqc: false,
        iskycdocument: false,
      };
      saveDetails.push(saveCorrAddressObj);
    }

    if (
      signatureObj &&
      signatureObj.fileName === "" &&
      signatureObj.documentCategoryId !== ""
    ) {
      let saveSignatureObj = {
        documentCategoryId: signatureObj.documentCategoryId?.toString(),
        documentId: signatureObj.documentId?.toString(),
        documentexpirydate: "",
        fileName: ".",
        isfilecropped: true,
        mimeType: ".",
        panno: GlobalStore.personaldetails.pan,
        isWatsappFlag: true,
        personaldetailsid: "0",
        autoqc: false,
        iskycdocument: false,
      };
      saveDetails.push(saveSignatureObj);
    }

    if (
      incomeObj &&
      incomeObj.fileName === "" &&
      incomeObj.documentCategoryId !== ""
    ) {
      let saveIncomeObj = {
        documentCategoryId: incomeObj.documentCategoryId?.toString(),
        documentId: incomeObj.documentId?.toString(),
        documentexpirydate: "",
        fileName: ".",
        isfilecropped: true,
        mimeType: ".",
        panno: GlobalStore.personaldetails.pan,
        isWatsappFlag: true,
        personaldetailsid: "0",
        autoqc: false,
        iskycdocument: false,
      };
      saveDetails.push(saveIncomeObj);
    }

    const objUTM_Info = utmDurationInfoObj(startTime, "documentsdur");
    const modifiedBy = window.sessionStorage.getItem('empCode')
    const saveObj = {
      applicationId: GlobalStore.applicationID,
      clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
      documentInfo: saveDetails,
      leadId: GlobalStore.leadId,
      objUTM_Info: objUTM_Info,
      ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
    };
    ASaveDocumentDetails(getSaveStatus, saveObj);
  };

  const handleBankDoc = (val: any) => {
    if (val) {
      if (val.DocumentCategoryId === 9) {
        firstBankObj.disable = false;
        firstBankObj.documentId = val.DocumentId;
        setFirstBankObj(firstBankObj);
        setDefaultFirstBankDoc(val.DocumentName);
      } else if (val.DocumentCategoryId === 60) {
        secondBankObj.disable = false;
        secondBankObj.documentId = val.DocumentId;
        setSecondBankObj(secondBankObj);
        setDefaultSecondBankDoc(val.DocumentName);
      } else if (val.DocumentCategoryId === 61) {
        thirdBankObj.disable = false;
        thirdBankObj.documentId = val.DocumentId;
        setThirdBankObj(thirdBankObj);
        setDefaultThirdBankDoc(val.DocumentName);
      } else if (val.DocumentCategoryId === 70) {
        fourthBankObj.disable = false;
        fourthBankObj.documentId = val.DocumentId;
        setFourthBankObj(fourthBankObj);
        setDefaultFourthBankDoc(val.DocumentName);
      } else if (val.DocumentCategoryId === 71) {
        fifthBankObj.disable = false;
        fifthBankObj.documentId = val.DocumentId;
        setFifthBankObj(fifthBankObj);
        setDefaultFifthBankDoc(val.DocumentName);
      }
    }
  };

  const handlePermanentAddress = (val: any) => {
    if (val) {
      if (
        val.DocumentId === 125 ||
        permAddressObj.mimeType === "application/pdf"
      ) {
        setSecondDoc(false);
        setAnotherFile(false);
      } else {
        setSecondDoc(true);
      }
      // setIsFirstAdd(false);
      permAddressObj.disable = blockAadhar;
      permAddressObj.documentId = val.DocumentId;
      setPermAddressObj(permAddressObj);
      setDefaultAddress(val.DocumentName);
    }
  };

  const handleCorrespondenceAddress = (val: any) => {
    if (val) {
      if (
        val.DocumentId === 133 ||
        corrAddressObj.mimeType === "application/pdf"
      ) {
        setCorrSecondDoc(false);
        setCorrAnotherFile(false);
      } else {
        setCorrSecondDoc(true);
      }
      corrAddressObj.disable = false;
      corrAddressObj.documentId = val.DocumentId;
      setCorrAddressObj(corrAddressObj);
      setDefaultCorrAddress(val.DocumentName);
    }
  };

  const handleIncomeProof = (val: any) => {
    if (val !== "") {
      incomeObj.disable = false;
      incomeObj.documentId = val.DocumentId;
      setIncomeObj(incomeObj);
      setDefaultIncomeDoc(val.DocumentName);
    }
  };

  const addDocument = () => {
    if (secondDoc) {
      setAnotherFile(true);
    } else {
      setAnotherFile(false);
    }
  };

  const addCorrDocument = () => {
    if (corrSecondDoc) {
      setCorrAnotherFile(true);
    } else {
      setCorrAnotherFile(false);
    }
  };

  const handleSubmit = () => {
    setLoaderSign(true);
    setIsLoading(true);
    if (clientStageDetails.accountcategory == 2 && clientStageDetails.rmassisted) {
      QCServiceTaskCreation(
        (res: any) => {
          if (!res || res.error) {
            setIsLoading(false);
            setErrCode(res.error);
            setLoaderSign(false);
          } else {
            if (
              res &&
              res.data !== null &&
              Object.keys(res?.data)?.length > 0
            ) {
              navigate(statusUrl.docVerificationInProgress)
            } else {
              setErrCode("Something went wrong. please try again later.");
              setIsLoading(false);
              setLoaderSign(false);
            }
          }
        },
        GlobalStore?.applicationID,
        GlobalStore.stageStatus.accountcategory
          ? GlobalStore?.stageStatus?.accountcategory
          : 0
      );
    } else getSaveStatusNew();
  };

  const getSaveStatusNew = () => {
    AGetPendingDocument((res: any) => {
      if (!res || res.error) {
        //   setErrCode("1456- Error in fetching pending documents list.");
        setErrCode(errCode + res.error);
        gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR123" });
        setIsLoading(false);
        setLoaderSign(false);
      } else {
        const responseObj = res?.data ? JSON.parse(res?.data) : [];
        if (true) {
          const clientPartialDetails_ao = JSON.parse(
            window.localStorage.getItem("clientPartialDetails_ao") || "{}"
          );
          const onlyIpvPending: Array<any> = (responseObj ?? []).filter(
            (item: any) =>
              item.Mandatory === true &&
              item.DocumentCategory !== "In Person Verification"
          );

          if (onlyIpvPending?.length == 0) {
            setLoaderSign(false);
            if (
              GlobalStore.isDigiLocker ||
              clientPartialDetails_ao.isDigiLocker ||
              GlobalStore.isKRA ||
              clientPartialDetails_ao.isKRA
            ) {
              gtmService({
                action: "DOCUMENT_VERIFICATION",
                label: "Step_Complete",
              });
              completeModuleStatus(dashboardUrl.doc);
              // history.push(incompleteStageNavigation(dashboardUrl.doc));
              navigate(incompleteStageNavigation(dashboardUrl.doc))
            } else {
              const onlyIpvPending: Array<any> = responseObj.filter(
                (item: any) =>
                  item.Mandatory === true
              );
              if (onlyIpvPending.length === 0) {
                gtmService({
                  action: "DOCUMENT_VERIFICATION",
                  label: "Step_Complete",
                });
              } else if (onlyIpvPending.length > 0) {
                let isIpvExist = GlobalStore.leftNavBarState.filter(
                  (data: any) => data.navUrl === "/ipv"
                );
                if (isIpvExist.length === 0) {
                  GlobalStore.setLeftNavBarState((prevState) => [
                    ...prevState,
                    ipvNavBarObj,
                  ]);
                }
              }
              completeModuleStatus(dashboardUrl.doc);
              // history.push(incompleteStageNavigation(dashboardUrl.doc));
              navigate(incompleteStageNavigation(dashboardUrl.doc))
            }
          } else {
            setErrCode("Please upload all required documents.");
            setIsLoading(false);
            setLoaderSign(false);
          }
        } else {
          gtmService({
            action: "GetDocumentDetails",
            label: "ERROR || ERR123-S",
          });
        }
      }
    }, GlobalStore.applicationID);
  };
  const getSaveStatus = (res: any) => {
    if (!res || res.error) {
      //setErrCode(1641)
      setErrCode(errCode + res.error);
      gtmService({
        action: "SaveUploadedDocumentDetails",
        label: "ERROR || ERR133",
      });
      setIsLoading(false);
      setLoaderSign(false);
    } else {
      if (res.data) {
        setIsLoading(true);
        // Clevertap event: submit documents data
        const data = {
          EventName:
            cleverTapEvents.registration.documentVerificationPage
              .CLICK_ON_SUBMIT,
          InitiationPlatform: "",
          UTM_SOURCE: props.UTM_SOURCE || "",
          UTM_MEDIUM: props.UTM_MEDIUM || "",
          UTM_CAMPAIGN: props.UTM_CAMPAIGN || "",
          KRA: GlobalStore.isKRA,
          ADHAR_LINKED_WITH_MOBILE: "",
          DIGILOCKER_PROCESS: GlobalStore.isDigiLocker,
          ADDRESS_PROOF_SUBMITTED_VIA: uploadVaiWatsAppFlag
            ? "whattsapp"
            : "upload_now",
          LEAD_ID: GlobalStore.leadId,
          REF_ID: GlobalStore.applicationID,
        };

        ClevertapService.pushEvent(data);
        // Clevertap ends here

        // Apps flyer event for click on proceed on plan details page
        AppsFlyerService.pushEvent(
          appsFlyerEvents.registration.documentVerificationPage.CLICK_ON_SUBMIT
        );

        AGetPendingDocument(pendingDocQC, GlobalStore.applicationID);
      } else {
        setIsLoading(false);
        gtmService({
          action: "SaveUploadedDocumentDetails",
          label: "ERROR || ERR133-S",
        });
      }
    }
  };
  const hideSeflieOption = () => {
    if (GlobalStore?.isKRA && GlobalStore?.stageStatus?.accountcategory == 2) {
      return true;
    } else return false;
  };
  function pendingDocQC(res: any) {
    if (!res || res.error) {
      //   setErrCode("1456- Error in fetching pending documents list.");
      setErrCode(errCode + res.error);
      gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR123" });
      setIsLoading(false);
    } else {
      const responseObj = JSON.parse(res.data);
      if (responseObj && responseObj.length > 0) {
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );

        if (
          GlobalStore.isDigiLocker ||
          clientPartialDetails_ao.isDigiLocker ||
          GlobalStore.isKRA ||
          clientPartialDetails_ao.isKRA
        ) {
          gtmService({
            action: "DOCUMENT_VERIFICATION",
            label: "Step_Complete",
          });
          completeModuleStatus(dashboardUrl.doc);
          // history.push(incompleteStageNavigation(dashboardUrl.doc));
          navigate(incompleteStageNavigation(dashboardUrl.doc))
        } else {
          const onlyIpvPending: Array<any> = responseObj.filter(
            (item: any) =>
              //   item.documentcategoryid !== 36 &&
              //   item.documentcategoryid !== 30 &&
              // //   item.documentcategoryid !== 62
              // item.DocumentCategoryId !== 36 &&
              // item.DocumentCategoryId !== 30 &&
              // item.DocumentCategoryId !== 62
              item.Mandatory === true
          );
          if (onlyIpvPending.length === 0) {
            gtmService({
              action: "DOCUMENT_VERIFICATION",
              label: "Step_Complete",
            });
          } else if (onlyIpvPending.length > 0) {
            let isIpvExist = GlobalStore.leftNavBarState.filter(
              (data: any) => data.navUrl === "/ipv"
            );
            if (isIpvExist.length === 0) {
              GlobalStore.setLeftNavBarState((prevState) => [
                ...prevState,
                ipvNavBarObj,
              ]);
            }
          }
          completeModuleStatus(dashboardUrl.doc);
          // history.push(incompleteStageNavigation(dashboardUrl.doc));
          navigate(incompleteStageNavigation(dashboardUrl.doc))
        }
      } else {
        gtmService({
          action: "GetDocumentDetails",
          label: "ERROR || ERR123-S",
        });
      }
    }
  }
  const panSkipIfAPI = () => {
    if (GlobalStore.isKRA && parseInt(userId) > 0) return false;
    else return (!panObj.imgUrl && !isNewPan) || !isPanAndDobMatch;
  };
  const selfieSkipIfAPI = () => {
    if (
      GlobalStore.isKRA &&
      parseInt(userId) > 0 &&
      GlobalStore?.stageStatus?.accountcategory == 2
    )
      return false;
    else if (
      GlobalStore.isKRA &&
      GlobalStore?.stageStatus?.accountcategory == 2
    ) {
      return false;
    } else return !photoObj.imgUrl && !isNewPhoto;
  };
  const disableSelfieCapture = () => {
    if (
      GlobalStore.isKRA &&
      parseInt(userId) > 0 &&
      GlobalStore?.stageStatus?.accountcategory == 2
    )
      return true;
    else if (
      GlobalStore.isKRA &&
      GlobalStore?.stageStatus?.accountcategory == 2
    ) {
      return true;
    } else if (GlobalStore?.isKRA == false && disabledUploadForEsign()) {
      return true;
    } else return false;
  };
  const checkFilledForm = () => {
    // Check if photo is taken
    if (selfieSkipIfAPI()) {
      return true;
    } else if (panSkipIfAPI()) {
      return true;
    }
    if (!permAddressObj.base64 || !permAddressObj.imgUrl) {
      return true;
    }

    // Checking if Address field is present in the uploaded Aadhar files
    else if (permAddressObj.documentId === aadhaarDocumnetId) {
      return aadharAddress ? false : true;
    } else if (corrAddressObj.documentId === corrAadhaarDocumnetId) {
      return corrAadharAddress ? false : true;
    } else {
      return false;
    }
  };

  return (
    <div>
      <div className="mgt40">
        <div className="fieldLblRight">
          <div className="explain">
            {showBrowserPermissionModal && (
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <InfoModal width={DeviceContext().isMobile ? "328px" : "354px"}>
                  <div className="explainInfo w-100">
                    <span>
                      To open your account online, we would mandatorily need
                      access to your geo locations and camera. In your browser
                      notification, click on 'Allow' to proceed ahead
                    </span>
                  </div>
                  <div>
                    <Button
                      btnName="OK"
                      onClick={() => {
                        turnOnCamera();
                        // setsShowBrowserPermissionModal(false);
                      }}
                    />
                    {/* OK
                    </Button> */}
                  </div>
                </InfoModal>
              </div>
            )}
          </div>
          {sendSmsLinkModal && (
            <div className="modal-overlay">
              <div
                className="modal-content"
                role="dialog"
                aria-modal="true"
                aria-labelledby="sms-sent-title-joint"
              >
                <h2 className="modal-title" id="sms-sent-title-joint">SMS Sent</h2>
                <div className="sr-only" aria-live="polite">
                  SMS Sent. We have sent an SMS to {GlobalStore.user.mobile} with a link for selfie verification.
                </div>
                <p className="modal-text">
                  We have sent an SMS to {GlobalStore.user.mobile}<br />
                  with a link for selfie verification.
                </p>
                <div className="modal-actions">
                  <button type="button" className="modal-button" onClick={() => setSendSmsLinkModal(false)}>
                    Got it
                  </button>
                </div>
              </div>
            </div>
          )}
          {showRemovePopup && (
            <div className="modal-overlay">
              <div
                className="modal-content"
                role="dialog"
                aria-modal="true"
                aria-labelledby="alert-title-joint"
              >
                <h2 className="modal-title" id="alert-title-joint">Alert</h2>
                <div className="sr-only" aria-live="polite">
                  Alert. This action will redirect you to the personal documents page.
                </div>
                <p className="modal-text">
                  This action will redirect you to the personal documents page.
                </p>
                <div className="modal-actions">
                  <button type="button" className="modal-button" onClick={() => {
                    try {
                      const screen_name = getScreenName(window.location.pathname);
                      if (screen_name) {
                        mixpanelService({
                          event: mixpanelEvents.CTA_CLICKED,
                          screen_name,
                          text: "Got it",
                          cta_type: "sticky",
                          cta_class: "secondary",
                          cta_service: "AOJ",
                        });
                      }
                    } catch (e) {
                      console.error("mixpanel cta_clicked failed", e);
                    }
                    setShowRemovePopup(false)
                    // history.push(dashboardUrl.personalIfo);
                    navigate(dashboardUrl.personalIfo)
                  }}>
                    Got it
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={"docForm frame" + (isLoading ? " op05" : "")}>
        {/* <Backdrop
          isShow={seedingPopup}
          onClose={() => closeSeedingPopup()}
          isCloseIcon={false}
        >
          <div className="isSeeding"> */}
        {/* {DeviceContext().isMobile && <EdelLogoCenter />} */}
        {/* <img className="seedingIcon" src={isSeeding} alt="isSeeding" />
            <span className="seedingLabel">PAN Aadhar Link</span>
            <span className="subLAbel">
              We observe that your PAN and Aadhar is not linked. There are
              higher chances of your PAN getting deactivated.
            </span>
            <div className="seedingCTA">
              <div className="borderBlue">
                <TransparentButton
                  isLoading={isLoading}
                  btnName="Re-Check"
                  onClick={() => reCheck()}
                />
              </div>
              <div>
                <Button btnName="Link PAN & Aadhar" onClick={navToLink} />
              </div>
            </div>
          </div>
        </Backdrop> */}

        <fieldset disabled={isLoading}>
          <legend className="sr-only">Document upload</legend>
          <>
            {showSignaturePopup == true ? (
              <>
                <ViewSignatureSamplePopup
                  setShowPopup={setShowSignaturePopup}
                  showPopup={showSignaturePopup}
                />
              </>
            ) : (
              ""
            )}
            {showPhotoPopup == true ? (
              <>
                <ViewPhotoSamplePopup
                  setShowPopup={setShowPhotoPopup}
                  showPopup={showPhotoPopup}
                />
              </>
            ) : (
              ""
            )}
            {showSignatureMobilePopup == true ? (
              <ViewSignatureSamplePopupMobileView
                setShowPopup={setShowSignatureMobilePopup}
                showPopup={showSignatureMobilePopup}
              />
            ) : (
              ""
            )}
            {showPhotoMobilePopup == true ? (
              <ViewPhotoSampleMobileViewProps
                setShowPopup={setShowPhotoMobilePopup}
                showPopup={showPhotoMobilePopup}
              />
            ) : (
              ""
            )}
          </>
          {regectedDocStatus &&
            regectedDocStatus.map(function (item: any, index: number) {
              return (
                <div key={index} className="mrt20">
                  {" "}
                  {item.DocumentType === "PHOTOGRAPH" && (
                    <ErrMsg>
                      <>
                        <span>
                          Reason for Rejection: {item?.RejectionReason}
                        </span>
                      </>
                    </ErrMsg>
                  )}
                </div>
              );
            })}
          {uploadDocFlag ? (
            <>
              <div className="uploadLayout">
                {firstBankList.length !== 0 ? (
                  <div className="mrt60 row">
                    <span className="bankDoc">
                      {firstBankObj.documentcategory} Document
                    </span>
                    <DropdownSearch
                      name="firstBankDoc"
                      searchLength={0}
                      options={firstBankList}
                      searchKey="DocumentName"
                      placeholder="Select Bank Document"
                      isDownArrow={true}
                      defaultValue={defaultFirstBankDoc}
                      onOptionSelect={(val) => handleBankDoc(val)}
                    />
                    <span className="bankDocSubHeading mrt10">
                      Should be in the same sequence as per the Account Creation Sequence at Nuvama
                    </span>
                    <div className="mrt20">
                      <DocumentBrowse
                        id="firstBankDoc"
                        previewImageexternalClassName={"maxSizewithAnother"}
                        docObj={firstBankObj}
                        onDocUploadComplete={onFirstBankDocUploadComplete}
                      />
                      {firstBankListError != "" ? (
                        <div>
                          {" "}
                          <br />
                          <ErrMsg>
                            <>
                              <span>{firstBankListError}</span>
                            </>
                          </ErrMsg>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* <div className="togContainer mrt40">
                      <span className="isTogLabel">
                        Would share this document later via WhatsApp
                      </span>
                      <div className="togSize">
                        {/* <Toggle
                          isOn={togFirstBank}
                          onChange={() => sendViaWatsapp("FirstBank")}
                        /> */}
                    {/* <Toggle isOn={false} onChange={() => {}} />
                      </div> */}
                    {/* </div> */}
                    <div>
                      {togFirstBank && (
                        <div className="watsLayout">
                          <span className="shareDoc">Share Documents on</span>
                          <div className="watsNum">
                            <span className="watsapp">WhatsApp</span>
                            <span className="watsAppNum">
                              <span>
                                <img className="watsappImg" src={watsAppIcon} alt="" aria-hidden="true" />
                              </span>
                              {watsappNo}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                    {regectedDocStatus &&
                      regectedDocStatus.map(function (item: any) {
                        return (
                          <div className="mrt20">
                            {" "}
                            {item.ContentType ===
                              firstBankObj.documentcategory && (
                                <ErrMsg>
                                  <>
                                    <span>
                                      Reason for Rejection: {item.RejectionReason}
                                    </span>
                                  </>
                                </ErrMsg>
                              )}
                          </div>
                        );
                      })}
                    <div className="recDiv"></div>
                  </div>
                ) : null}

                {secondBankList.length !== 0 ? (
                  <div className="mrt60 row">
                    <span className="bankDoc">
                      {secondBankObj.documentcategory} Document
                    </span>
                    <DropdownSearch
                      name="secondBankDoc"
                      searchLength={0}
                      options={secondBankList}
                      searchKey="DocumentName"
                      placeholder="Select Bank Document"
                      isDownArrow={true}
                      defaultValue={defaultSecondBankDoc}
                      onOptionSelect={(val) => handleBankDoc(val)}
                    />
                    <span className="bankDocSubHeading mrt10">
                      Should be in the same sequence as per the Account Creation Sequence at Nuvama
                    </span>
                    <div className="mrt20">
                      <DocumentBrowse
                        id="secondBankDoc"
                        previewImageexternalClassName={"maxSizewithAnother"}
                        docObj={secondBankObj}
                        onDocUploadComplete={onSecondBankDocUploadComplete}
                      />
                      {secondBankListError != "" ? (
                        <div>
                          {" "}
                          <br />
                          <ErrMsg>
                            <>
                              <span>{secondBankListError}</span>
                            </>
                          </ErrMsg>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* <div className="togContainer mrt40">
                      <span className="isTogLabel">
                        Would share this document later via WhatsApp
                      </span>
                      <div className="togSize">
                        <Toggle
                          isOn={togSecondBank}
                          onChange={() => sendViaWatsapp("SecondBank")}
                        />
                        <Toggle isOn={false} onChange={() => {}} />
                      </div>
                    </div> */}
                    <div>
                      {togSecondBank && (
                        <div className="watsLayout">
                          <span className="shareDoc">Share Documents on</span>
                          <div className="watsNum">
                            <span className="watsapp">WhatsApp</span>
                            <span className="watsAppNum">
                              <span>
                                <img className="watsappImg" src={watsAppIcon} alt="" aria-hidden="true" />
                              </span>
                              {watsappNo}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                    {regectedDocStatus &&
                      regectedDocStatus.map(function (item: any) {
                        return (
                          <div className="mrt20">
                            {" "}
                            {item.ContentType ===
                              secondBankObj.documentcategory && (
                                <ErrMsg>
                                  <>
                                    <span>
                                      Reason for Rejection: {item.RejectionReason}
                                    </span>
                                  </>
                                </ErrMsg>
                              )}
                          </div>
                        );
                      })}
                    <div className="recDiv"></div>
                  </div>
                ) : null}

                {thirdBankList.length !== 0 ? (
                  <div className="mrt60 row">
                    <span className="bankDoc">
                      {thirdBankObj.documentcategory} Document
                    </span>
                    <DropdownSearch
                      name="thirdBankDoc"
                      searchLength={0}
                      options={thirdBankList}
                      searchKey="DocumentName"
                      placeholder="Select Bank Document"
                      isDownArrow={true}
                      defaultValue={defaultThirdBankDoc}
                      onOptionSelect={(val) => handleBankDoc(val)}
                    />
                    <span className="bankDocSubHeading mrt10">
                      Should be in the same sequence as per the Account Creation Sequence at Nuvama
                    </span>
                    <div className="mrt20">
                      <DocumentBrowse
                        id="thirdBankDoc"
                        previewImageexternalClassName={"maxSizewithAnother"}
                        docObj={thirdBankObj}
                        onDocUploadComplete={onThirdBankDocUploadComplete}
                      />
                      {thirdBankListError != "" ? (
                        <div>
                          {" "}
                          <br />
                          <ErrMsg>
                            <>
                              <span>{thirdBankListError}</span>
                            </>
                          </ErrMsg>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* <div className="togContainer mrt40">
                      <span className="isTogLabel">
                        Would share this document later via WhatsApp
                      </span>
                      <div className="togSize">
                        <Toggle
                          isOn={togThirdBank}
                          onChange={() => sendViaWatsapp("ThirdBank")}
                        />
                        <Toggle isOn={false} onChange={() => {}} />
                      </div>
                    </div> */}
                    <div>
                      {togThirdBank && (
                        <div className="watsLayout">
                          <span className="shareDoc">Share Documents on</span>
                          <div className="watsNum">
                            <span className="watsapp">WhatsApp</span>
                            <span className="watsAppNum">
                              <span>
                                <img className="watsappImg" src={watsAppIcon} alt="" aria-hidden="true" />
                              </span>
                              {watsappNo}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                    {regectedDocStatus &&
                      regectedDocStatus.map(function (item: any) {
                        return (
                          <div className="mrt20">
                            {" "}
                            {item.ContentType ===
                              thirdBankObj.documentcategory && (
                                <ErrMsg>
                                  <>
                                    <span>
                                      Reason for Rejection: {item.RejectionReason}
                                    </span>
                                  </>
                                </ErrMsg>
                              )}
                          </div>
                        );
                      })}
                    <div className="recDiv"></div>
                  </div>
                ) : null}

                {fourthBankList.length !== 0 ? (
                  <div className="mrt60 row">
                    <span className="bankDoc">
                      {fourthBankObj.documentcategory} Document
                    </span>
                    <DropdownSearch
                      name="fourthBankDoc"
                      searchLength={0}
                      options={fourthBankList}
                      searchKey="DocumentName"
                      placeholder="Select Bank Document"
                      isDownArrow={true}
                      defaultValue={defaultFourthBankDoc}
                      onOptionSelect={(val) => handleBankDoc(val)}
                    />
                    <span className="bankDocSubHeading mrt10">
                      Should be in the same sequence as per the Account Creation Sequence at Nuvama
                    </span>
                    <div className="mrt20">
                      <DocumentBrowse
                        id="fourthBankDoc"
                        previewImageexternalClassName={"maxSizewithAnother"}
                        docObj={fourthBankObj}
                        onDocUploadComplete={onFourthBankDocUploadComplete}
                      />
                      {fourthBankListError != "" ? (
                        <div>
                          {" "}
                          <br />
                          <ErrMsg>
                            <>
                              <span>{fourthBankListError}</span>
                            </>
                          </ErrMsg>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* <div className="togContainer mrt40">
                      <span className="isTogLabel">
                        Would share this document later via WhatsApp
                      </span>
                      <div className="togSize"> */}
                    {/* <Toggle
                          isOn={togFourthBank}
                          onChange={() => sendViaWatsapp("FourthBank")}
                        /> */}
                    {/* <Toggle isOn={false} onChange={() => {}} />
                      </div>
                    </div> */}
                    <div>
                      {togFourthBank && (
                        <div className="watsLayout">
                          <span className="shareDoc">Share Documents on</span>
                          <div className="watsNum">
                            <span className="watsapp">WhatsApp</span>
                            <span className="watsAppNum">
                              <span>
                                <img className="watsappImg" src={watsAppIcon} alt="" aria-hidden="true" />
                              </span>
                              {watsappNo}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                    {regectedDocStatus &&
                      regectedDocStatus.map(function (item: any) {
                        return (
                          <div className="mrt20">
                            {" "}
                            {item.ContentType ===
                              fourthBankObj.documentcategory && (
                                <ErrMsg>
                                  <>
                                    <span>
                                      Reason for Rejection: {item.RejectionReason}
                                    </span>
                                  </>
                                </ErrMsg>
                              )}
                          </div>
                        );
                      })}
                    <div className="recDiv"></div>
                  </div>
                ) : null}

                {fifthBankList.length !== 0 ? (
                  <div className="mrt60 row">
                    <span className="bankDoc">
                      {fifthBankObj.documentcategory} Document
                    </span>
                    <DropdownSearch
                      name="fifthBankDoc"
                      searchLength={0}
                      options={fifthBankList}
                      searchKey="DocumentName"
                      placeholder="Select Bank Document"
                      isDownArrow={true}
                      defaultValue={defaultFifthBankDoc}
                      onOptionSelect={(val) => handleBankDoc(val)}
                    />
                    <span className="bankDocSubHeading mrt10">
                      Should be in the same sequence as per the Account Creation Sequence at Nuvama
                    </span>
                    <div className="mrt20">
                      <DocumentBrowse
                        id="fifthBankDoc"
                        previewImageexternalClassName={"maxSizewithAnother"}
                        docObj={fifthBankObj}
                        onDocUploadComplete={onFifthBankDocUploadComplete}
                      />
                      {fifthBankListError != "" ? (
                        <div>
                          {" "}
                          <br />
                          <ErrMsg>
                            <>
                              <span>{fifthBankListError}</span>
                            </>
                          </ErrMsg>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* <div className="togContainer mrt40">
                      <span className="isTogLabel">
                        Would share this document later via WhatsApp
                      </span>
                      <div className="togSize"> */}
                    {/* <Toggle
                          isOn={togFifthBank}
                          onChange={() => sendViaWatsapp("FifthBank")}
                        /> */}
                    {/* <Toggle isOn={false} onChange={() => {}} />
                      </div>
                    </div> */}
                    <div>
                      {togFifthBank && (
                        <div className="watsLayout">
                          <span className="shareDoc">Share Documents on</span>
                          <div className="watsNum">
                            <span className="watsapp">WhatsApp</span>
                            <span className="watsAppNum">
                              <span>
                                <img className="watsappImg" src={watsAppIcon} alt="" aria-hidden="true" />
                              </span>
                              {watsappNo}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                    {regectedDocStatus &&
                      regectedDocStatus.map(function (item: any) {
                        return (
                          <div className="mrt20">
                            {" "}
                            {item.ContentType ===
                              fifthBankObj.documentcategory && (
                                <ErrMsg>
                                  <>
                                    <span>
                                      Reason for Rejection: {item.RejectionReason}
                                    </span>
                                  </>
                                </ErrMsg>
                              )}
                          </div>
                        );
                      })}
                    <div className="recDiv"></div>
                  </div>
                ) : null}
                <div>
                  {!(GlobalStore?.isKRA && parseInt(userId) > 0) &&
                    panObj !== null &&
                    panObj !== undefined && (
                      <div className="mrt60 row">
                        <span className="bankDoc">Pan Card</span>
                        <div className="mrt20">
                          <DocumentBrowse
                            id="panCard"
                            docObj={panObj}
                            onDocUploadComplete={onPanDocUploadComplete}
                            previewImageexternalClassName={"maxSizewithAnother"}
                            disableRemove={false}
                            isRemove={(docOj) => onRemove(docOj, "panCard")}
                          />
                        </div>
                      </div>
                    )}
                  {regectedDocStatus &&
                    regectedDocStatus.map(function (item: any) {
                      return (
                        <div className="mrt20">
                          {" "}
                          {item.ContentType === "PROOF OF IDENTITY" &&
                            item?.DocumentType == "PAN CARD" && (
                              <ErrMsg>
                                <>
                                  <span>
                                    Reason for Rejection: {item.RejectionReason}
                                  </span>
                                </>
                              </ErrMsg>
                            )}
                        </div>
                      );
                    })}
                  {errCode && panButDisable == true && (
                    <div className="errMsgBlck errWidth mrt40">
                      <ErrMsg>
                        {typeof errCode === "number" ? (
                          <>
                            <span>We are facing some technical issue.</span>
                            <span>
                              Please try after sometime (error code:{errCode})
                            </span>
                          </>
                        ) : (
                          <span>{errCode}</span>
                        )}
                      </ErrMsg>
                    </div>
                  )}
                </div>
                {/* {!GlobalStore.isDigiLocker && ( */}
                {!GlobalStore.isDigiLocker &&
                  // For full CKYC cases without permenant address document
                  (!GlobalStore.isKYC ||
                    !GlobalStore.isKRA ||
                    !defaultPermAddressProof) &&
                  isManual !== null &&
                  isManual !== undefined &&
                  isManual && (
                    <div className="mrt60 row">
                      <label className="bankDoc" htmlFor="firstPermAddJoint">Personal Address Proof (Account Holder 1 | Primary Holder)</label>
                      <DropdownSearch
                        id="firstPermAddJoint"
                        name="firstPermAdd"
                        searchLength={0}
                        options={permAddList}
                        searchKey="DocumentName"
                        placeholder="Select Personal Address Proof"
                        isDownArrow={true}
                        defaultValue={defaultAddress}
                        disabled={blockAadhar}
                        onOptionSelect={(val) => {
                          setShowRemovePopup(true)
                          setRenderSamplePopup(false);
                          handlePermanentAddress(val);
                        }}
                      />
                      <span className="bankDocSubHeading mrt10">
                        Upload clear scanned image of both front and back of the
                        card or upload them in a single PDF.
                      </span>
                      <br />
                      <button
                        type="button"
                        className="view-sample-2"
                        onClick={() => {
                          try {
                            const screen_name = getScreenName(window.location.pathname);
                            if (screen_name) {
                              mixpanelService({
                                event: mixpanelEvents.CTA_CLICKED,
                                screen_name,
                                text: "View Sample",
                                cta_type: "sticky",
                                cta_class: "secondary",
                                cta_service: "AOJ",
                              });
                            }
                          } catch (e) {
                            console.error("mixpanel cta_clicked failed", e);
                          }
                          setRenderSamplePopup(true);
                        }}
                      >
                        View Sample
                      </button>
                      {renderSamplePopups && (
                        <>
                          {DeviceContext().isMobile ? (
                            <>
                              {getUISampleMobilePopups(
                                permAddList.find(
                                  (item: any) =>
                                    item.DocumentName === defaultAddress
                                )?.DocumentId
                              )}
                            </>
                          ) : (
                            <>
                              {getUISamplePopups(
                                permAddList.find(
                                  (item: any) =>
                                    item.DocumentName === defaultAddress
                                )?.DocumentId
                              )}
                            </>
                          )}
                        </>
                      )}
                      <div className="mrt20">
                        {(permAddressObj.disable = blockAadhar)}
                        <DocumentBrowse
                          id="permAddress"
                          docObj={permAddressObj}
                          previewImageexternalClassName={"maxSizewithAnother1"}
                          onDocUploadComplete={onFirstPermAddressUploadComplete}
                          isRemove={(docOj) => {
                            setShowRemovePopup(true)
                            onRemove(docOj, "permAddressObj")
                          }
                          }
                        />
                        {permAddListError != "" ? (
                          <div>
                            {" "}
                            <br />
                            <ErrMsg>
                              <>
                                <span>{permAddListError}</span>
                              </>
                            </ErrMsg>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      {anotherFile && (
                        <div className="row">
                          <div className="mrt20">
                            <DocumentBrowse
                              id="permSecondAddress"
                              previewImageexternalClassName={
                                "maxSizewithAnother"
                              }
                              docObj={permSecondAddressObj}
                              onDocUploadComplete={
                                onSecondPermAddressUploadComplete
                              }
                            />
                            {secondDocError != "" ? (
                              <div>
                                {" "}
                                <br />
                                <ErrMsg>
                                  <>
                                    <span>{secondDocError}</span>
                                  </>
                                </ErrMsg>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      )}
                      <div className="mrt20">
                        <button
                          type="button"
                          className={secondDoc ? "addDoc" : "addDocDisable"}
                          onClick={() => {
                            try {
                              const screen_name = getScreenName(window.location.pathname);
                              if (screen_name) {
                                mixpanelService({
                                  event: mixpanelEvents.CTA_CLICKED,
                                  screen_name,
                                  text: "Add Document",
                                  cta_type: "sticky",
                                  cta_class: "secondary",
                                  cta_service: "AOJ",
                                });
                              }
                            } catch (e) {
                              console.error("mixpanel cta_clicked failed", e);
                            }
                            addDocument();
                          }}
                        >
                          <span className="edel-icon-plus" aria-hidden="true"></span> Add Document
                        </button>
                      </div>
                      {/* <div className="togContainer mrt40">
                    <span className="isTogLabel">
                      Would share this document later via WhatsApp
                    </span>
                    <div className="togSize">
                      <Toggle
                        isOn={togPermAdd}
                        onChange={() => sendViaWatsapp("PermAddress")}
                      />
                      <Toggle isOn={false} onChange={() => {}} />
                    </div>
                  </div> */}
                      <div>
                        {togPermAdd && (
                          <div className="watsLayout">
                            <span className="shareDoc">
                              Share Documents on
                            </span>
                            <div className="watsNum">
                              <span className="watsapp">WhatsApp</span>
                              <span className="watsAppNum">
                                <span>
                                  <img
                                    className="watsappImg"
                                    src={watsAppIcon} alt="" aria-hidden="true" />
                                </span>
                                {watsappNo}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                      {regectedDocStatus &&
                        regectedDocStatus.map(function (item: any) {
                          return (
                            <div className="mrt20">
                              {" "}
                              {item.ContentType ===
                                "PROOF OF ADDRESS PERMANENT" && (
                                  <ErrMsg>
                                    <>
                                      <span>
                                        Reason for Rejection:{" "}
                                        {item.RejectionReason}
                                      </span>
                                    </>
                                  </ErrMsg>
                                )}
                            </div>
                          );
                        })}
                      <div className="recDiv"></div>
                    </div>
                  )}
                {!GlobalStore.isDigiLocker &&
                  // For full CKYC cases without permenant address document
                  (!GlobalStore.isKYC ||
                    !GlobalStore.isKRA ||
                    !defaultPermAddressProof) &&
                  !isManual && (
                    <div className="mrt60 row">
                      <label className="bankDoc" htmlFor="firstPermAddJointManual">Personal Address Proof (Account Holder 1 | Primary Holder)</label>
                      <DropdownSearch
                        id="firstPermAddJointManual"
                        name="firstPermAdd"
                        searchLength={0}
                        options={permAddList}
                        searchKey="DocumentName"
                        placeholder="Select Personal Address Proof"
                        isDownArrow={true}
                        defaultValue={defaultAddress}
                        disabled={blockAadhar}
                        onOptionSelect={(val) => {
                          setRenderSamplePopup(false);
                          handlePermanentAddress(val);
                        }}
                      />
                      <span className="bankDocSubHeading mrt10">
                        Upload clear scanned image of both front and back of the
                        card or upload them in a single PDF.
                      </span>
                      <br />
                      <button
                        type="button"
                        className="view-sample-2"
                        onClick={() => {
                          try {
                            const screen_name = getScreenName(window.location.pathname);
                            if (screen_name) {
                              mixpanelService({
                                event: mixpanelEvents.CTA_CLICKED,
                                screen_name,
                                text: "View Sample",
                                cta_type: "sticky",
                                cta_class: "secondary",
                                cta_service: "AOJ",
                              });
                            }
                          } catch (e) {
                            console.error("mixpanel cta_clicked failed", e);
                          }
                          setRenderSamplePopup(true);
                        }}
                      >
                        View Sample
                      </button>
                      {renderSamplePopups && (
                        <>
                          {DeviceContext().isMobile ? (
                            <>
                              {getUISampleMobilePopups(
                                permAddList.find(
                                  (item: any) =>
                                    item.DocumentName === defaultAddress
                                )?.DocumentId
                              )}
                            </>
                          ) : (
                            <>
                              {getUISamplePopups(
                                permAddList.find(
                                  (item: any) =>
                                    item.DocumentName === defaultAddress
                                )?.DocumentId
                              )}
                            </>
                          )}
                        </>
                      )}
                      <div className="mrt20">
                        {(permAddressObj.disable = blockAadhar)}
                        <DocumentBrowse
                          id="permAddress"
                          docObj={permAddressObj}
                          previewImageexternalClassName={"maxSizewithAnother1"}
                          onDocUploadComplete={onFirstPermAddressUploadComplete}
                          isRemove={(docOj) => {
                            onRemove(docOj, "permAddressObj")
                          }
                          }
                        />
                        {permAddListError != "" ? (
                          <div>
                            {" "}
                            <br />
                            <ErrMsg>
                              <>
                                <span>{permAddListError}</span>
                              </>
                            </ErrMsg>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      {anotherFile && (
                        <div className="row">
                          <div className="mrt20">
                            <DocumentBrowse
                              id="permSecondAddress"
                              previewImageexternalClassName={
                                "maxSizewithAnother"
                              }
                              docObj={permSecondAddressObj}
                              onDocUploadComplete={
                                onSecondPermAddressUploadComplete
                              }
                            />
                            {secondDocError != "" ? (
                              <div>
                                {" "}
                                <br />
                                <ErrMsg>
                                  <>
                                    <span>{secondDocError}</span>
                                  </>
                                </ErrMsg>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      )}
                      <div className="mrt20">
                        <button
                          type="button"
                          className={secondDoc ? "addDoc" : "addDocDisable"}
                          onClick={() => {
                            try {
                              const screen_name = getScreenName(window.location.pathname);
                              if (screen_name) {
                                mixpanelService({
                                  event: mixpanelEvents.CTA_CLICKED,
                                  screen_name,
                                  text: "Add Document",
                                  cta_type: "sticky",
                                  cta_class: "secondary",
                                  cta_service: "AOJ",
                                });
                              }
                            } catch (e) {
                              console.error("mixpanel cta_clicked failed", e);
                            }
                            addDocument();
                          }}
                        >
                          <span className="edel-icon-plus" aria-hidden="true"></span> Add Document
                        </button>
                      </div>
                      {/* <div className="togContainer mrt40">
                        <span className="isTogLabel">
                          Would share this document later via WhatsApp
                        </span>
                        <div className="togSize">
                          <Toggle
                            isOn={togPermAdd}
                            onChange={() => sendViaWatsapp("PermAddress")}
                          />
                          <Toggle isOn={false} onChange={() => {}} />
                        </div>
                      </div> */}
                      <div>
                        {togPermAdd && (
                          <div className="watsLayout">
                            <span className="shareDoc">
                              Share Documents on
                            </span>
                            <div className="watsNum">
                              <span className="watsapp">WhatsApp</span>
                              <span className="watsAppNum">
                                <span>
                                  <img
                                    className="watsappImg"
                                    src={watsAppIcon} alt="" aria-hidden="true" />
                                </span>
                                {watsappNo}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                      {regectedDocStatus &&
                        regectedDocStatus.map(function (item: any) {
                          return (
                            <div className="mrt20">
                              {" "}
                              {item.ContentType ===
                                "PROOF OF ADDRESS PERMANENT" && (
                                  <ErrMsg>
                                    <>
                                      <span>
                                        Reason for Rejection:{" "}
                                        {item.RejectionReason}
                                      </span>
                                    </>
                                  </ErrMsg>
                                )}
                            </div>
                          );
                        })}
                      <div className="recDiv"></div>
                    </div>
                  )}

                {corrAddList.length !== 0 && showCorr ? (
                  <div className="mrt60 row">
                    <span className="bankDoc">
                      Correspondence Address Proof
                    </span>
                    <DropdownSearch
                      name="firstCorrmAdd"
                      searchLength={0}
                      options={corrAddList}
                      searchKey="DocumentName"
                      placeholder="Select Correspondence Address Proof"
                      isDownArrow={true}
                      defaultValue={defaultCorrAddress}
                      onOptionSelect={(val) => {
                        setShowRemovePopup(true)
                        setRenderCorrSamplePopup(false);
                        handleCorrespondenceAddress(val);
                      }}
                    />
                    <span className="bankDocSubHeading mrt10">
                      Upload clear scanned image of both front and back of the
                      card or upload them in a single PDF.
                    </span>
                    <br />
                    <button
                      type="button"
                      className="view-sample-2"
                      onClick={() => {
                        try {
                          const screen_name = getScreenName(window.location.pathname);
                          if (screen_name) {
                            mixpanelService({
                              event: mixpanelEvents.CTA_CLICKED,
                              screen_name,
                              text: "View Sample",
                              cta_type: "sticky",
                              cta_class: "secondary",
                              cta_service: "AOJ",
                            });
                          }
                        } catch (e) {
                          console.error("mixpanel cta_clicked failed", e);
                        }
                        setRenderCorrSamplePopup(true);
                      }}
                    >
                      View Sample
                    </button>
                    {renderCorrSamplePopups && (
                      <>
                        {DeviceContext().isMobile ? (
                          <>
                            {getUISampleCorrMobilePopups(
                              corrAddList.find(
                                (item: any) =>
                                  item.DocumentName === defaultCorrAddress
                              )?.DocumentId
                            )}
                          </>
                        ) : (
                          <>
                            {getUICorrSamplePopups(
                              corrAddList.find(
                                (item: any) =>
                                  item.DocumentName === defaultCorrAddress
                              )?.DocumentId
                            )}
                          </>
                        )}
                      </>
                    )}
                    <div className="mrt20">
                      <DocumentBrowse
                        id="corrAddress"
                        previewImageexternalClassName={"maxSizewithAnother"}
                        docObj={corrAddressObj}
                        onDocUploadComplete={onFirstCorrAddressUploadComplete}
                      />
                      {corrAddListError != "" ? (
                        <div>
                          {" "}
                          <br />
                          <ErrMsg>
                            <>
                              <span>{corrAddListError}</span>
                            </>
                          </ErrMsg>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {corrAnotherFile && (
                      <div className="row">
                        <div className="mrt20">
                          <DocumentBrowse
                            id="corrSecondAddress"
                            previewImageexternalClassName={"maxSizewithAnother"}
                            docObj={corrSecondAddressObj}
                            onDocUploadComplete={
                              onSecondCorrAddressUploadComplete
                            }
                          />
                          {corrSecondDocError != "" ? (
                            <div>
                              {" "}
                              <br />
                              <ErrMsg>
                                <>
                                  <span>{corrSecondDocError}</span>
                                </>
                              </ErrMsg>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    )}
                    <div className="mrt20">
                      <button
                        type="button"
                        className={corrSecondDoc ? "addDoc" : "addDocDisable"}
                        onClick={() => {
                          try {
                            const screen_name = getScreenName(window.location.pathname);
                            if (screen_name) {
                              mixpanelService({
                                event: mixpanelEvents.CTA_CLICKED,
                                screen_name,
                                text: "Add Document",
                                cta_type: "sticky",
                                cta_class: "secondary",
                                cta_service: "AOJ",
                              });
                            }
                          } catch (e) {
                            console.error("mixpanel cta_clicked failed", e);
                          }
                          addCorrDocument();
                        }}
                      >
                        <span className="edel-icon-plus" aria-hidden="true"></span> Add Document
                      </button>
                    </div>
                    {/* <div className="togContainer mrt40">
                       <span className="isTogLabel">
                         Would share this document later via WhatsApp
                       </span>
                       <div className="togSize">
                         <Toggle
                           isOn={togCorrAdd}
                           onChange={() => sendViaWatsapp("CorrAddress")}
                         />
                         <Toggle isOn={false} onChange={() => {}} />
                       </div>
                     </div> */}
                    <div>
                      {togCorrAdd && (
                        <div className="watsLayout">
                          <span className="shareDoc">Share Documents on</span>
                          <div className="watsNum">
                            <span className="watsapp">WhatsApp</span>
                            <span className="watsAppNum">
                              <span>
                                <img className="watsappImg" src={watsAppIcon} alt="" aria-hidden="true" />
                              </span>
                              {watsappNo}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                    {regectedDocStatus &&
                      regectedDocStatus.map(function (item: any) {
                        return (
                          <div className="mrt20">
                            {" "}
                            {item.ContentType ===
                              "PROOF OF ADDRESS CORRESPONDENCE" && (
                                <ErrMsg>
                                  <>
                                    <span>
                                      Reason for Rejection: {item.RejectionReason}
                                    </span>
                                  </>
                                </ErrMsg>
                              )}
                          </div>
                        );
                      })}
                    <div className="recDiv"></div>
                  </div>
                ) : null}

                {incomeList.length !== 0 ? (
                  <div className="mrt60 row">
                    <span className="bankDoc">Income Proof (Optional)</span>
                    <DropdownSearch
                      name="incomeProof"
                      searchLength={0}
                      options={incomeList}
                      searchKey="DocumentName"
                      placeholder="Select Income Proof"
                      isDownArrow={true}
                      defaultValue={defaultIncomeDoc}
                      onOptionSelect={(val) => handleIncomeProof(val)}
                    />
                    <span className="bankDocSubHeading mrt10">
                      Note: Income Proof is required for trading in derivative
                      segment
                    </span>
                    <div className="mrt20">
                      <DocumentBrowse
                        id="incomeDoc"
                        previewImageexternalClassName={"maxSizewithAnother"}
                        docObj={{ ...incomeObj }}
                        onDocUploadComplete={onIncomeUploadComplete}
                      />
                      {incomeListError != "" ? (
                        <div>
                          {" "}
                          <br />
                          <ErrMsg>
                            <>
                              <span>{incomeListError}</span>
                            </>
                          </ErrMsg>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* <div className="togContainer mrt40">
                      <span className="isTogLabel">
                        Would share this document later via WhatsApp
                      </span>
                      <div className="togSize"> */}
                    {/* <Toggle
                          isOn={togIncome}
                          onChange={() => sendViaWatsapp("Income")}
                        /> */}
                    {/* <Toggle isOn={false} onChange={() => {}} />
                      </div>
                    </div> */}
                    <div>
                      {togIncome && (
                        <div className="watsLayout">
                          <span className="shareDoc">Share Documents on</span>
                          <div className="watsNum">
                            <span className="watsapp">WhatsApp</span>
                            <span className="watsAppNum">
                              <span>
                                <img className="watsappImg" src={watsAppIcon} alt="" aria-hidden="true" />
                              </span>
                              {watsappNo}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                    {regectedDocStatus &&
                      regectedDocStatus.map(function (item: any) {
                        return (
                          <div className="mrt20">
                            {" "}
                            {item.ContentType === "PROOF OF INCOME" && (
                              <ErrMsg>
                                <>
                                  <span>
                                    Reason for Rejection: {item.RejectionReason}
                                  </span>
                                </>
                              </ErrMsg>
                            )}
                          </div>
                        );
                      })}
                    <div className="recDiv"></div>
                  </div>
                ) : null}

                <div className="mrt60 row">
                  <span className="signature-sample">
                    <span className="shareDoc">Authenticate (Account Holder 1 | Primary Holder)</span>
                  </span>
                  {showSignatureTwoPopup == true ? (
                    <>
                      {DeviceContext()?.isMobile ? (
                        <>
                          <ViewSignatureSamplePopupMobileView
                            setShowPopup={setShowSignatureTwoPopup}
                            showPopup={showSignatureTwoPopup}
                          />
                        </>
                      ) : (
                        <>
                          <ViewSignatureSamplePopup
                            setShowPopup={setShowSignatureTwoPopup}
                            showPopup={showSignatureTwoPopup}
                            parentClassName="signature-popup"
                          />
                        </>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  <fieldset className="signature-container-doc">
                    <legend className="photoSubHeading mrt10">
                      Add you signature for authentication. You can choose one of the option below:
                    </legend>
                    {/* Upload Signature Option */}
                    {!signatureObj?.uploadPer && (
                      <>
                        <div className="option-row">
                          <input
                            type="radio"
                            id="signatureOption-upload-joint"
                            name="signatureOption"
                            value="upload"
                            checked={signatureOption === "upload"}
                            aria-required={true}
                            onChange={(e) => {
                              setSdkResult(null);
                              setSignatureOption(e.target.value);
                              setSignatureOption("upload")
                              let signatureCopy = { ...initialPanDocObj };
                              signatureCopy.documentcategory = "Signature";
                              signatureCopy.documentCategoryId = "27";
                              signatureCopy.documentId = 305;
                              signatureCopy.isElogSignOpted = true;
                              setSignatureObj(signatureCopy);
                              onSignatureUploadCompleteElog(
                                "",
                                "",
                                "signature",
                                "image/jpeg",
                                false
                              );
                            }}
                          />
                          <div>
                            <div style={{ display: 'flex' }}>
                              <label htmlFor="signatureOption-upload-joint" className="option-label">Signature</label>
                              <span className="recommended">Recommended</span>
                              <button
                                type="button"
                                className="view-sample"
                                style={{ flex: 'auto', flexDirection: 'row-reverse', display: "flex" }}
                                onClick={() => {
                                  try {
                                    const screen_name = getScreenName(window.location.pathname);
                                    if (screen_name) {
                                      mixpanelService({
                                        event: mixpanelEvents.CTA_CLICKED,
                                        screen_name,
                                        text: "View Guideline",
                                        cta_type: "sticky",
                                        cta_class: "secondary",
                                        cta_service: "AOJ",
                                      });
                                    }
                                  } catch (e) {
                                    console.error("mixpanel cta_clicked failed", e);
                                  }
                                  setShowSignatureTwoPopup(true);
                                }}
                              >
                                View Guideline
                              </button>
                            </div>
                            <div>
                              <div className="subtext">Upload a clear image of your signature in Blue/Black ink on a blank white.</div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {signatureOption === "upload" && (
                      <>
                        <div className="mrt20">
                          <span className="mrb10">1st Holder (Primary)</span>
                          <DocumentBrowse
                            id="signature"
                            previewImageexternalClassName={"maxSizewithAnother"}
                            docObj={signatureObj}
                            onDocUploadComplete={signatureUpload}
                            // mandateRemove={true}
                            isRemove={(obj) => {
                              setSignatureObj({
                                ...signatureObj,
                                disable: false,
                                uploadPer: 0,
                                hideProgress: true,
                                showFile: true
                              })
                            }}
                          />
                          {signatureListError !== "" && (
                            <div>
                              <br />
                              <ErrMsg>
                                <span>{signatureListError}</span>
                              </ErrMsg>
                            </div>
                          )}
                        </div>
                        {regectedDocStatus && regectedDocStatus.filter((a: any) => a.DocumentType === "SIGNATURE" && a.DocumentCategoryId == 27).map(function (item: any) {
                          return (
                            <div className="mrt20">
                              <ErrMsg>
                                <>
                                  <span>
                                    Reason for Rejection: {item?.RejectionReason}
                                  </span>
                                </>
                              </ErrMsg>
                            </div>
                          );
                        })}
                        {signaturesArr.map((sign, i) => (
                          <div className="mrt20">
                            <span className="mrb10">Holder {i + 2}</span>
                            <DocumentBrowse
                              id={`signature_${sign.documentCategoryId}`}
                              previewImageexternalClassName={"maxSizewithAnother"}
                              docObj={sign}
                              // onDocUploadComplete={onSignatureUploadComplete}
                              onDocUploadComplete={signatureUpload}
                              // mandateRemove={true}
                              isRemove={(obj) => {
                                setSignatureObjSecond({
                                  ...signatureObjSecond,
                                  disable: false,
                                  uploadPer: 0,
                                  hideProgress: true,
                                  showFile: true
                                })
                              }}
                            />
                            {signatureArrError.length > 0 && (
                              <div>
                                <br />
                                <ErrMsg>
                                  <span>{signatureArrError.find((a: any) => a.id == `signature_${sign.documentCategoryId}`)?.err}</span>
                                </ErrMsg>
                              </div>
                            )}
                            {regectedDocStatus && regectedDocStatus.filter((a: any) => a.DocumentType === "SIGNATURE" && a.DocumentCategoryId == sign.documentCategoryId).map(function (item: any) {
                              return (
                                <div className="mrt20">
                                  <ErrMsg>
                                    <>
                                      <span>
                                        Reason for Rejection: {item?.RejectionReason}
                                      </span>
                                    </>
                                  </ErrMsg>
                                </div>
                              );
                            })}
                          </div>
                        ))}
                      </>
                    )}

                    {/* elog signature */}
                    {GlobalStore?.isKRA && GlobalStore?.stageStatus?.accountcategory == 2 && (
                      <div className="option-row">
                        <input
                          type="radio"
                          id="signatureOption-elog-joint"
                          name="signatureOption"
                          value="elog"
                          checked={signatureOption === "elog"}
                          aria-required={true}
                          onChange={(e) => {
                            setSignatureOption("elog")
                            let signatureCopy = { ...initialPanDocObj };
                            signatureCopy.documentcategory = "Signature";
                            signatureCopy.documentCategoryId = "27";
                            signatureCopy.documentId = 305;
                            signatureCopy.isElogSignOpted = true;
                            setSignatureObj(signatureCopy);
                            onSignatureUploadCompleteElog(
                              "",
                              "",
                              "signature",
                              "image/jpeg",
                              true
                            );
                          }}
                        />
                        <div>
                          <label htmlFor="signatureOption-elog-joint" className="option-label">E-Log (Authentication via BSE STAR MF)</label>
                          {/* {signatureOption === "elog" && ( */}
                          <div className="subtext">Fast and seamless authentication with OTP.</div>
                          {/* )} */}
                        </div>
                      </div>
                    )}

                    {sdkResult?.cropped_sign && (
                      <div className="signature-preview">
                        {/* Close button */}
                        <button
                          type="button"
                          className="signature-close-btn"
                          aria-label="Remove signature preview"
                          onClick={() => {
                            try {
                              const screen_name = getScreenName(window.location.pathname);
                              if (screen_name) {
                                mixpanelService({
                                  event: mixpanelEvents.CTA_CLICKED,
                                  screen_name,
                                  text: "Remove signature preview",
                                  cta_type: "sticky",
                                  cta_class: "secondary",
                                  cta_service: "AOJ",
                                });
                              }
                            } catch (e) {
                              console.error("mixpanel cta_clicked failed", e);
                            }
                            setSignatureObj({
                              ...signatureObj,
                              disable: false,
                              uploadPer: 0,
                              hideProgress: true,
                              showFile: true,
                            });
                            setSdkResult(null);
                          }}
                        >
                          ×
                        </button>

                        {/* Signature image */}
                        <img
                          className="signature-img"
                          src={`data:image/jpeg;base64,${sdkResult.cropped_sign}`}
                          alt="Signature"
                        />

                        {/* Bottom line */}
                        <hr className="signature-divider" />
                      </div>
                    )}

                    {sdkError && <p className="error-text" role="alert" aria-live="assertive">Error: {sdkError.message}</p>}
                  </fieldset>

                  {/* <div className="mrt20">
                    <DocumentBrowse
                      id="signature"
                      previewImageexternalClassName={"maxSizewithAnother"}
                      docObj={signatureObj}
                      onDocUploadComplete={onSignatureUploadComplete}
                    // mandateRemove={true}
                    />
                    {signatureListError != "" ? (
                      <div>
                        {" "}
                        <br />
                        <ErrMsg>
                          <>
                            <span>{signatureListError}</span>
                          </>
                        </ErrMsg>
                      </div>
                    ) : (
                      ""
                    )}
                  </div> */}
                  {/* <div className="togContainer mrt40">
                    <span className="isTogLabel">
                      Would share this document later via WhatsApp
                    </span>
                    <div className="togSize">
                      <Toggle
                        isOn={togSig}
                        onChange={() => sendViaWatsapp("Signature")}
                      />
                      <Toggle isOn={false} onChange={() => {}} />
                    </div>
                  </div> */}
                  <div>
                    {togSig && (
                      <div className="watsLayout">
                        <span className="shareDoc">Share Documents on</span>
                        <div className="watsNum">
                          <span className="watsapp">WhatsApp</span>
                          <span className="watsAppNum">
                            <span>
                              <img className="watsappImg" src={watsAppIcon} alt="" aria-hidden="true" />
                            </span>
                            {watsappNo}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* nomineefirst Start */}
                {nomineeFirstList && nomineeFirstList.length > 0 && (
                  <>
                    <div className="mrt60 row">
                      <span className="shareDoc">Nominee 1</span>
                      <div className="mrt20">
                        {nomineeFirstList.map((data: any, index: number) => {
                          if (
                            data.DocumentCategoryId ===
                            nomineeDocsIds.nomineeOne.photo.documentCategoryId
                          ) {
                            return (
                              <>
                                <p>Photo</p>
                                <DocumentBrowse
                                  id="nomFirstPhotoId"
                                  previewImageexternalClassName={
                                    "maxSizewithAnother"
                                  }
                                  docObj={nomineeFirstObj[0]}
                                  onDocUploadComplete={(
                                    val,
                                    fileName,
                                    id,
                                    type
                                  ) =>
                                    onNomineeUploadComplete(
                                      val,
                                      fileName,
                                      id,
                                      type,
                                      index
                                    )
                                  }
                                  isRemove={(removeDocObj) =>
                                    handleRemoveDoc(
                                      index,
                                      "nomFirstPhotoId",
                                      removeDocObj
                                    )
                                  }
                                />
                                {nomineeGuardianError.nomFirstPhotoId != "" ? (
                                  <div>
                                    {" "}
                                    <br />
                                    <ErrMsg>
                                      <>
                                        <span>
                                          {nomineeGuardianError.nomFirstPhotoId}
                                        </span>
                                      </>
                                    </ErrMsg>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {regectedDocStatus &&
                                  regectedDocStatus.map(function (item: any) {
                                    return (
                                      <div className="mrt20">
                                        {" "}
                                        {item.DocumentCategoryId ===
                                          nomineeDocsIds.nomineeOne.photo
                                            .documentCategoryId && (
                                            <ErrMsg>
                                              <>
                                                <span>
                                                  Reason for Rejection:{" "}
                                                  {item?.RejectionReason}
                                                </span>
                                              </>
                                            </ErrMsg>
                                          )}
                                      </div>
                                    );
                                  })}
                              </>
                            );
                          } else if (
                            data.DocumentCategoryId ===
                            nomineeDocsIds.nomineeOne.signature
                              .documentCategoryId
                          ) {
                            return (
                              <>
                                <p>Signature</p>
                                <DocumentBrowse
                                  id="nomFirstSignature"
                                  previewImageexternalClassName={
                                    "maxSizewithAnother"
                                  }
                                  docObj={nomineeFirstObj[1]}
                                  onDocUploadComplete={(
                                    val,
                                    fileName,
                                    id,
                                    type
                                  ) =>
                                    onNomineeUploadComplete(
                                      val,
                                      fileName,
                                      id,
                                      type,
                                      index
                                    )
                                  }
                                  isRemove={(removeDocObj) =>
                                    handleRemoveDoc(
                                      index,
                                      "nomFirstSignature",
                                      removeDocObj
                                    )
                                  }
                                />
                                {nomineeGuardianError.nomFirstSignature !=
                                  "" ? (
                                  <div>
                                    {" "}
                                    <br />
                                    <ErrMsg>
                                      <>
                                        <span>
                                          {
                                            nomineeGuardianError.nomFirstSignature
                                          }
                                        </span>
                                      </>
                                    </ErrMsg>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {regectedDocStatus &&
                                  regectedDocStatus.map(function (item: any) {
                                    return (
                                      <div className="mrt20">
                                        {" "}
                                        {item.DocumentCategoryId ===
                                          nomineeDocsIds.nomineeOne.signature
                                            .documentCategoryId && (
                                            <ErrMsg>
                                              <>
                                                <span>
                                                  Reason for Rejection:{" "}
                                                  {item?.RejectionReason}
                                                </span>
                                              </>
                                            </ErrMsg>
                                          )}
                                      </div>
                                    );
                                  })}
                              </>
                            );
                          }
                        })}
                      </div>
                      {/* <div className="togContainer mrt40">
                        <span className="isTogLabel">
                          Would share this document later via WhatsApp
                        </span>
                        <div className="togSize">
                          <Toggle
                            isOn={nomineeGuardianTog.nomineeFirst}
                            onChange={() => sendViaWatsapp("nomineeFirst")}
                          />
                        </div>
                      </div> */}
                      <div>
                        {nomineeGuardianTog.nomineeFirst && (
                          <div className="watsLayout">
                            <span className="shareDoc">
                              Share Documents on
                            </span>
                            <div className="watsNum">
                              <span className="watsapp">WhatsApp</span>
                              <span className="watsAppNum">
                                <span>
                                  <img
                                    className="watsappImg"
                                    src={watsAppIcon} alt="" aria-hidden="true" />
                                </span>
                                {watsappNo}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
                {/* nomineeFirst End */}
                {/* GuardianFirst Start */}

                {guardianFirstList && guardianFirstList.length > 0 && (
                  <>
                    <div className="mrt60 row">
                      <span className="shareDoc">Guardian 1</span>
                      <div className="mrt20">
                        {guardianFirstList.map((data: any, index: number) => {
                          if (
                            data.DocumentCategoryId ===
                            nomineeDocsIds.nomineeOne.guardianDetails.photo
                              .documentCategoryId
                          ) {
                            return (
                              <>
                                <p>Photo</p>
                                <DocumentBrowse
                                  id="guardianFirstPhotoId"
                                  previewImageexternalClassName={
                                    "maxSizewithAnother"
                                  }
                                  docObj={guardianFirstObj[0]}
                                  onDocUploadComplete={(
                                    val,
                                    fileName,
                                    id,
                                    type
                                  ) =>
                                    onNomineeUploadComplete(
                                      val,
                                      fileName,
                                      id,
                                      type,
                                      index
                                    )
                                  }
                                  isRemove={(removeDocObj) =>
                                    handleRemoveDoc(
                                      index,
                                      "guardianFirstPhotoId",
                                      removeDocObj
                                    )
                                  }
                                />
                                {nomineeGuardianError.guardianFirstPhotoId !=
                                  "" ? (
                                  <div>
                                    {" "}
                                    <br />
                                    <ErrMsg>
                                      <>
                                        <span>
                                          {
                                            nomineeGuardianError.guardianFirstPhotoId
                                          }
                                        </span>
                                      </>
                                    </ErrMsg>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {regectedDocStatus &&
                                  regectedDocStatus.map(function (item: any) {
                                    return (
                                      <div className="mrt20">
                                        {" "}
                                        {item.DocumentCategoryId ===
                                          nomineeDocsIds.nomineeOne
                                            .guardianDetails.photo
                                            .documentCategoryId && (
                                            <ErrMsg>
                                              <>
                                                <span>
                                                  Reason for Rejection:{" "}
                                                  {item?.RejectionReason}
                                                </span>
                                              </>
                                            </ErrMsg>
                                          )}
                                      </div>
                                    );
                                  })}
                              </>
                            );
                          } else if (
                            data.DocumentCategoryId ===
                            nomineeDocsIds.nomineeOne.guardianDetails.signature
                              .documentCategoryId
                          ) {
                            return (
                              <>
                                <p>Signature</p>
                                <DocumentBrowse
                                  id="guardianFirstSignature"
                                  previewImageexternalClassName={
                                    "maxSizewithAnother"
                                  }
                                  docObj={guardianFirstObj[1]}
                                  onDocUploadComplete={(
                                    val,
                                    fileName,
                                    id,
                                    type
                                  ) =>
                                    onNomineeUploadComplete(
                                      val,
                                      fileName,
                                      id,
                                      type,
                                      index
                                    )
                                  }
                                  isRemove={(removeDocObj) =>
                                    handleRemoveDoc(
                                      index,
                                      "guardianFirstSignature",
                                      removeDocObj
                                    )
                                  }
                                />
                                {nomineeGuardianError.guardianFirstSignature !=
                                  "" ? (
                                  <div>
                                    {" "}
                                    <br />
                                    <ErrMsg>
                                      <>
                                        <span>
                                          {
                                            nomineeGuardianError.guardianFirstSignature
                                          }
                                        </span>
                                      </>
                                    </ErrMsg>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {regectedDocStatus &&
                                  regectedDocStatus.map(function (item: any) {
                                    return (
                                      <div className="mrt20">
                                        {" "}
                                        {item.DocumentCategoryId ===
                                          nomineeDocsIds.nomineeOne
                                            .guardianDetails.signature
                                            .documentCategoryId && (
                                            <ErrMsg>
                                              <>
                                                <span>
                                                  Reason for Rejection:{" "}
                                                  {item?.RejectionReason}
                                                </span>
                                              </>
                                            </ErrMsg>
                                          )}
                                      </div>
                                    );
                                  })}
                              </>
                            );
                          }
                        })}
                      </div>
                      {/* <div className="togContainer mrt40">
                        <span className="isTogLabel">
                          Would share this document later via WhatsApp
                        </span>
                        <div className="togSize">
                          <Toggle
                            isOn={nomineeGuardianTog.guardianFirst}
                            onChange={() => sendViaWatsapp("guardianFirst")}
                          />
                        </div>
                      </div> */}
                      <div>
                        {nomineeGuardianTog.guardianFirst && (
                          <div className="watsLayout">
                            <span className="shareDoc">
                              Share Documents on
                            </span>
                            <div className="watsNum">
                              <span className="watsapp">WhatsApp</span>
                              <span className="watsAppNum">
                                <span>
                                  <img
                                    className="watsappImg"
                                    src={watsAppIcon} alt="" aria-hidden="true" />
                                </span>
                                {watsappNo}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
                {/* GuardianFirst End */}

                {/* nomineeSecond start */}
                {nomineeSecondList && nomineeSecondList.length > 0 && (
                  <>
                    <div className="mrt60 row">
                      <span className="shareDoc">Nominee 2</span>
                      <div className="mrt20">
                        {nomineeSecondList.map((data: any, index: number) => {
                          if (
                            data.DocumentCategoryId ===
                            nomineeDocsIds.nomineeTwo.photo.documentCategoryId
                          ) {
                            return (
                              <>
                                <p>Photo</p>
                                <DocumentBrowse
                                  id="nomSecondPhotoId"
                                  previewImageexternalClassName={
                                    "maxSizewithAnother"
                                  }
                                  docObj={nomineeSecondObj[0]}
                                  onDocUploadComplete={(
                                    val,
                                    fileName,
                                    id,
                                    type
                                  ) =>
                                    onNomineeUploadComplete(
                                      val,
                                      fileName,
                                      id,
                                      type,
                                      index
                                    )
                                  }
                                  isRemove={(removeDocObj) =>
                                    handleRemoveDoc(
                                      index,
                                      "nomSecondPhotoId",
                                      removeDocObj
                                    )
                                  }
                                />
                                {nomineeGuardianError.nomSecondPhotoId != "" ? (
                                  <div>
                                    {" "}
                                    <br />
                                    <ErrMsg>
                                      <>
                                        <span>
                                          {
                                            nomineeGuardianError.nomSecondPhotoId
                                          }
                                        </span>
                                      </>
                                    </ErrMsg>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {regectedDocStatus &&
                                  regectedDocStatus.map(function (item: any) {
                                    return (
                                      <div className="mrt20">
                                        {" "}
                                        {item.DocumentCategoryId ===
                                          nomineeDocsIds.nomineeTwo.photo
                                            .documentCategoryId && (
                                            <ErrMsg>
                                              <>
                                                <span>
                                                  Reason for Rejection:{" "}
                                                  {item?.RejectionReason}
                                                </span>
                                              </>
                                            </ErrMsg>
                                          )}
                                      </div>
                                    );
                                  })}
                              </>
                            );
                          } else if (
                            data.DocumentCategoryId ===
                            nomineeDocsIds.nomineeTwo.signature
                              .documentCategoryId
                          ) {
                            return (
                              <>
                                <p>Signature</p>
                                <DocumentBrowse
                                  id="nomSecondSignature"
                                  previewImageexternalClassName={
                                    "maxSizewithAnother"
                                  }
                                  docObj={nomineeSecondObj[1]}
                                  onDocUploadComplete={(
                                    val,
                                    fileName,
                                    id,
                                    type
                                  ) =>
                                    onNomineeUploadComplete(
                                      val,
                                      fileName,
                                      id,
                                      type,
                                      index
                                    )
                                  }
                                  isRemove={(removeDocObj) =>
                                    handleRemoveDoc(
                                      index,
                                      "nomSecondSignature",
                                      removeDocObj
                                    )
                                  }
                                />
                                {nomineeGuardianError.nomSecondSignature !=
                                  "" ? (
                                  <div>
                                    {" "}
                                    <br />
                                    <ErrMsg>
                                      <>
                                        <span>
                                          {
                                            nomineeGuardianError.nomSecondSignature
                                          }
                                        </span>
                                      </>
                                    </ErrMsg>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {regectedDocStatus &&
                                  regectedDocStatus.map(function (item: any) {
                                    return (
                                      <div className="mrt20">
                                        {" "}
                                        {item.DocumentCategoryId ===
                                          nomineeDocsIds.nomineeTwo.signature
                                            .documentCategoryId && (
                                            <ErrMsg>
                                              <>
                                                <span>
                                                  Reason for Rejection:{" "}
                                                  {item?.RejectionReason}
                                                </span>
                                              </>
                                            </ErrMsg>
                                          )}
                                      </div>
                                    );
                                  })}
                              </>
                            );
                          }
                        })}
                      </div>
                      {/* <div className="togContainer mrt40">
                        <span className="isTogLabel">
                          Would share this document later via WhatsApp
                        </span>
                        <div className="togSize">
                          <Toggle
                            isOn={nomineeGuardianTog.nomineeSecond}
                            onChange={() => sendViaWatsapp("nomineeSecond")}
                          />
                        </div>
                      </div> */}
                      <div>
                        {nomineeGuardianTog.nomineeSecond && (
                          <div className="watsLayout">
                            <span className="shareDoc">
                              Share Documents on
                            </span>
                            <div className="watsNum">
                              <span className="watsapp">WhatsApp</span>
                              <span className="watsAppNum">
                                <span>
                                  <img
                                    className="watsappImg"
                                    src={watsAppIcon} alt="" aria-hidden="true" />
                                </span>
                                {watsappNo}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
                {/* nomineeSecond End */}
                {/* GuardianSecond Start */}
                {guardianSecondList && guardianSecondList.length > 0 && (
                  <>
                    <div className="mrt60 row">
                      <span className="shareDoc">Guardian 2</span>
                      <div className="mrt20">
                        {guardianSecondList.map((data: any, index: number) => {
                          if (
                            data.DocumentCategoryId ===
                            nomineeDocsIds.nomineeTwo.guardianDetails.photo
                              .documentCategoryId
                          ) {
                            return (
                              <>
                                <p>Photo</p>
                                <DocumentBrowse
                                  id="guardianSecondPhotoId"
                                  previewImageexternalClassName={
                                    "maxSizewithAnother"
                                  }
                                  docObj={guardianSecondObj[0]}
                                  onDocUploadComplete={(
                                    val,
                                    fileName,
                                    id,
                                    type
                                  ) =>
                                    onNomineeUploadComplete(
                                      val,
                                      fileName,
                                      id,
                                      type,
                                      index
                                    )
                                  }
                                  isRemove={(removeDocObj) =>
                                    handleRemoveDoc(
                                      index,
                                      "guardianSecondPhotoId",
                                      removeDocObj
                                    )
                                  }
                                />
                                {nomineeGuardianError.guardianSecondPhotoId !=
                                  "" ? (
                                  <div>
                                    {" "}
                                    <br />
                                    <ErrMsg>
                                      <>
                                        <span>
                                          {
                                            nomineeGuardianError.guardianSecondPhotoId
                                          }
                                        </span>
                                      </>
                                    </ErrMsg>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {regectedDocStatus &&
                                  regectedDocStatus.map(function (item: any) {
                                    return (
                                      <div className="mrt20">
                                        {" "}
                                        {item.DocumentCategoryId ===
                                          nomineeDocsIds.nomineeTwo
                                            .guardianDetails.photo
                                            .documentCategoryId && (
                                            <ErrMsg>
                                              <>
                                                <span>
                                                  Reason for Rejection:{" "}
                                                  {item?.RejectionReason}
                                                </span>
                                              </>
                                            </ErrMsg>
                                          )}
                                      </div>
                                    );
                                  })}
                              </>
                            );
                          } else if (
                            data.DocumentCategoryId ===
                            nomineeDocsIds.nomineeTwo.guardianDetails.signature
                              .documentCategoryId
                          ) {
                            return (
                              <>
                                <p>Signature</p>
                                <DocumentBrowse
                                  id="guardianSecondSignature"
                                  previewImageexternalClassName={
                                    "maxSizewithAnother"
                                  }
                                  docObj={guardianSecondObj[1]}
                                  onDocUploadComplete={(
                                    val,
                                    fileName,
                                    id,
                                    type
                                  ) =>
                                    onNomineeUploadComplete(
                                      val,
                                      fileName,
                                      id,
                                      type,
                                      index
                                    )
                                  }
                                  isRemove={(removeDocObj) =>
                                    handleRemoveDoc(
                                      index,
                                      "guardianSecondSignature",
                                      removeDocObj
                                    )
                                  }
                                />
                                {nomineeGuardianError.guardianSecondSignature !=
                                  "" ? (
                                  <div>
                                    {" "}
                                    <br />
                                    <ErrMsg>
                                      <>
                                        <span>
                                          {
                                            nomineeGuardianError.guardianSecondSignature
                                          }
                                        </span>
                                      </>
                                    </ErrMsg>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {regectedDocStatus &&
                                  regectedDocStatus.map(function (item: any) {
                                    return (
                                      <div className="mrt20">
                                        {" "}
                                        {item.DocumentCategoryId ===
                                          nomineeDocsIds.nomineeTwo
                                            .guardianDetails.signature
                                            .documentCategoryId && (
                                            <ErrMsg>
                                              <>
                                                <span>
                                                  Reason for Rejection:{" "}
                                                  {item?.RejectionReason}
                                                </span>
                                              </>
                                            </ErrMsg>
                                          )}
                                      </div>
                                    );
                                  })}
                              </>
                            );
                          }
                        })}
                      </div>
                      {/* <div className="togContainer mrt40">
                        <span className="isTogLabel">
                          Would share this document later via WhatsApp
                        </span>
                        <div className="togSize">
                          <Toggle
                            isOn={nomineeGuardianTog.guardianSecond}
                            onChange={() => sendViaWatsapp("guardianSecond")}
                          />
                        </div>
                      </div> */}
                      <div>
                        {nomineeGuardianTog.guardianSecond && (
                          <div className="watsLayout">
                            <span className="shareDoc">
                              Share Documents on
                            </span>
                            <div className="watsNum">
                              <span className="watsapp">WhatsApp</span>
                              <span className="watsAppNum">
                                <span>
                                  <img
                                    className="watsappImg"
                                    src={watsAppIcon} alt="" aria-hidden="true" />
                                </span>
                                {watsappNo}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
                {/* GuardianSecond End */}
                {/* nomineeThird */}
                {nomineeThirdList && nomineeThirdList.length > 0 && (
                  <>
                    <div className="mrt60 row">
                      <span className="shareDoc">Nominee 3</span>
                      <div className="mrt20">
                        {nomineeThirdList.map((data: any, index: number) => {
                          if (
                            data.DocumentCategoryId ===
                            nomineeDocsIds.nomineeThree.photo.documentCategoryId
                          ) {
                            return (
                              <>
                                <p>Photo</p>
                                <DocumentBrowse
                                  id="nomThirdPhotoId"
                                  previewImageexternalClassName={
                                    "maxSizewithAnother"
                                  }
                                  docObj={nomineeThirdObj[0]}
                                  onDocUploadComplete={(
                                    val,
                                    fileName,
                                    id,
                                    type
                                  ) =>
                                    onNomineeUploadComplete(
                                      val,
                                      fileName,
                                      id,
                                      type,
                                      index
                                    )
                                  }
                                  isRemove={(removeDocObj) =>
                                    handleRemoveDoc(
                                      index,
                                      "nomThirdPhotoId",
                                      removeDocObj
                                    )
                                  }
                                />
                                {nomineeGuardianError.nomThirdPhotoId != "" ? (
                                  <div>
                                    {" "}
                                    <br />
                                    <ErrMsg>
                                      <>
                                        <span>
                                          {nomineeGuardianError.nomThirdPhotoId}
                                        </span>
                                      </>
                                    </ErrMsg>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {regectedDocStatus &&
                                  regectedDocStatus.map(function (item: any) {
                                    return (
                                      <div className="mrt20">
                                        {" "}
                                        {item.DocumentCategoryId ===
                                          nomineeDocsIds.nomineeThree.photo
                                            .documentCategoryId && (
                                            <ErrMsg>
                                              <>
                                                <span>
                                                  Reason for Rejection:{" "}
                                                  {item?.RejectionReason}
                                                </span>
                                              </>
                                            </ErrMsg>
                                          )}
                                      </div>
                                    );
                                  })}
                              </>
                            );
                          } else if (
                            data.DocumentCategoryId ===
                            nomineeDocsIds.nomineeThree.signature
                              .documentCategoryId
                          ) {
                            return (
                              <>
                                <p>Signature</p>
                                <DocumentBrowse
                                  id="nomThirdSignature"
                                  previewImageexternalClassName={
                                    "maxSizewithAnother"
                                  }
                                  docObj={nomineeThirdObj[1]}
                                  onDocUploadComplete={(
                                    val,
                                    fileName,
                                    id,
                                    type
                                  ) =>
                                    onNomineeUploadComplete(
                                      val,
                                      fileName,
                                      id,
                                      type,
                                      index
                                    )
                                  }
                                  isRemove={(removeDocObj) =>
                                    handleRemoveDoc(
                                      index,
                                      "nomThirdSignature",
                                      removeDocObj
                                    )
                                  }
                                />

                                {nomineeGuardianError.nomThirdSignature !=
                                  "" ? (
                                  <div>
                                    {" "}
                                    <br />
                                    <ErrMsg>
                                      <>
                                        <span>
                                          {
                                            nomineeGuardianError.nomThirdSignature
                                          }
                                        </span>
                                      </>
                                    </ErrMsg>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {regectedDocStatus &&
                                  regectedDocStatus.map(function (item: any) {
                                    return (
                                      <div className="mrt20">
                                        {" "}
                                        {item.DocumentCategoryId ===
                                          nomineeDocsIds.nomineeThree.signature
                                            .documentCategoryId && (
                                            <ErrMsg>
                                              <>
                                                <span>
                                                  Reason for Rejection:{" "}
                                                  {item?.RejectionReason}
                                                </span>
                                              </>
                                            </ErrMsg>
                                          )}
                                      </div>
                                    );
                                  })}
                              </>
                            );
                          }
                        })}
                      </div>
                      {/* <div className="togContainer mrt40">
                        <span className="isTogLabel">
                          Would share this document later via WhatsApp
                        </span>
                        <div className="togSize">
                          <Toggle
                            isOn={nomineeGuardianTog.nomineeThree}
                            onChange={() => sendViaWatsapp("nomineeThree")}
                          />
                        </div>
                      </div> */}
                      <div>
                        {nomineeGuardianTog.nomineeThree && (
                          <div className="watsLayout">
                            <span className="shareDoc">
                              Share Documents on
                            </span>
                            <div className="watsNum">
                              <span className="watsapp">WhatsApp</span>
                              <span className="watsAppNum">
                                <span>
                                  <img
                                    className="watsappImg"
                                    src={watsAppIcon} alt="" aria-hidden="true" />
                                </span>
                                {watsappNo}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
                {/* NomineeThird Start */}

                {/* GuardianThird Start */}
                {guardianThirdList && guardianThirdList.length > 0 && (
                  <>
                    <div className="mrt60 row">
                      <span className="shareDoc">Guardian 3</span>
                      <div className="mrt20">
                        {guardianThirdList.map((data: any, index: number) => {
                          if (
                            data.DocumentCategoryId ===
                            nomineeDocsIds.nomineeThree.guardianDetails.photo
                              .documentCategoryId
                          ) {
                            return (
                              <>
                                <p>Photo</p>
                                <DocumentBrowse
                                  id="guardianThirdPhotoId"
                                  previewImageexternalClassName={
                                    "maxSizewithAnother"
                                  }
                                  docObj={guardianThirdObj[0]}
                                  onDocUploadComplete={(
                                    val,
                                    fileName,
                                    id,
                                    type
                                  ) =>
                                    onNomineeUploadComplete(
                                      val,
                                      fileName,
                                      id,
                                      type,
                                      index
                                    )
                                  }
                                  isRemove={(removeDocObj) =>
                                    handleRemoveDoc(
                                      index,
                                      "guardianThirdPhotoId",
                                      removeDocObj
                                    )
                                  }
                                />
                                {nomineeGuardianError.guardianThirdPhotoId !=
                                  "" ? (
                                  <div>
                                    {" "}
                                    <br />
                                    <ErrMsg>
                                      <>
                                        <span>
                                          {
                                            nomineeGuardianError.guardianThirdPhotoId
                                          }
                                        </span>
                                      </>
                                    </ErrMsg>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {regectedDocStatus &&
                                  regectedDocStatus.map(function (item: any) {
                                    return (
                                      <div className="mrt20">
                                        {" "}
                                        {item.DocumentCategoryId ===
                                          nomineeDocsIds.nomineeThree
                                            .guardianDetails.photo
                                            .documentCategoryId && (
                                            <ErrMsg>
                                              <>
                                                <span>
                                                  Reason for Rejection:{" "}
                                                  {item?.RejectionReason}
                                                </span>
                                              </>
                                            </ErrMsg>
                                          )}
                                      </div>
                                    );
                                  })}
                              </>
                            );
                          } else if (
                            data.DocumentCategoryId ===
                            nomineeDocsIds.nomineeThree.guardianDetails
                              .signature.documentCategoryId
                          ) {
                            return (
                              <>
                                <p>Signature</p>
                                <DocumentBrowse
                                  id="guardianThirdSignature"
                                  previewImageexternalClassName={
                                    "maxSizewithAnother"
                                  }
                                  docObj={guardianThirdObj[1]}
                                  onDocUploadComplete={(
                                    val,
                                    fileName,
                                    id,
                                    type
                                  ) =>
                                    onNomineeUploadComplete(
                                      val,
                                      fileName,
                                      id,
                                      type,
                                      index
                                    )
                                  }
                                  isRemove={(removeDocObj) =>
                                    handleRemoveDoc(
                                      index,
                                      "guardianThirdSignature",
                                      removeDocObj
                                    )
                                  }
                                />

                                {nomineeGuardianError.guardianThirdSignature !=
                                  "" ? (
                                  <div>
                                    {" "}
                                    <br />
                                    <ErrMsg>
                                      <>
                                        <span>
                                          {
                                            nomineeGuardianError.guardianThirdSignature
                                          }
                                        </span>
                                      </>
                                    </ErrMsg>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {regectedDocStatus &&
                                  regectedDocStatus.map(function (item: any) {
                                    return (
                                      <div className="mrt20">
                                        {" "}
                                        {item.DocumentCategoryId ===
                                          nomineeDocsIds.nomineeThree
                                            .guardianDetails.signature
                                            .documentCategoryId && (
                                            <ErrMsg>
                                              <>
                                                <span>
                                                  Reason for Rejection:{" "}
                                                  {item?.RejectionReason}
                                                </span>
                                              </>
                                            </ErrMsg>
                                          )}
                                      </div>
                                    );
                                  })}
                              </>
                            );
                          }
                        })}
                      </div>
                      {/* <div className="togContainer mrt40">
                        <span className="isTogLabel">
                          Would share this document later via WhatsApp
                        </span>
                        <div className="togSize">
                          <Toggle
                            isOn={nomineeGuardianTog.guardianThird}
                            onChange={() => sendViaWatsapp("guardianThird")}
                          />
                        </div>
                      </div> */}
                      <div>
                        {nomineeGuardianTog.guardianThird && (
                          <div className="watsLayout">
                            <span className="shareDoc">
                              Share Documents on
                            </span>
                            <div className="watsNum">
                              <span className="watsapp">WhatsApp</span>
                              <span className="watsAppNum">
                                <span>
                                  <img
                                    className="watsappImg"
                                    src={watsAppIcon} alt="" aria-hidden="true" />
                                </span>
                                {watsappNo}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
                {/* GuardianThird End */}

                {/* {DeviceContext().isMobile && (togPAN || togFirstBank || togSecondBank || togThirdBank || togFourthBank || togFifthBank || togPermAdd || togCorrAdd || togSig || togIncome) && <div className="watsLayout">
                                    <span className="shareDoc">Share Documents on</span>
                                    <div className="watsNum">
                                        <span className="watsapp">WhatsApp</span>
                                        <span className="watsAppNum"><span><img className="watsappImg" src={watsAppIcon} alt="" aria-hidden="true" /></span>{watsappNo}</span>
                                    </div>
                                </div>} */}

                {/* Rejection Error Msg Start*/}
                {/* {
                                    regectedDocStatus && regectedDocStatus.map((item: any, index: number) => <div key={index} className='errMsgBlck errWidth mrt40'>
                                        <ErrMsg>
                                            <>
                                                <span>Reason for Rejection: {item.rejectionreason}</span>
                                            </>
                                        </ErrMsg>
                                    </div>)
                                } */}
                {/* Rejection Error Msg End*/}

                {/* Error Msg Start*/}
                {errCode && panButDisable == false && (
                  <div className="errMsgBlck errWidth mrt40">
                    <ErrMsg>
                      {typeof errCode === "number" ? (
                        <>
                          <span>We are facing some technical issue.</span>
                          <span>
                            Please try after sometime (error code:{errCode})
                          </span>
                        </>
                      ) : (
                        <span>{errCode}</span>
                      )}
                    </ErrMsg>
                  </div>
                )}
                {/* Error Msg End*/}

                {/* Photo Error Msg Start*/}
                {photoErrorMsg != "" && (
                  <div className="errMsgBlck errWidth mrt40">
                    <ErrMsg>
                      <span>{photoErrorMsg}</span>
                    </ErrMsg>
                  </div>
                )}
                {/* Photo Error Msg End*/}
                {GlobalStore?.stageStatus?.accountcategory == 2 && GlobalStore?.stageStatus?.rmassisted &&
                  <span className="photoNoteHeading">
                    I hereby confirm that I have personally met with the client and/or visited the client's place and have carried out the due diligence on the documents provided during the onboarding process
                  </span>
                }
                <div className="docSubBtn">
                  <SubmitButton
                    isLoading={loaderSign || isLoading}
                    btnName="Submit"
                    onClick={handleSubmit}
                    disabled={
                      (typeof errCode === "string" && errCode != "") ||
                      shouldDisable() ||
                      // signatureListError ||
                      checkFilledForm() ||
                      permAddButDisable ||
                      panButDisable ||
                      // || nomineeDisable ||
                      // guardianDisable
                      liveLocationCheck.checkPhotoLiveness
                      // ||
                      // liveLocationCheck.checkLocation
                    }
                  />
                </div>
              </div>
            </>
          ) : uploadVaiWatsAppFlag ? (
            <>
              <div className="watsLayout">
                <span className="shareDoc">Share Documents on</span>
                <div className="watsNum">
                  <span className="watsapp">WhatsApp</span>
                  <span className="watsAppNum">
                    <span>
                      <img className="watsappImg" src={watsAppIcon} alt="" aria-hidden="true" />
                    </span>
                    {watsappNo}
                  </span>
                </div>
              </div>
              <div className="uploadLayout mrt60">
                <Button
                  isLoading={loaderSign || isLoading}
                  btnName="Save and Proceed"
                  onClick={() => saveViaWatsApp()}
                />
              </div>
            </>
          ) : (
            <div
              className={DeviceContext().isMobile ? "mrt40" : "selectOption"}
            >
              <h2 className="heading">Document Upload</h2>
              <span className="uploadSubHeading">
                You need to upload your documents for verification. How would
                you like to share the required documents listed below?
              </span>
              <ul className="mrl-25 mrt20 list">
                {pendingDocObj &&
                  pendingDocObj.map((item: any, index: number) => {
                    return (
                      <li
                        key={index}
                        className={`${showGuideText(item) ? "text-family" : ""
                          }`}
                      >
                        {item.DocumentCategory}
                        {showGuideText(item) ? (
                          <button
                            type="button"
                            className="view-sample"
                            onClick={() => {
                              try {
                                const screen_name = getScreenName(window.location.pathname);
                                if (screen_name) {
                                  mixpanelService({
                                    event: mixpanelEvents.CTA_CLICKED,
                                    screen_name,
                                    text: "View Sample",
                                    cta_type: "sticky",
                                    cta_class: "secondary",
                                    cta_service: "AOJ",
                                  });
                                }
                              } catch (e) {
                                console.error("mixpanel cta_clicked failed", e);
                              }
                              setSamplePopupups(item);
                            }}
                          >
                            View Sample
                          </button>
                        ) : (
                          ""
                        )}
                      </li>
                    );
                  })}
              </ul>
              <div className="btnContainer mrt40">
                {/* <div className="borderBlue spaceBetweem">
                  <TransparentButton
                    btnName="Via WhatsApp"
                    onClick={() => uploadViaWatsApp()}
                    isWhatsapp={true}Nomi
                  />
                </div> */}
                <div className="borderBlue">
                  <TransparentButton
                    btnName="Upload Now"
                    onClick={() => uploadDoc()}
                    isUpload={true}
                  />
                </div>
              </div>
            </div>
          )}
        </fieldset>
      </div>
    </div>
  );
};

export default DocVerifcationFormJoint;
